/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ClientBase } from './client.base'
import { QuoteStatus } from './utils/QuoteStatus'
import { QuoteType } from './utils/QuoteType'
import { ReferralContactDTO } from './viewModels/ReferralContactDTO'
import { ScheduleDto } from './viewModels/ScheduleDto'
import { CMS1500Dto } from './viewModels/claim/Cms1500Dto'

export class Client extends ClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>
  }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    'ngInject'

    super()
    this.http = http ? http : <any>window
    this.baseUrl = baseUrl ? baseUrl : ''
  }

  /**
   * @return OK
   */
  getAppointmentTaskById(
    appointmentTaskId: string
  ): Promise<SwaggerResponse<AppointmentTaskDto>> {
    let url_ = this.baseUrl + '/api/appointmentTasks/{appointmentTaskId}'
    if (appointmentTaskId === undefined || appointmentTaskId === null)
      throw new Error("The parameter 'appointmentTaskId' must be defined.")
    url_ = url_.replace('{appointmentTaskId}', encodeURIComponent('' + appointmentTaskId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAppointmentTaskById(_response)
      )
    })
  }

  protected processGetAppointmentTaskById(
    response: Response
  ): Promise<SwaggerResponse<AppointmentTaskDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? AppointmentTaskDto.fromJS(resultData200)
          : new AppointmentTaskDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<AppointmentTaskDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedAppointmentTask (optional)
   * @return Success
   */
  updateAppointmentTask(
    appointmentTaskId: string,
    updatedAppointmentTask?: AppointmentTaskDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/appointmentTasks/{appointmentTaskId}'
    if (appointmentTaskId === undefined || appointmentTaskId === null)
      throw new Error("The parameter 'appointmentTaskId' must be defined.")
    url_ = url_.replace('{appointmentTaskId}', encodeURIComponent('' + appointmentTaskId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedAppointmentTask)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateAppointmentTask(_response)
      )
    })
  }

  protected processUpdateAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateAppointmentTask(appointmentTaskId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/appointmentTasks/{appointmentTaskId}'
    if (appointmentTaskId === undefined || appointmentTaskId === null)
      throw new Error("The parameter 'appointmentTaskId' must be defined.")
    url_ = url_.replace('{appointmentTaskId}', encodeURIComponent('' + appointmentTaskId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateAppointmentTask(_response)
      )
    })
  }

  protected processReactivateAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveAppointmentTask(appointmentTaskId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/appointmentTasks/{appointmentTaskId}'
    if (appointmentTaskId === undefined || appointmentTaskId === null)
      throw new Error("The parameter 'appointmentTaskId' must be defined.")
    url_ = url_.replace('{appointmentTaskId}', encodeURIComponent('' + appointmentTaskId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveAppointmentTask(_response)
      )
    })
  }

  protected processArchiveAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param organizationId (optional)
   * @param componentId (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllAppointmentTasks(
    organizationId?: string | null | undefined,
    componentId?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<AppointmentTaskDto[]>> {
    let url_ = this.baseUrl + '/api/appointmentTasks?'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (componentId !== undefined)
      url_ += 'componentId=' + encodeURIComponent('' + componentId) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllAppointmentTasks(_response)
      )
    })
  }

  protected processGetAllAppointmentTasks(
    response: Response
  ): Promise<SwaggerResponse<AppointmentTaskDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(AppointmentTaskDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<AppointmentTaskDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newAppointmentTask (optional)
   * @return Success
   */
  createAppointmentTask(
    newAppointmentTask?: AppointmentTaskDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/appointmentTasks'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newAppointmentTask)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateAppointmentTask(_response)
      )
    })
  }

  protected processCreateAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getAttachmentFileById(
    attachmentFileId: string
  ): Promise<SwaggerResponse<AttachmentFileDto>> {
    let url_ = this.baseUrl + '/api/attachmentFiles/{attachmentFileId}'
    if (attachmentFileId === undefined || attachmentFileId === null)
      throw new Error("The parameter 'attachmentFileId' must be defined.")
    url_ = url_.replace('{attachmentFileId}', encodeURIComponent('' + attachmentFileId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAttachmentFileById(_response)
      )
    })
  }

  protected processGetAttachmentFileById(
    response: Response
  ): Promise<SwaggerResponse<AttachmentFileDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? AttachmentFileDto.fromJS(resultData200)
          : new AttachmentFileDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<AttachmentFileDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedAttachmentFile (optional)
   * @return Success
   */
  updateAttachmentFile(
    attachmentFileId: string,
    updatedAttachmentFile?: AttachmentFileDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/attachmentFiles/{attachmentFileId}'
    if (attachmentFileId === undefined || attachmentFileId === null)
      throw new Error("The parameter 'attachmentFileId' must be defined.")
    url_ = url_.replace('{attachmentFileId}', encodeURIComponent('' + attachmentFileId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedAttachmentFile)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateAttachmentFile(_response)
      )
    })
  }

  protected processUpdateAttachmentFile(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  deleteAttachmentFile(attachmentFileId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/attachmentFiles/{attachmentFileId}'
    if (attachmentFileId === undefined || attachmentFileId === null)
      throw new Error("The parameter 'attachmentFileId' must be defined.")
    url_ = url_.replace('{attachmentFileId}', encodeURIComponent('' + attachmentFileId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processDeleteAttachmentFile(_response)
      )
    })
  }

  protected processDeleteAttachmentFile(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllAttachmentFiles(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<AttachmentFileDto[]>> {
    let url_ = this.baseUrl + '/api/attachmentFiles?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllAttachmentFiles(_response)
      )
    })
  }

  protected processGetAllAttachmentFiles(
    response: Response
  ): Promise<SwaggerResponse<AttachmentFileDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(AttachmentFileDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<AttachmentFileDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newAttachmentFile (optional)
   * @param folder (optional)
   * @return Success
   */
  createAttachmentFile(
    newAttachmentFile?: AttachmentFileDto | null | undefined,
    folder?: string | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/attachmentFiles?'
    if (folder !== undefined) url_ += 'folder=' + encodeURIComponent('' + folder) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newAttachmentFile)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateAttachmentFile(_response)
      )
    })
  }

  protected processCreateAttachmentFile(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiFilesByMimeFileByFullPathAndFilenameGet(
    mime: string,
    fullPathAndFilename: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/files/{mime}/file/{fullPathAndFilename}'
    if (mime === undefined || mime === null)
      throw new Error("The parameter 'mime' must be defined.")
    url_ = url_.replace('{mime}', encodeURIComponent('' + mime))
    if (fullPathAndFilename === undefined || fullPathAndFilename === null)
      throw new Error("The parameter 'fullPathAndFilename' must be defined.")
    url_ = url_.replace(
      '{fullPathAndFilename}',
      encodeURIComponent('' + fullPathAndFilename)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiFilesByMimeFileByFullPathAndFilenameGet(_response)
      )
    })
  }

  protected processApiFilesByMimeFileByFullPathAndFilenameGet(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getBodyPartById(bodyPartId: string): Promise<SwaggerResponse<BodyPartDto>> {
    let url_ = this.baseUrl + '/api/bodyParts/{bodyPartId}'
    if (bodyPartId === undefined || bodyPartId === null)
      throw new Error("The parameter 'bodyPartId' must be defined.")
    url_ = url_.replace('{bodyPartId}', encodeURIComponent('' + bodyPartId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetBodyPartById(_response)
      )
    })
  }

  protected processGetBodyPartById(
    response: Response
  ): Promise<SwaggerResponse<BodyPartDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? BodyPartDto.fromJS(resultData200) : new BodyPartDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<BodyPartDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedBodyPart (optional)
   * @return Success
   */
  updateBodyPart(
    bodyPartId: string,
    updatedBodyPart?: BodyPartDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/bodyParts/{bodyPartId}'
    if (bodyPartId === undefined || bodyPartId === null)
      throw new Error("The parameter 'bodyPartId' must be defined.")
    url_ = url_.replace('{bodyPartId}', encodeURIComponent('' + bodyPartId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedBodyPart)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateBodyPart(_response)
      )
    })
  }

  protected processUpdateBodyPart(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateBodyPart(bodyPartId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/bodyParts/{bodyPartId}'
    if (bodyPartId === undefined || bodyPartId === null)
      throw new Error("The parameter 'bodyPartId' must be defined.")
    url_ = url_.replace('{bodyPartId}', encodeURIComponent('' + bodyPartId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateBodyPart(_response)
      )
    })
  }

  protected processReactivateBodyPart(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveBodyPart(bodyPartId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/bodyParts/{bodyPartId}'
    if (bodyPartId === undefined || bodyPartId === null)
      throw new Error("The parameter 'bodyPartId' must be defined.")
    url_ = url_.replace('{bodyPartId}', encodeURIComponent('' + bodyPartId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveBodyPart(_response)
      )
    })
  }

  protected processArchiveBodyPart(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllBodyParts(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<BodyPartDto[]>> {
    let url_ = this.baseUrl + '/api/bodyParts?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllBodyParts(_response)
      )
    })
  }

  protected processGetAllBodyParts(
    response: Response
  ): Promise<SwaggerResponse<BodyPartDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(BodyPartDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<BodyPartDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newBodyPart (optional)
   * @return Success
   */
  createBodyPart(
    newBodyPart?: BodyPartDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/bodyParts'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newBodyPart)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateBodyPart(_response)
      )
    })
  }

  protected processCreateBodyPart(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getCheckById(checkId: string): Promise<SwaggerResponse<CheckDto>> {
    let url_ = this.baseUrl + '/api/checks/{checkId}'
    if (checkId === undefined || checkId === null)
      throw new Error("The parameter 'checkId' must be defined.")
    url_ = url_.replace('{checkId}', encodeURIComponent('' + checkId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetCheckById(_response)
      )
    })
  }

  protected processGetCheckById(response: Response): Promise<SwaggerResponse<CheckDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? CheckDto.fromJS(resultData200) : new CheckDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CheckDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedCheck (optional)
   * @return Success
   */
  updateCheck(
    checkId: string,
    updatedCheck?: CheckDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/checks/{checkId}'
    if (checkId === undefined || checkId === null)
      throw new Error("The parameter 'checkId' must be defined.")
    url_ = url_.replace('{checkId}', encodeURIComponent('' + checkId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedCheck)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateCheck(_response)
      )
    })
  }

  protected processUpdateCheck(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateCheck(checkId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/checks/{checkId}'
    if (checkId === undefined || checkId === null)
      throw new Error("The parameter 'checkId' must be defined.")
    url_ = url_.replace('{checkId}', encodeURIComponent('' + checkId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateCheck(_response)
      )
    })
  }

  protected processReactivateCheck(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveCheck(checkId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/checks/{checkId}'
    if (checkId === undefined || checkId === null)
      throw new Error("The parameter 'checkId' must be defined.")
    url_ = url_.replace('{checkId}', encodeURIComponent('' + checkId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveCheck(_response)
      )
    })
  }

  protected processArchiveCheck(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllChecks(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<CheckDto[]>> {
    let url_ = this.baseUrl + '/api/checks?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllChecks(_response)
      )
    })
  }

  protected processGetAllChecks(
    response: Response
  ): Promise<SwaggerResponse<CheckDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(CheckDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CheckDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newCheck (optional)
   * @return Success
   */
  createCheck(newCheck?: CheckDto | null | undefined): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/checks'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newCheck)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateCheck(_response)
      )
    })
  }

  protected processCreateCheck(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedCheck (optional)
   * @return Success
   */
  previewEOB(
    updatedCheck?: CheckDto | null | undefined
  ): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/checks/previewEOB'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedCheck)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processPreviewEOB(_response)
      )
    })
  }

  protected processPreviewEOB(response: Response): Promise<SwaggerResponse<string>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getCMS1500ById(cms1500Id: string): Promise<SwaggerResponse<CMS1500Dto>> {
    let url_ = this.baseUrl + '/api/cms1500/{cms1500Id}'
    if (cms1500Id === undefined || cms1500Id === null)
      throw new Error("The parameter 'cms1500Id' must be defined.")
    url_ = url_.replace('{cms1500Id}', encodeURIComponent('' + cms1500Id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetCMS1500ById(_response)
      )
    })
  }

  protected processGetCMS1500ById(
    response: Response
  ): Promise<SwaggerResponse<CMS1500Dto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? CMS1500Dto.fromJS(resultData200) : new CMS1500Dto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CMS1500Dto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedCMS1500 (optional)
   * @return Success
   */
  updateCMS1500(
    cms1500Id: string,
    updatedCMS1500?: CMS1500Dto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cms1500/{cms1500Id}'
    if (cms1500Id === undefined || cms1500Id === null)
      throw new Error("The parameter 'cms1500Id' must be defined.")
    url_ = url_.replace('{cms1500Id}', encodeURIComponent('' + cms1500Id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedCMS1500)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateCMS1500(_response)
      )
    })
  }

  protected processUpdateCMS1500(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateCMS1500(cms1500Id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cms1500/{cms1500Id}'
    if (cms1500Id === undefined || cms1500Id === null)
      throw new Error("The parameter 'cms1500Id' must be defined.")
    url_ = url_.replace('{cms1500Id}', encodeURIComponent('' + cms1500Id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateCMS1500(_response)
      )
    })
  }

  protected processReactivateCMS1500(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveCMS1500(cms1500Id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cms1500/{cms1500Id}'
    if (cms1500Id === undefined || cms1500Id === null)
      throw new Error("The parameter 'cms1500Id' must be defined.")
    url_ = url_.replace('{cms1500Id}', encodeURIComponent('' + cms1500Id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveCMS1500(_response)
      )
    })
  }

  protected processArchiveCMS1500(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param currentBill (optional)
   * @return OK
   */
  checkDuplicateBill(
    currentBill?: CMS1500Dto | null | undefined
  ): Promise<SwaggerResponse<CMS1500Dto>> {
    let url_ = this.baseUrl + '/api/cms1500/duplicateCheck'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(currentBill)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCheckDuplicateBill(_response)
      )
    })
  }

  protected processCheckDuplicateBill(
    response: Response
  ): Promise<SwaggerResponse<CMS1500Dto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? CMS1500Dto.fromJS(resultData200) : new CMS1500Dto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CMS1500Dto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param organizationId (optional)
   * @param providerId (optional)
   * @param episodeOfCareId (optional)
   * @param billStatus (optional)
   * @param type (optional)
   * @param showBilledOut (optional)
   * @param showPaid (optional)
   * @param isOutgoing (optional)
   * @param showNegativeBalanceBills (optional)
   * @param showZeroBalanceBills (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllCMS1500(
    filter?: string | null | undefined,
    organizationId?: string | null | undefined,
    providerId?: string | null | undefined,
    episodeOfCareId?: string | null | undefined,
    billStatus?: string | null | undefined,
    type?: number | null | undefined,
    showBilledOut?: boolean | null | undefined,
    showPaid?: boolean | null | undefined,
    isOutgoing?: boolean | null | undefined,
    showNegativeBalanceBills?: boolean | null | undefined,
    showZeroBalanceBills?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<CMS1500Dto[]>> {
    let url_ = this.baseUrl + '/api/cms1500?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    if (episodeOfCareId !== undefined)
      url_ += 'episodeOfCareId=' + encodeURIComponent('' + episodeOfCareId) + '&'
    if (billStatus !== undefined)
      url_ += 'billStatus=' + encodeURIComponent('' + billStatus) + '&'
    if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&'
    if (showBilledOut !== undefined)
      url_ += 'showBilledOut=' + encodeURIComponent('' + showBilledOut) + '&'
    if (showPaid !== undefined)
      url_ += 'showPaid=' + encodeURIComponent('' + showPaid) + '&'
    if (isOutgoing !== undefined)
      url_ += 'isOutgoing=' + encodeURIComponent('' + isOutgoing) + '&'
    if (showNegativeBalanceBills !== undefined)
      url_ +=
        'showNegativeBalanceBills=' +
        encodeURIComponent('' + showNegativeBalanceBills) +
        '&'
    if (showZeroBalanceBills !== undefined)
      url_ +=
        'showZeroBalanceBills=' + encodeURIComponent('' + showZeroBalanceBills) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllCMS1500(_response)
      )
    })
  }

  protected processGetAllCMS1500(
    response: Response
  ): Promise<SwaggerResponse<CMS1500Dto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(CMS1500Dto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CMS1500Dto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newCMS1500 (optional)
   * @return Success
   */
  createCMS1500(
    newCMS1500?: CMS1500Dto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cms1500'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newCMS1500)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateCMS1500(_response)
      )
    })
  }

  protected processCreateCMS1500(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param cms1500 (optional)
   * @return Success
   */
  createOutgoingCMS1500(
    cms1500Id: string,
    cms1500?: CMS1500Dto | null | undefined
  ): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/cms1500/outgoing/{cms1500Id}'
    if (cms1500Id === undefined || cms1500Id === null)
      throw new Error("The parameter 'cms1500Id' must be defined.")
    url_ = url_.replace('{cms1500Id}', encodeURIComponent('' + cms1500Id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(cms1500)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateOutgoingCMS1500(_response)
      )
    })
  }

  protected processCreateOutgoingCMS1500(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param status (optional)
   * @return Success
   */
  updateCMS1500status(
    cms1500Id: string,
    status?: string | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cms1500/{cms1500Id}/status'
    if (cms1500Id === undefined || cms1500Id === null)
      throw new Error("The parameter 'cms1500Id' must be defined.")
    url_ = url_.replace('{cms1500Id}', encodeURIComponent('' + cms1500Id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(status)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateCMS1500status(_response)
      )
    })
  }

  protected processUpdateCMS1500status(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param subType (optional)
   * @return Success
   */
  apiColumnSettingsByUserIdByTypeGet(
    userId: string,
    type: string,
    subType?: string | null | undefined
  ): Promise<SwaggerResponse<ColumnSettingsDto[]>> {
    let url_ = this.baseUrl + '/api/ColumnSettings/{userId}/{type}?'
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.")
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId))
    if (type === undefined || type === null)
      throw new Error("The parameter 'type' must be defined.")
    url_ = url_.replace('{type}', encodeURIComponent('' + type))
    if (subType !== undefined) url_ += 'subType=' + encodeURIComponent('' + subType) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiColumnSettingsByUserIdByTypeGet(_response)
      )
    })
  }

  protected processApiColumnSettingsByUserIdByTypeGet(
    response: Response
  ): Promise<SwaggerResponse<ColumnSettingsDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ColumnSettingsDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ColumnSettingsDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveCommunication(communicationId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/communication/{communicationId}'
    if (communicationId === undefined || communicationId === null)
      throw new Error("The parameter 'communicationId' must be defined.")
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveCommunication(_response)
      )
    })
  }

  protected processArchiveCommunication(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getCommunicationById(
    communicationId: string
  ): Promise<SwaggerResponse<CommunicationDto>> {
    let url_ = this.baseUrl + '/api/communications/{communicationId}'
    if (communicationId === undefined || communicationId === null)
      throw new Error("The parameter 'communicationId' must be defined.")
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetCommunicationById(_response)
      )
    })
  }

  protected processGetCommunicationById(
    response: Response
  ): Promise<SwaggerResponse<CommunicationDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? CommunicationDto.fromJS(resultData200)
          : new CommunicationDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CommunicationDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedCommunication (optional)
   * @return Success
   */
  updateCommunication(
    communicationId: string,
    updatedCommunication?: CommunicationDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/communications/{communicationId}'
    if (communicationId === undefined || communicationId === null)
      throw new Error("The parameter 'communicationId' must be defined.")
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedCommunication)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateCommunication(_response)
      )
    })
  }

  protected processUpdateCommunication(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateCommunication(communicationId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/communications/{communicationId}'
    if (communicationId === undefined || communicationId === null)
      throw new Error("The parameter 'communicationId' must be defined.")
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateCommunication(_response)
      )
    })
  }

  protected processReactivateCommunication(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param patientId (optional)
   * @param providerId (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param startDOS (optional)
   * @param endDOS (optional)
   * @param type (optional)
   * @param tags (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllCommunications(
    patientId?: string | null | undefined,
    providerId?: string | null | undefined,
    startDate?: Date | null | undefined,
    endDate?: Date | null | undefined,
    startDOS?: Date | null | undefined,
    endDOS?: Date | null | undefined,
    type?: string | null | undefined,
    tags?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<CommunicationDto[]>> {
    let url_ = this.baseUrl + '/api/communications?'
    if (patientId !== undefined)
      url_ += 'patientId=' + encodeURIComponent('' + patientId) + '&'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    if (startDate !== undefined)
      url_ +=
        'startDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&'
    if (endDate !== undefined)
      url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&'
    if (startDOS !== undefined)
      url_ +=
        'startDOS=' + encodeURIComponent(startDOS ? '' + startDOS.toJSON() : '') + '&'
    if (endDOS !== undefined)
      url_ += 'endDOS=' + encodeURIComponent(endDOS ? '' + endDOS.toJSON() : '') + '&'
    if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&'
    if (tags !== undefined) url_ += 'tags=' + encodeURIComponent('' + tags) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllCommunications(_response)
      )
    })
  }

  protected processGetAllCommunications(
    response: Response
  ): Promise<SwaggerResponse<CommunicationDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(CommunicationDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CommunicationDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newCommunication (optional)
   * @return Success
   */
  createCommunication(
    newCommunication?: CommunicationDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/communications'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newCommunication)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateCommunication(_response)
      )
    })
  }

  protected processCreateCommunication(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getComponentById(componentId: string): Promise<SwaggerResponse<ComponentDto>> {
    let url_ = this.baseUrl + '/api/components/{componentId}'
    if (componentId === undefined || componentId === null)
      throw new Error("The parameter 'componentId' must be defined.")
    url_ = url_.replace('{componentId}', encodeURIComponent('' + componentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetComponentById(_response)
      )
    })
  }

  protected processGetComponentById(
    response: Response
  ): Promise<SwaggerResponse<ComponentDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? ComponentDto.fromJS(resultData200)
          : new ComponentDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ComponentDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedComponent (optional)
   * @return Success
   */
  updateComponent(
    componentId: string,
    updatedComponent?: ComponentDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/components/{componentId}'
    if (componentId === undefined || componentId === null)
      throw new Error("The parameter 'componentId' must be defined.")
    url_ = url_.replace('{componentId}', encodeURIComponent('' + componentId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedComponent)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateComponent(_response)
      )
    })
  }

  protected processUpdateComponent(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateComponent(componentId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/components/{componentId}'
    if (componentId === undefined || componentId === null)
      throw new Error("The parameter 'componentId' must be defined.")
    url_ = url_.replace('{componentId}', encodeURIComponent('' + componentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateComponent(_response)
      )
    })
  }

  protected processReactivateComponent(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveComponent(componentId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/components/{componentId}'
    if (componentId === undefined || componentId === null)
      throw new Error("The parameter 'componentId' must be defined.")
    url_ = url_.replace('{componentId}', encodeURIComponent('' + componentId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveComponent(_response)
      )
    })
  }

  protected processArchiveComponent(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllComponents(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ComponentDto[]>> {
    let url_ = this.baseUrl + '/api/components?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllComponents(_response)
      )
    })
  }

  protected processGetAllComponents(
    response: Response
  ): Promise<SwaggerResponse<ComponentDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ComponentDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ComponentDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newComponent (optional)
   * @return Success
   */
  createComponent(
    newComponent?: ComponentDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/components'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newComponent)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateComponent(_response)
      )
    })
  }

  protected processCreateComponent(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getContactById(contactId: string): Promise<SwaggerResponse<ContactDto>> {
    let url_ = this.baseUrl + '/api/contacts/{contactId}'
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.")
    url_ = url_.replace('{contactId}', encodeURIComponent('' + contactId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetContactById(_response)
      )
    })
  }

  protected processGetContactById(
    response: Response
  ): Promise<SwaggerResponse<ContactDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? ContactDto.fromJS(resultData200) : new ContactDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContactDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedContact (optional)
   * @return Success
   */
  updateContact(
    contactId: string,
    updatedContact?: ContactDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contacts/{contactId}'
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.")
    url_ = url_.replace('{contactId}', encodeURIComponent('' + contactId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedContact)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateContact(_response)
      )
    })
  }

  protected processUpdateContact(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateContact(contactId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contacts/{contactId}'
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.")
    url_ = url_.replace('{contactId}', encodeURIComponent('' + contactId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateContact(_response)
      )
    })
  }

  protected processReactivateContact(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveContact(contactId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contacts/{contactId}'
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.")
    url_ = url_.replace('{contactId}', encodeURIComponent('' + contactId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveContact(_response)
      )
    })
  }

  protected processArchiveContact(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param providerId (optional)
   * @param insuranceCompanyId (optional)
   * @param referringDoctorId (optional)
   * @param nurseCaseManagerId (optional)
   * @param employerId (optional)
   * @param contactType (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllContacts(
    providerId?: string | null | undefined,
    insuranceCompanyId?: string | null | undefined,
    referringDoctorId?: string | null | undefined,
    nurseCaseManagerId?: string | null | undefined,
    employerId?: string | null | undefined,
    contactType?: number | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ContactDto[]>> {
    let url_ = this.baseUrl + '/api/contacts?'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    if (insuranceCompanyId !== undefined)
      url_ += 'insuranceCompanyId=' + encodeURIComponent('' + insuranceCompanyId) + '&'
    if (referringDoctorId !== undefined)
      url_ += 'referringDoctorId=' + encodeURIComponent('' + referringDoctorId) + '&'
    if (nurseCaseManagerId !== undefined)
      url_ += 'nurseCaseManagerId=' + encodeURIComponent('' + nurseCaseManagerId) + '&'
    if (employerId !== undefined)
      url_ += 'employerId=' + encodeURIComponent('' + employerId) + '&'
    if (contactType !== undefined)
      url_ += 'contactType=' + encodeURIComponent('' + contactType) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllContacts(_response)
      )
    })
  }

  protected processGetAllContacts(
    response: Response
  ): Promise<SwaggerResponse<ContactDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ContactDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContactDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newContact (optional)
   * @return Success
   */
  createContact(
    newContact?: ContactDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contacts'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newContact)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateContact(_response)
      )
    })
  }

  protected processCreateContact(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param providerId (optional)
   * @return OK
   */
  getImportantContacts(
    providerId?: string | null | undefined
  ): Promise<SwaggerResponse<ContactDto[]>> {
    let url_ = this.baseUrl + '/api/contacts/important?'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetImportantContacts(_response)
      )
    })
  }

  protected processGetImportantContacts(
    response: Response
  ): Promise<SwaggerResponse<ContactDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ContactDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContactDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getContactTypeById(contactTypeId: string): Promise<SwaggerResponse<ContactTypeDto>> {
    let url_ = this.baseUrl + '/api/contactTypes/{contactTypeId}'
    if (contactTypeId === undefined || contactTypeId === null)
      throw new Error("The parameter 'contactTypeId' must be defined.")
    url_ = url_.replace('{contactTypeId}', encodeURIComponent('' + contactTypeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetContactTypeById(_response)
      )
    })
  }

  protected processGetContactTypeById(
    response: Response
  ): Promise<SwaggerResponse<ContactTypeDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? ContactTypeDto.fromJS(resultData200)
          : new ContactTypeDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContactTypeDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedContactType (optional)
   * @return Success
   */
  updateContactType(
    contactTypeId: string,
    updatedContactType?: ContactTypeDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contactTypes/{contactTypeId}'
    if (contactTypeId === undefined || contactTypeId === null)
      throw new Error("The parameter 'contactTypeId' must be defined.")
    url_ = url_.replace('{contactTypeId}', encodeURIComponent('' + contactTypeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedContactType)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateContactType(_response)
      )
    })
  }

  protected processUpdateContactType(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateContactType(contactTypeId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contactTypes/{contactTypeId}'
    if (contactTypeId === undefined || contactTypeId === null)
      throw new Error("The parameter 'contactTypeId' must be defined.")
    url_ = url_.replace('{contactTypeId}', encodeURIComponent('' + contactTypeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateContactType(_response)
      )
    })
  }

  protected processReactivateContactType(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveContactType(contactTypeId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contactTypes/{contactTypeId}'
    if (contactTypeId === undefined || contactTypeId === null)
      throw new Error("The parameter 'contactTypeId' must be defined.")
    url_ = url_.replace('{contactTypeId}', encodeURIComponent('' + contactTypeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveContactType(_response)
      )
    })
  }

  protected processArchiveContactType(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllContactTypes(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ContactTypeDto[]>> {
    let url_ = this.baseUrl + '/api/contactType?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllContactTypes(_response)
      )
    })
  }

  protected processGetAllContactTypes(
    response: Response
  ): Promise<SwaggerResponse<ContactTypeDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ContactTypeDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContactTypeDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newContactType (optional)
   * @return Success
   */
  createContactType(
    newContactType?: ContactTypeDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/contactType'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newContactType)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateContactType(_response)
      )
    })
  }

  protected processCreateContactType(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getContractById(
    providerId: string,
    contractId: string
  ): Promise<SwaggerResponse<ContractDto>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/contracts/{contractId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.")
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetContractById(_response)
      )
    })
  }

  protected processGetContractById(
    response: Response
  ): Promise<SwaggerResponse<ContractDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? ContractDto.fromJS(resultData200) : new ContractDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContractDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedContract (optional)
   * @return Success
   */
  updateContract(
    providerId: string,
    contractId: string,
    updatedContract?: ContractDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/contracts/{contractId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.")
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedContract)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateContract(_response)
      )
    })
  }

  protected processUpdateContract(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateContract(
    providerId: string,
    contractId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/contracts/{contractId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.")
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateContract(_response)
      )
    })
  }

  protected processReactivateContract(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveContract(
    providerId: string,
    contractId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/contracts/{contractId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.")
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveContract(_response)
      )
    })
  }

  protected processArchiveContract(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param singleCaseAgreementsOnly (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllContracts(
    providerId: string,
    filter?: string | null | undefined,
    singleCaseAgreementsOnly?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ContractDto[]>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/contracts?'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (singleCaseAgreementsOnly !== undefined)
      url_ +=
        'singleCaseAgreementsOnly=' +
        encodeURIComponent('' + singleCaseAgreementsOnly) +
        '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllContracts(_response)
      )
    })
  }

  protected processGetAllContracts(
    response: Response
  ): Promise<SwaggerResponse<ContractDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ContractDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ContractDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newContract (optional)
   * @return Success
   */
  createContract(
    providerId: string,
    newContract?: ContractDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/contracts'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newContract)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateContract(_response)
      )
    })
  }

  protected processCreateContract(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getCptCodeById(cptCodeId: string): Promise<SwaggerResponse<CptCodeDto>> {
    let url_ = this.baseUrl + '/api/cptCodes/{cptCodeId}'
    if (cptCodeId === undefined || cptCodeId === null)
      throw new Error("The parameter 'cptCodeId' must be defined.")
    url_ = url_.replace('{cptCodeId}', encodeURIComponent('' + cptCodeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetCptCodeById(_response)
      )
    })
  }

  protected processGetCptCodeById(
    response: Response
  ): Promise<SwaggerResponse<CptCodeDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? CptCodeDto.fromJS(resultData200) : new CptCodeDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CptCodeDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedCptCode (optional)
   * @return Success
   */
  updateCptCode(
    cptCodeId: string,
    updatedCptCode?: CptCodeDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cptCodes/{cptCodeId}'
    if (cptCodeId === undefined || cptCodeId === null)
      throw new Error("The parameter 'cptCodeId' must be defined.")
    url_ = url_.replace('{cptCodeId}', encodeURIComponent('' + cptCodeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedCptCode)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateCptCode(_response)
      )
    })
  }

  protected processUpdateCptCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateCptCode(cptCodeId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cptCodes/{cptCodeId}'
    if (cptCodeId === undefined || cptCodeId === null)
      throw new Error("The parameter 'cptCodeId' must be defined.")
    url_ = url_.replace('{cptCodeId}', encodeURIComponent('' + cptCodeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateCptCode(_response)
      )
    })
  }

  protected processReactivateCptCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveCptCode(cptCodeId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cptCodes/{cptCodeId}'
    if (cptCodeId === undefined || cptCodeId === null)
      throw new Error("The parameter 'cptCodeId' must be defined.")
    url_ = url_.replace('{cptCodeId}', encodeURIComponent('' + cptCodeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveCptCode(_response)
      )
    })
  }

  protected processArchiveCptCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param cptCodeList (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllCptCodes(
    cptCodeList?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<CptCodeDto[]>> {
    let url_ = this.baseUrl + '/api/cptCodes?'
    if (cptCodeList !== undefined)
      url_ += 'cptCodeList=' + encodeURIComponent('' + cptCodeList) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllCptCodes(_response)
      )
    })
  }

  protected processGetAllCptCodes(
    response: Response
  ): Promise<SwaggerResponse<CptCodeDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(CptCodeDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CptCodeDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newCptCode (optional)
   * @return Success
   */
  createCptCode(
    newCptCode?: CptCodeDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/cptCodes'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newCptCode)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateCptCode(_response)
      )
    })
  }

  protected processCreateCptCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getDxCodeById(dxCodeId: string): Promise<SwaggerResponse<DxCodeDto>> {
    let url_ = this.baseUrl + '/api/dxCodes/{dxCodeId}'
    if (dxCodeId === undefined || dxCodeId === null)
      throw new Error("The parameter 'dxCodeId' must be defined.")
    url_ = url_.replace('{dxCodeId}', encodeURIComponent('' + dxCodeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetDxCodeById(_response)
      )
    })
  }

  protected processGetDxCodeById(
    response: Response
  ): Promise<SwaggerResponse<DxCodeDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? DxCodeDto.fromJS(resultData200) : new DxCodeDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<DxCodeDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedDxCode (optional)
   * @return Success
   */
  updateDxCode(
    dxCodeId: string,
    updatedDxCode?: DxCodeDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/dxCodes/{dxCodeId}'
    if (dxCodeId === undefined || dxCodeId === null)
      throw new Error("The parameter 'dxCodeId' must be defined.")
    url_ = url_.replace('{dxCodeId}', encodeURIComponent('' + dxCodeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedDxCode)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateDxCode(_response)
      )
    })
  }

  protected processUpdateDxCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateDxCode(dxCodeId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/dxCodes/{dxCodeId}'
    if (dxCodeId === undefined || dxCodeId === null)
      throw new Error("The parameter 'dxCodeId' must be defined.")
    url_ = url_.replace('{dxCodeId}', encodeURIComponent('' + dxCodeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateDxCode(_response)
      )
    })
  }

  protected processReactivateDxCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveDxCode(dxCodeId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/dxCodes/{dxCodeId}'
    if (dxCodeId === undefined || dxCodeId === null)
      throw new Error("The parameter 'dxCodeId' must be defined.")
    url_ = url_.replace('{dxCodeId}', encodeURIComponent('' + dxCodeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveDxCode(_response)
      )
    })
  }

  protected processArchiveDxCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param dxCodeList (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllDxCodes(
    dxCodeList?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<DxCodeDto[]>> {
    let url_ = this.baseUrl + '/api/dxCodes?'
    if (dxCodeList !== undefined)
      url_ += 'dxCodeList=' + encodeURIComponent('' + dxCodeList) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllDxCodes(_response)
      )
    })
  }

  protected processGetAllDxCodes(
    response: Response
  ): Promise<SwaggerResponse<DxCodeDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(DxCodeDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<DxCodeDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newDxCode (optional)
   * @return Success
   */
  createDxCode(newDxCode?: DxCodeDto | null | undefined): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/dxCodes'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newDxCode)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateDxCode(_response)
      )
    })
  }

  protected processCreateDxCode(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getEmployerById(employerId: string): Promise<SwaggerResponse<EmployerDto>> {
    let url_ = this.baseUrl + '/api/employers/{employerId}'
    if (employerId === undefined || employerId === null)
      throw new Error("The parameter 'employerId' must be defined.")
    url_ = url_.replace('{employerId}', encodeURIComponent('' + employerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetEmployerById(_response)
      )
    })
  }

  protected processGetEmployerById(
    response: Response
  ): Promise<SwaggerResponse<EmployerDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? EmployerDto.fromJS(resultData200) : new EmployerDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<EmployerDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedEmployer (optional)
   * @return Success
   */
  updateEmployer(
    employerId: string,
    updatedEmployer?: EmployerDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/employers/{employerId}'
    if (employerId === undefined || employerId === null)
      throw new Error("The parameter 'employerId' must be defined.")
    url_ = url_.replace('{employerId}', encodeURIComponent('' + employerId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedEmployer)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateEmployer(_response)
      )
    })
  }

  protected processUpdateEmployer(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateEmployer(employerId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/employers/{employerId}'
    if (employerId === undefined || employerId === null)
      throw new Error("The parameter 'employerId' must be defined.")
    url_ = url_.replace('{employerId}', encodeURIComponent('' + employerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateEmployer(_response)
      )
    })
  }

  protected processReactivateEmployer(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveEmployer(employerId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/employers/{employerId}'
    if (employerId === undefined || employerId === null)
      throw new Error("The parameter 'employerId' must be defined.")
    url_ = url_.replace('{employerId}', encodeURIComponent('' + employerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveEmployer(_response)
      )
    })
  }

  protected processArchiveEmployer(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllEmployers(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<EmployerDto[]>> {
    let url_ = this.baseUrl + '/api/employers?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllEmployers(_response)
      )
    })
  }

  protected processGetAllEmployers(
    response: Response
  ): Promise<SwaggerResponse<EmployerDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(EmployerDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<EmployerDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newEmployer (optional)
   * @return Success
   */
  createEmployer(
    newEmployer?: EmployerDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/employers'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newEmployer)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateEmployer(_response)
      )
    })
  }

  protected processCreateEmployer(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getEpisodeOfCareById(
    episodeOfCareId: string
  ): Promise<SwaggerResponse<EpisodeOfCareDto>> {
    let url_ = this.baseUrl + '/api/EpisodesOfCare/{episodeOfCareId}'
    if (episodeOfCareId === undefined || episodeOfCareId === null)
      throw new Error("The parameter 'episodeOfCareId' must be defined.")
    url_ = url_.replace('{episodeOfCareId}', encodeURIComponent('' + episodeOfCareId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetEpisodeOfCareById(_response)
      )
    })
  }

  protected processGetEpisodeOfCareById(
    response: Response
  ): Promise<SwaggerResponse<EpisodeOfCareDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? EpisodeOfCareDto.fromJS(resultData200)
          : new EpisodeOfCareDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<EpisodeOfCareDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedEpisodeOfCare (optional)
   * @return Success
   */
  updateEpisodeOfCare(
    episodeOfCareId: string,
    updatedEpisodeOfCare?: EpisodeOfCareDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/EpisodesOfCare/{episodeOfCareId}'
    if (episodeOfCareId === undefined || episodeOfCareId === null)
      throw new Error("The parameter 'episodeOfCareId' must be defined.")
    url_ = url_.replace('{episodeOfCareId}', encodeURIComponent('' + episodeOfCareId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedEpisodeOfCare)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateEpisodeOfCare(_response)
      )
    })
  }

  protected processUpdateEpisodeOfCare(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateEpisodeOfCare(episodeOfCareId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/EpisodesOfCare/{episodeOfCareId}'
    if (episodeOfCareId === undefined || episodeOfCareId === null)
      throw new Error("The parameter 'episodeOfCareId' must be defined.")
    url_ = url_.replace('{episodeOfCareId}', encodeURIComponent('' + episodeOfCareId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateEpisodeOfCare(_response)
      )
    })
  }

  protected processReactivateEpisodeOfCare(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveEpisodeOfCare(episodeOfCareId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/EpisodesOfCare/{episodeOfCareId}'
    if (episodeOfCareId === undefined || episodeOfCareId === null)
      throw new Error("The parameter 'episodeOfCareId' must be defined.")
    url_ = url_.replace('{episodeOfCareId}', encodeURIComponent('' + episodeOfCareId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveEpisodeOfCare(_response)
      )
    })
  }

  protected processArchiveEpisodeOfCare(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newEpisodeOfCare (optional)
   * @return Success
   */
  createEpisodeOfCare(
    referralId: string,
    newEpisodeOfCare?: EpisodeOfCareDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/referrals/{referralId}/EpisodesOfCare'
    if (referralId === undefined || referralId === null)
      throw new Error("The parameter 'referralId' must be defined.")
    url_ = url_.replace('{referralId}', encodeURIComponent('' + referralId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newEpisodeOfCare)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateEpisodeOfCare(_response)
      )
    })
  }

  protected processCreateEpisodeOfCare(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param organizationId (optional)
   * @param referralId (optional)
   * @param patientId (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllEpisodesOfCare(
    organizationId?: string | null | undefined,
    referralId?: string | null | undefined,
    patientId?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<EpisodeOfCareDto[]>> {
    let url_ = this.baseUrl + '/api/EpisodesOfCare?'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (referralId !== undefined)
      url_ += 'referralId=' + encodeURIComponent('' + referralId) + '&'
    if (patientId !== undefined)
      url_ += 'patientId=' + encodeURIComponent('' + patientId) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllEpisodesOfCare(_response)
      )
    })
  }

  protected processGetAllEpisodesOfCare(
    response: Response
  ): Promise<SwaggerResponse<EpisodeOfCareDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(EpisodeOfCareDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<EpisodeOfCareDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param careCoordinatorId (optional)
   * @return OK
   */
  ordersNotReceivedCount(
    careCoordinatorId?: string | null | undefined
  ): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/ordersNotReceivedCount?'
    if (careCoordinatorId !== undefined)
      url_ += 'careCoordinatorId=' + encodeURIComponent('' + careCoordinatorId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processOrdersNotReceivedCount(_response)
      )
    })
  }

  protected processOrdersNotReceivedCount(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param careCoordinatorId (optional)
   * @return OK
   */
  referralsNotScheduledCount(
    careCoordinatorId?: string | null | undefined
  ): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/referralsNotScheduledCount?'
    if (careCoordinatorId !== undefined)
      url_ += 'careCoordinatorId=' + encodeURIComponent('' + careCoordinatorId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReferralsNotScheduledCount(_response)
      )
    })
  }

  protected processReferralsNotScheduledCount(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param careCoordinatorId (optional)
   * @return OK
   */
  scaSentNotReceivedCount(
    careCoordinatorId?: string | null | undefined
  ): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/scaSentNotReceivedCount?'
    if (careCoordinatorId !== undefined)
      url_ += 'careCoordinatorId=' + encodeURIComponent('' + careCoordinatorId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processScaSentNotReceivedCount(_response)
      )
    })
  }

  protected processScaSentNotReceivedCount(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param careCoordinatorId (optional)
   * @return OK
   */
  testScheduledResultsNotReceivedCount(
    careCoordinatorId?: string | null | undefined
  ): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/testScheduledResultsNotReceivedCount?'
    if (careCoordinatorId !== undefined)
      url_ += 'careCoordinatorId=' + encodeURIComponent('' + careCoordinatorId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processTestScheduledResultsNotReceivedCount(_response)
      )
    })
  }

  protected processTestScheduledResultsNotReceivedCount(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiImagesByMimeFileByFullPathAndFilenameGet(
    mime: string,
    fullPathAndFilename: string
  ): Promise<SwaggerResponse<File>> {
    let url_ = this.baseUrl + '/api/Images/{mime}/file/{fullPathAndFilename}'
    if (mime === undefined || mime === null)
      throw new Error("The parameter 'mime' must be defined.")
    url_ = url_.replace('{mime}', encodeURIComponent('' + mime))
    if (fullPathAndFilename === undefined || fullPathAndFilename === null)
      throw new Error("The parameter 'fullPathAndFilename' must be defined.")
    url_ = url_.replace(
      '{fullPathAndFilename}',
      encodeURIComponent('' + fullPathAndFilename)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiImagesByMimeFileByFullPathAndFilenameGet(_response)
      )
    })
  }

  protected processApiImagesByMimeFileByFullPathAndFilenameGet(
    response: Response
  ): Promise<SwaggerResponse<File>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? File.fromJS(resultData200) : new File()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<File>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllInsuranceCompanies(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<InsuranceCompanyDto[]>> {
    let url_ = this.baseUrl + '/api/insuranceCompanies?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllInsuranceCompanies(_response)
      )
    })
  }

  protected processGetAllInsuranceCompanies(
    response: Response
  ): Promise<SwaggerResponse<InsuranceCompanyDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(InsuranceCompanyDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<InsuranceCompanyDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newInsuranceCompany (optional)
   * @return Success
   */
  createInsuranceCompany(
    newInsuranceCompany?: InsuranceCompanyDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/insuranceCompanies'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newInsuranceCompany)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateInsuranceCompany(_response)
      )
    })
  }

  protected processCreateInsuranceCompany(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getInsuranceCompanyById(
    insuranceCompanyId: string
  ): Promise<SwaggerResponse<InsuranceCompanyDto>> {
    let url_ = this.baseUrl + '/api/insuranceCompanies/{insuranceCompanyId}'
    if (insuranceCompanyId === undefined || insuranceCompanyId === null)
      throw new Error("The parameter 'insuranceCompanyId' must be defined.")
    url_ = url_.replace(
      '{insuranceCompanyId}',
      encodeURIComponent('' + insuranceCompanyId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetInsuranceCompanyById(_response)
      )
    })
  }

  protected processGetInsuranceCompanyById(
    response: Response
  ): Promise<SwaggerResponse<InsuranceCompanyDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? InsuranceCompanyDto.fromJS(resultData200)
          : new InsuranceCompanyDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<InsuranceCompanyDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedInsuranceCompany (optional)
   * @return Success
   */
  updateInsuranceCompany(
    insuranceCompanyId: string,
    updatedInsuranceCompany?: InsuranceCompanyDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/insuranceCompanies/{insuranceCompanyId}'
    if (insuranceCompanyId === undefined || insuranceCompanyId === null)
      throw new Error("The parameter 'insuranceCompanyId' must be defined.")
    url_ = url_.replace(
      '{insuranceCompanyId}',
      encodeURIComponent('' + insuranceCompanyId)
    )
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedInsuranceCompany)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateInsuranceCompany(_response)
      )
    })
  }

  protected processUpdateInsuranceCompany(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateInsuranceCompany(insuranceCompanyId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/insuranceCompanies/{insuranceCompanyId}'
    if (insuranceCompanyId === undefined || insuranceCompanyId === null)
      throw new Error("The parameter 'insuranceCompanyId' must be defined.")
    url_ = url_.replace(
      '{insuranceCompanyId}',
      encodeURIComponent('' + insuranceCompanyId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateInsuranceCompany(_response)
      )
    })
  }

  protected processReactivateInsuranceCompany(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveInsuranceCompany(insuranceCompanyId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/insuranceCompanies/{insuranceCompanyId}'
    if (insuranceCompanyId === undefined || insuranceCompanyId === null)
      throw new Error("The parameter 'insuranceCompanyId' must be defined.")
    url_ = url_.replace(
      '{insuranceCompanyId}',
      encodeURIComponent('' + insuranceCompanyId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveInsuranceCompany(_response)
      )
    })
  }

  protected processArchiveInsuranceCompany(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getLocationBillingById(
    locationBillingId: string
  ): Promise<SwaggerResponse<LocationBillingDto>> {
    let url_ = this.baseUrl + '/api/locationBillings/{locationBillingId}'
    if (locationBillingId === undefined || locationBillingId === null)
      throw new Error("The parameter 'locationBillingId' must be defined.")
    url_ = url_.replace('{locationBillingId}', encodeURIComponent('' + locationBillingId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetLocationBillingById(_response)
      )
    })
  }

  protected processGetLocationBillingById(
    response: Response
  ): Promise<SwaggerResponse<LocationBillingDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? LocationBillingDto.fromJS(resultData200)
          : new LocationBillingDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LocationBillingDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedLocationBilling (optional)
   * @return Success
   */
  updateLocationBilling(
    locationBillingId: string,
    updatedLocationBilling?: LocationBillingDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locationBillings/{locationBillingId}'
    if (locationBillingId === undefined || locationBillingId === null)
      throw new Error("The parameter 'locationBillingId' must be defined.")
    url_ = url_.replace('{locationBillingId}', encodeURIComponent('' + locationBillingId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedLocationBilling)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateLocationBilling(_response)
      )
    })
  }

  protected processUpdateLocationBilling(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateLocationBilling(locationBillingId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locationBillings/{locationBillingId}'
    if (locationBillingId === undefined || locationBillingId === null)
      throw new Error("The parameter 'locationBillingId' must be defined.")
    url_ = url_.replace('{locationBillingId}', encodeURIComponent('' + locationBillingId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateLocationBilling(_response)
      )
    })
  }

  protected processReactivateLocationBilling(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveLocationBilling(locationBillingId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locationBillings/{locationBillingId}'
    if (locationBillingId === undefined || locationBillingId === null)
      throw new Error("The parameter 'locationBillingId' must be defined.")
    url_ = url_.replace('{locationBillingId}', encodeURIComponent('' + locationBillingId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveLocationBilling(_response)
      )
    })
  }

  protected processArchiveLocationBilling(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param locationId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllLocationBillings(
    filter?: string | null | undefined,
    locationId?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<LocationBillingDto[]>> {
    let url_ = this.baseUrl + '/api/locationBillings?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (locationId !== undefined)
      url_ += 'locationId=' + encodeURIComponent('' + locationId) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllLocationBillings(_response)
      )
    })
  }

  protected processGetAllLocationBillings(
    response: Response
  ): Promise<SwaggerResponse<LocationBillingDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(LocationBillingDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LocationBillingDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newLocationBilling (optional)
   * @return Success
   */
  createLocationBilling(
    newLocationBilling?: LocationBillingDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locationBillings'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newLocationBilling)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateLocationBilling(_response)
      )
    })
  }

  protected processCreateLocationBilling(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getLocationById(locationId: string): Promise<SwaggerResponse<LocationDto>> {
    let url_ = this.baseUrl + '/api/locations/{locationId}'
    if (locationId === undefined || locationId === null)
      throw new Error("The parameter 'locationId' must be defined.")
    url_ = url_.replace('{locationId}', encodeURIComponent('' + locationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetLocationById(_response)
      )
    })
  }

  protected processGetLocationById(
    response: Response
  ): Promise<SwaggerResponse<LocationDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? LocationDto.fromJS(resultData200) : new LocationDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LocationDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedLocation (optional)
   * @return Success
   */
  updateLocation(
    locationId: string,
    updatedLocation?: LocationDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locations/{locationId}'
    if (locationId === undefined || locationId === null)
      throw new Error("The parameter 'locationId' must be defined.")
    url_ = url_.replace('{locationId}', encodeURIComponent('' + locationId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedLocation)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateLocation(_response)
      )
    })
  }

  protected processUpdateLocation(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateLocation(locationId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locations/{locationId}'
    if (locationId === undefined || locationId === null)
      throw new Error("The parameter 'locationId' must be defined.")
    url_ = url_.replace('{locationId}', encodeURIComponent('' + locationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateLocation(_response)
      )
    })
  }

  protected processReactivateLocation(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveLocation(locationId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locations/{locationId}'
    if (locationId === undefined || locationId === null)
      throw new Error("The parameter 'locationId' must be defined.")
    url_ = url_.replace('{locationId}', encodeURIComponent('' + locationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveLocation(_response)
      )
    })
  }

  protected processArchiveLocation(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param providerId (optional)
   * @param providerTypeId (optional)
   * @param filter (optional)
   * @param tags (optional)
   * @param procedures (optional)
   * @param latitude (optional)
   * @param longitude (optional)
   * @param range (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @param providerGroup (optional)
   * @return OK
   */
  getAllLocations(
    providerId?: string | null | undefined,
    providerTypeId?: string | null | undefined,
    filter?: string | null | undefined,
    tags?: string | null | undefined,
    procedures?: string | null | undefined,
    latitude?: number | null | undefined,
    longitude?: number | null | undefined,
    range?: number | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined,
    providerGroup?: string | null | undefined
  ): Promise<SwaggerResponse<LocationDto[]>> {
    let url_ = this.baseUrl + '/api/locations?'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    if (providerTypeId !== undefined)
      url_ += 'providerTypeId=' + encodeURIComponent('' + providerTypeId) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (tags !== undefined) url_ += 'tags=' + encodeURIComponent('' + tags) + '&'
    if (procedures !== undefined)
      url_ += 'procedures=' + encodeURIComponent('' + procedures) + '&'
    if (latitude !== undefined)
      url_ += 'latitude=' + encodeURIComponent('' + latitude) + '&'
    if (longitude !== undefined)
      url_ += 'longitude=' + encodeURIComponent('' + longitude) + '&'
    if (range !== undefined) url_ += 'range=' + encodeURIComponent('' + range) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    if (providerGroup !== undefined)
      url_ += 'providerGroup=' + encodeURIComponent('' + providerGroup) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllLocations(_response)
      )
    })
  }

  protected processGetAllLocations(
    response: Response
  ): Promise<SwaggerResponse<LocationDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(LocationDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LocationDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param providerId (optional)
   * @param newLocation (optional)
   * @return Success
   */
  createLocation(
    providerId?: string | null | undefined,
    newLocation?: LocationDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/locations?'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newLocation)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateLocation(_response)
      )
    })
  }

  protected processCreateLocation(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param login (optional)
   * @return Success
   */
  apiLoginPut(login?: LoginDto | null | undefined): Promise<SwaggerResponse<LoginDto>> {
    let url_ = this.baseUrl + '/api/Login'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(login)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiLoginPut(_response)
      )
    })
  }

  protected processApiLoginPut(response: Response): Promise<SwaggerResponse<LoginDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? LoginDto.fromJS(resultData200) : new LoginDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LoginDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param model (optional)
   * @return Success
   */
  apiLoginPost(model?: LoginDto | null | undefined): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/api/Login'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(model)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiLoginPost(_response)
      )
    })
  }

  protected processApiLoginPost(response: Response): Promise<SwaggerResponse<UserDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiLoginDelete(): Promise<SwaggerResponse<LoginDto>> {
    let url_ = this.baseUrl + '/api/Login'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiLoginDelete(_response)
      )
    })
  }

  protected processApiLoginDelete(
    response: Response
  ): Promise<SwaggerResponse<LoginDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? LoginDto.fromJS(resultData200) : new LoginDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LoginDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param userName (optional)
   * @param resetToken (optional)
   * @return Success
   */
  apiLoginTokenValidityPost(
    userName?: string | null | undefined,
    resetToken?: string | null | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + '/api/Login/TokenValidity?'
    if (userName !== undefined)
      url_ += 'userName=' + encodeURIComponent('' + userName) + '&'
    if (resetToken !== undefined)
      url_ += 'resetToken=' + encodeURIComponent('' + resetToken) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiLoginTokenValidityPost(_response)
      )
    })
  }

  protected processApiLoginTokenValidityPost(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param model (optional)
   * @return Success
   */
  apiLoginForgotPasswordPost(
    model?: LoginDto | null | undefined
  ): Promise<SwaggerResponse<LoginDto>> {
    let url_ = this.baseUrl + '/api/Login/ForgotPassword'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(model)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiLoginForgotPasswordPost(_response)
      )
    })
  }

  protected processApiLoginForgotPasswordPost(
    response: Response
  ): Promise<SwaggerResponse<LoginDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? LoginDto.fromJS(resultData200) : new LoginDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<LoginDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getMedicareCostLookupById(
    medicareCostLookupId: string
  ): Promise<SwaggerResponse<MedicareCostLookupDto>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups/{medicareCostLookupId}'
    if (medicareCostLookupId === undefined || medicareCostLookupId === null)
      throw new Error("The parameter 'medicareCostLookupId' must be defined.")
    url_ = url_.replace(
      '{medicareCostLookupId}',
      encodeURIComponent('' + medicareCostLookupId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetMedicareCostLookupById(_response)
      )
    })
  }

  protected processGetMedicareCostLookupById(
    response: Response
  ): Promise<SwaggerResponse<MedicareCostLookupDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? MedicareCostLookupDto.fromJS(resultData200)
          : new MedicareCostLookupDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<MedicareCostLookupDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedMedicareCostLookup (optional)
   * @return Success
   */
  updateMedicareCostLookup(
    medicareCostLookupId: string,
    updatedMedicareCostLookup?: MedicareCostLookupDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups/{medicareCostLookupId}'
    if (medicareCostLookupId === undefined || medicareCostLookupId === null)
      throw new Error("The parameter 'medicareCostLookupId' must be defined.")
    url_ = url_.replace(
      '{medicareCostLookupId}',
      encodeURIComponent('' + medicareCostLookupId)
    )
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedMedicareCostLookup)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateMedicareCostLookup(_response)
      )
    })
  }

  protected processUpdateMedicareCostLookup(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateMedicareCostLookup(
    medicareCostLookupId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups/{medicareCostLookupId}'
    if (medicareCostLookupId === undefined || medicareCostLookupId === null)
      throw new Error("The parameter 'medicareCostLookupId' must be defined.")
    url_ = url_.replace(
      '{medicareCostLookupId}',
      encodeURIComponent('' + medicareCostLookupId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateMedicareCostLookup(_response)
      )
    })
  }

  protected processReactivateMedicareCostLookup(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveMedicareCostLookup(
    medicareCostLookupId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups/{medicareCostLookupId}'
    if (medicareCostLookupId === undefined || medicareCostLookupId === null)
      throw new Error("The parameter 'medicareCostLookupId' must be defined.")
    url_ = url_.replace(
      '{medicareCostLookupId}',
      encodeURIComponent('' + medicareCostLookupId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveMedicareCostLookup(_response)
      )
    })
  }

  protected processArchiveMedicareCostLookup(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param dateFilter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllMedicareCostLookups(
    filter?: string | null | undefined,
    dateFilter?: Date | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<MedicareCostLookupDto[]>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (dateFilter !== undefined)
      url_ +=
        'dateFilter=' +
        encodeURIComponent(dateFilter ? '' + dateFilter.toJSON() : '') +
        '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllMedicareCostLookups(_response)
      )
    })
  }

  protected processGetAllMedicareCostLookups(
    response: Response
  ): Promise<SwaggerResponse<MedicareCostLookupDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200)
            result200.push(MedicareCostLookupDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<MedicareCostLookupDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newMedicareCostLookup (optional)
   * @return Success
   */
  createMedicareCostLookup(
    newMedicareCostLookup?: MedicareCostLookupDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newMedicareCostLookup)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateMedicareCostLookup(_response)
      )
    })
  }

  protected processCreateMedicareCostLookup(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param lineItemId (optional)
   * @param providerId (optional)
   * @param contractId (optional)
   * @param cptCode (optional)
   * @param mods (optional)
   * @return OK
   */
  lookupMedicareCosts(
    lineItemId?: string | null | undefined,
    providerId?: string | null | undefined,
    contractId?: string | null | undefined,
    cptCode?: string | null | undefined,
    mods?: string | null | undefined
  ): Promise<SwaggerResponse<CptCostLookupDto[]>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups/lookupMedicareCosts?'
    if (lineItemId !== undefined)
      url_ += 'lineItemId=' + encodeURIComponent('' + lineItemId) + '&'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    if (contractId !== undefined)
      url_ += 'contractId=' + encodeURIComponent('' + contractId) + '&'
    if (cptCode !== undefined) url_ += 'cptCode=' + encodeURIComponent('' + cptCode) + '&'
    if (mods !== undefined) url_ += 'mods=' + encodeURIComponent('' + mods) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processLookupMedicareCosts(_response)
      )
    })
  }

  protected processLookupMedicareCosts(
    response: Response
  ): Promise<SwaggerResponse<CptCostLookupDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(CptCostLookupDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<CptCostLookupDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param lineItemDtos (optional)
   * @return OK
   */
  applyDiscounts(
    lineItemDtos?: LineItemDto[] | null | undefined
  ): Promise<SwaggerResponse<DiscountsDto[]>> {
    let url_ = this.baseUrl + '/api/medicareCostLookups/applyDiscounts'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(lineItemDtos)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApplyDiscounts(_response)
      )
    })
  }

  protected processApplyDiscounts(
    response: Response
  ): Promise<SwaggerResponse<DiscountsDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(DiscountsDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<DiscountsDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getMultipleProcedureDiscountExclusionCodeById(
    multipleProcedureDiscountExclusionCodeId: string
  ): Promise<SwaggerResponse<MultipleProcedureDiscountExclusionCodeDto>> {
    let url_ =
      this.baseUrl +
      '/api/multipleProcedureDiscountExclusionCodes/{multipleProcedureDiscountExclusionCodeId}'
    if (
      multipleProcedureDiscountExclusionCodeId === undefined ||
      multipleProcedureDiscountExclusionCodeId === null
    )
      throw new Error(
        "The parameter 'multipleProcedureDiscountExclusionCodeId' must be defined."
      )
    url_ = url_.replace(
      '{multipleProcedureDiscountExclusionCodeId}',
      encodeURIComponent('' + multipleProcedureDiscountExclusionCodeId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetMultipleProcedureDiscountExclusionCodeById(_response)
      )
    })
  }

  protected processGetMultipleProcedureDiscountExclusionCodeById(
    response: Response
  ): Promise<SwaggerResponse<MultipleProcedureDiscountExclusionCodeDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? MultipleProcedureDiscountExclusionCodeDto.fromJS(resultData200)
          : new MultipleProcedureDiscountExclusionCodeDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<MultipleProcedureDiscountExclusionCodeDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedMultipleProcedureDiscountExclusionCode (optional)
   * @return Success
   */
  updateMultipleProcedureDiscountExclusionCode(
    multipleProcedureDiscountExclusionCodeId: string,
    updatedMultipleProcedureDiscountExclusionCode?:
      | MultipleProcedureDiscountExclusionCodeDto
      | null
      | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ =
      this.baseUrl +
      '/api/multipleProcedureDiscountExclusionCodes/{multipleProcedureDiscountExclusionCodeId}'
    if (
      multipleProcedureDiscountExclusionCodeId === undefined ||
      multipleProcedureDiscountExclusionCodeId === null
    )
      throw new Error(
        "The parameter 'multipleProcedureDiscountExclusionCodeId' must be defined."
      )
    url_ = url_.replace(
      '{multipleProcedureDiscountExclusionCodeId}',
      encodeURIComponent('' + multipleProcedureDiscountExclusionCodeId)
    )
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedMultipleProcedureDiscountExclusionCode)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateMultipleProcedureDiscountExclusionCode(_response)
      )
    })
  }

  protected processUpdateMultipleProcedureDiscountExclusionCode(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  deleteMultipleProcedureDiscountExclusionCode(
    multipleProcedureDiscountExclusionCodeId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ =
      this.baseUrl +
      '/api/multipleProcedureDiscountExclusionCodes/{multipleProcedureDiscountExclusionCodeId}'
    if (
      multipleProcedureDiscountExclusionCodeId === undefined ||
      multipleProcedureDiscountExclusionCodeId === null
    )
      throw new Error(
        "The parameter 'multipleProcedureDiscountExclusionCodeId' must be defined."
      )
    url_ = url_.replace(
      '{multipleProcedureDiscountExclusionCodeId}',
      encodeURIComponent('' + multipleProcedureDiscountExclusionCodeId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processDeleteMultipleProcedureDiscountExclusionCode(_response)
      )
    })
  }

  protected processDeleteMultipleProcedureDiscountExclusionCode(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllMultipleProcedureDiscountExclusionCodes(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<MultipleProcedureDiscountExclusionCodeDto[]>> {
    let url_ = this.baseUrl + '/api/multipleProcedureDiscountExclusionCodes?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllMultipleProcedureDiscountExclusionCodes(_response)
      )
    })
  }

  protected processGetAllMultipleProcedureDiscountExclusionCodes(
    response: Response
  ): Promise<SwaggerResponse<MultipleProcedureDiscountExclusionCodeDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200)
            result200.push(MultipleProcedureDiscountExclusionCodeDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<MultipleProcedureDiscountExclusionCodeDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newMultipleProcedureDiscountExclusionCodes (optional)
   * @return Success
   */
  createMultipleProcedureDiscountExclusionCode(
    newMultipleProcedureDiscountExclusionCodes?:
      | MultipleProcedureDiscountExclusionCodeDto
      | null
      | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/multipleProcedureDiscountExclusionCodes'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newMultipleProcedureDiscountExclusionCodes)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateMultipleProcedureDiscountExclusionCode(_response)
      )
    })
  }

  protected processCreateMultipleProcedureDiscountExclusionCode(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getNurseCaseManagerById(
    nurseCaseManagerId: string
  ): Promise<SwaggerResponse<NurseCaseManagerDto>> {
    let url_ = this.baseUrl + '/api/nurseCaseManagers/{nurseCaseManagerId}'
    if (nurseCaseManagerId === undefined || nurseCaseManagerId === null)
      throw new Error("The parameter 'nurseCaseManagerId' must be defined.")
    url_ = url_.replace(
      '{nurseCaseManagerId}',
      encodeURIComponent('' + nurseCaseManagerId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetNurseCaseManagerById(_response)
      )
    })
  }

  protected processGetNurseCaseManagerById(
    response: Response
  ): Promise<SwaggerResponse<NurseCaseManagerDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? NurseCaseManagerDto.fromJS(resultData200)
          : new NurseCaseManagerDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<NurseCaseManagerDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedNurseCaseManager (optional)
   * @return Success
   */
  updateNurseCaseManager(
    nurseCaseManagerId: string,
    updatedNurseCaseManager?: NurseCaseManagerDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/nurseCaseManagers/{nurseCaseManagerId}'
    if (nurseCaseManagerId === undefined || nurseCaseManagerId === null)
      throw new Error("The parameter 'nurseCaseManagerId' must be defined.")
    url_ = url_.replace(
      '{nurseCaseManagerId}',
      encodeURIComponent('' + nurseCaseManagerId)
    )
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedNurseCaseManager)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateNurseCaseManager(_response)
      )
    })
  }

  protected processUpdateNurseCaseManager(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateNurseCaseManager(nurseCaseManagerId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/nurseCaseManagers/{nurseCaseManagerId}'
    if (nurseCaseManagerId === undefined || nurseCaseManagerId === null)
      throw new Error("The parameter 'nurseCaseManagerId' must be defined.")
    url_ = url_.replace(
      '{nurseCaseManagerId}',
      encodeURIComponent('' + nurseCaseManagerId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateNurseCaseManager(_response)
      )
    })
  }

  protected processReactivateNurseCaseManager(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveNurseCaseManager(nurseCaseManagerId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/nurseCaseManagers/{nurseCaseManagerId}'
    if (nurseCaseManagerId === undefined || nurseCaseManagerId === null)
      throw new Error("The parameter 'nurseCaseManagerId' must be defined.")
    url_ = url_.replace(
      '{nurseCaseManagerId}',
      encodeURIComponent('' + nurseCaseManagerId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveNurseCaseManager(_response)
      )
    })
  }

  protected processArchiveNurseCaseManager(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllNurseCaseManagers(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<NurseCaseManagerDto[]>> {
    let url_ = this.baseUrl + '/api/nurseCaseManagers?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllNurseCaseManagers(_response)
      )
    })
  }

  protected processGetAllNurseCaseManagers(
    response: Response
  ): Promise<SwaggerResponse<NurseCaseManagerDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(NurseCaseManagerDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<NurseCaseManagerDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newNurseCaseManager (optional)
   * @return Success
   */
  createNurseCaseManager(
    newNurseCaseManager?: NurseCaseManagerDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/nurseCaseManagers'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newNurseCaseManager)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateNurseCaseManager(_response)
      )
    })
  }

  protected processCreateNurseCaseManager(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getOrganizationById(organizationId: string): Promise<SwaggerResponse<OrganizationDto>> {
    let url_ = this.baseUrl + '/api/organizations/{organizationId}'
    if (organizationId === undefined || organizationId === null)
      throw new Error("The parameter 'organizationId' must be defined.")
    url_ = url_.replace('{organizationId}', encodeURIComponent('' + organizationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetOrganizationById(_response)
      )
    })
  }

  protected processGetOrganizationById(
    response: Response
  ): Promise<SwaggerResponse<OrganizationDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? OrganizationDto.fromJS(resultData200)
          : new OrganizationDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<OrganizationDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedOrganization (optional)
   * @return Success
   */
  updateOrganization(
    organizationId: string,
    updatedOrganization?: OrganizationDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/organizations/{organizationId}'
    if (organizationId === undefined || organizationId === null)
      throw new Error("The parameter 'organizationId' must be defined.")
    url_ = url_.replace('{organizationId}', encodeURIComponent('' + organizationId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedOrganization)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateOrganization(_response)
      )
    })
  }

  protected processUpdateOrganization(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateOrganization(organizationId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/organizations/{organizationId}'
    if (organizationId === undefined || organizationId === null)
      throw new Error("The parameter 'organizationId' must be defined.")
    url_ = url_.replace('{organizationId}', encodeURIComponent('' + organizationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateOrganization(_response)
      )
    })
  }

  protected processReactivateOrganization(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveOrganization(organizationId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/organizations/{organizationId}'
    if (organizationId === undefined || organizationId === null)
      throw new Error("The parameter 'organizationId' must be defined.")
    url_ = url_.replace('{organizationId}', encodeURIComponent('' + organizationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveOrganization(_response)
      )
    })
  }

  protected processArchiveOrganization(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllOrganizations(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<OrganizationDto[]>> {
    let url_ = this.baseUrl + '/api/organizations?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllOrganizations(_response)
      )
    })
  }

  protected processGetAllOrganizations(
    response: Response
  ): Promise<SwaggerResponse<OrganizationDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(OrganizationDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<OrganizationDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newOrganization (optional)
   * @return Success
   */
  createOrganization(
    newOrganization?: OrganizationDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/organizations'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newOrganization)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateOrganization(_response)
      )
    })
  }

  protected processCreateOrganization(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiPasswordRulesGet(): Promise<SwaggerResponse<PasswordRuleSettings>> {
    let url_ = this.baseUrl + '/api/PasswordRules'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiPasswordRulesGet(_response)
      )
    })
  }

  protected processApiPasswordRulesGet(
    response: Response
  ): Promise<SwaggerResponse<PasswordRuleSettings>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? PasswordRuleSettings.fromJS(resultData200)
          : new PasswordRuleSettings()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PasswordRuleSettings>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getPatientById(patientId: string): Promise<SwaggerResponse<PatientDto>> {
    let url_ = this.baseUrl + '/api/patients/{patientId}'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetPatientById(_response)
      )
    })
  }

  protected processGetPatientById(
    response: Response
  ): Promise<SwaggerResponse<PatientDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? PatientDto.fromJS(resultData200) : new PatientDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PatientDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param up (optional)
   * @return Success
   */
  updatePatient(
    patientId: string,
    up?: PatientDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/patients/{patientId}'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(up)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdatePatient(_response)
      )
    })
  }

  protected processUpdatePatient(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivatePatient(patientId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/patients/{patientId}'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivatePatient(_response)
      )
    })
  }

  protected processReactivatePatient(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archivePatient(patientId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/patients/{patientId}'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchivePatient(_response)
      )
    })
  }

  protected processArchivePatient(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllPatients(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<PatientDto[]>> {
    let url_ = this.baseUrl + '/api/patient?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllPatients(_response)
      )
    })
  }

  protected processGetAllPatients(
    response: Response
  ): Promise<SwaggerResponse<PatientDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(PatientDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PatientDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newPatient (optional)
   * @return Success
   */
  createPatient(
    newPatient?: PatientDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/patient'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newPatient)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreatePatient(_response)
      )
    })
  }

  protected processCreatePatient(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  generatePatientDemographicsReport(
    patientId: string,
    episodeOfCareId: string
  ): Promise<SwaggerResponse<File>> {
    let url_ =
      this.baseUrl +
      '/api/patients/{patientId}/episodeOfCare/{episodeOfCareId}/PatientDemographics'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    if (episodeOfCareId === undefined || episodeOfCareId === null)
      throw new Error("The parameter 'episodeOfCareId' must be defined.")
    url_ = url_.replace('{episodeOfCareId}', encodeURIComponent('' + episodeOfCareId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGeneratePatientDemographicsReport(_response)
      )
    })
  }

  protected processGeneratePatientDemographicsReport(
    response: Response
  ): Promise<SwaggerResponse<File>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? File.fromJS(resultData200) : new File()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<File>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param contents (optional)
   * @return Success
   */
  sendPatientSMS(
    patientId: string,
    contents?: string | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/patients/{patientId}/sms'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(contents)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processSendPatientSMS(_response)
      )
    })
  }

  protected processSendPatientSMS(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getPhysicianById(
    providerId: string,
    physicianId: string
  ): Promise<SwaggerResponse<PhysicianDto>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/physicians/{physicianId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (physicianId === undefined || physicianId === null)
      throw new Error("The parameter 'physicianId' must be defined.")
    url_ = url_.replace('{physicianId}', encodeURIComponent('' + physicianId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetPhysicianById(_response)
      )
    })
  }

  protected processGetPhysicianById(
    response: Response
  ): Promise<SwaggerResponse<PhysicianDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? PhysicianDto.fromJS(resultData200)
          : new PhysicianDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PhysicianDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedPhysician (optional)
   * @return Success
   */
  updatePhysician(
    providerId: string,
    physicianId: string,
    updatedPhysician?: PhysicianDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/physicians/{physicianId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (physicianId === undefined || physicianId === null)
      throw new Error("The parameter 'physicianId' must be defined.")
    url_ = url_.replace('{physicianId}', encodeURIComponent('' + physicianId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedPhysician)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdatePhysician(_response)
      )
    })
  }

  protected processUpdatePhysician(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivatePhysician(
    providerId: string,
    physicianId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/physicians/{physicianId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (physicianId === undefined || physicianId === null)
      throw new Error("The parameter 'physicianId' must be defined.")
    url_ = url_.replace('{physicianId}', encodeURIComponent('' + physicianId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivatePhysician(_response)
      )
    })
  }

  protected processReactivatePhysician(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archivePhysician(
    providerId: string,
    physicianId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/physicians/{physicianId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (physicianId === undefined || physicianId === null)
      throw new Error("The parameter 'physicianId' must be defined.")
    url_ = url_.replace('{physicianId}', encodeURIComponent('' + physicianId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchivePhysician(_response)
      )
    })
  }

  protected processArchivePhysician(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllPhysicians(
    providerId: string,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<PhysicianDto[]>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/physicians?'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllPhysicians(_response)
      )
    })
  }

  protected processGetAllPhysicians(
    response: Response
  ): Promise<SwaggerResponse<PhysicianDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(PhysicianDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PhysicianDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newPhysician (optional)
   * @return Success
   */
  createPhysician(
    providerId: string,
    newPhysician?: PhysicianDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}/physicians'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newPhysician)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreatePhysician(_response)
      )
    })
  }

  protected processCreatePhysician(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getPreExistingConditionById(
    preExistingConditionId: string
  ): Promise<SwaggerResponse<PreExistingConditionDto>> {
    let url_ = this.baseUrl + '/api/preExistingConditions/{preExistingConditionId}'
    if (preExistingConditionId === undefined || preExistingConditionId === null)
      throw new Error("The parameter 'preExistingConditionId' must be defined.")
    url_ = url_.replace(
      '{preExistingConditionId}',
      encodeURIComponent('' + preExistingConditionId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetPreExistingConditionById(_response)
      )
    })
  }

  protected processGetPreExistingConditionById(
    response: Response
  ): Promise<SwaggerResponse<PreExistingConditionDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? PreExistingConditionDto.fromJS(resultData200)
          : new PreExistingConditionDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PreExistingConditionDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedPreExistingCondition (optional)
   * @return Success
   */
  updatePreExistingCondition(
    preExistingConditionId: string,
    updatedPreExistingCondition?: PreExistingConditionDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/preExistingConditions/{preExistingConditionId}'
    if (preExistingConditionId === undefined || preExistingConditionId === null)
      throw new Error("The parameter 'preExistingConditionId' must be defined.")
    url_ = url_.replace(
      '{preExistingConditionId}',
      encodeURIComponent('' + preExistingConditionId)
    )
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedPreExistingCondition)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdatePreExistingCondition(_response)
      )
    })
  }

  protected processUpdatePreExistingCondition(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivatePreExistingCondition(
    preExistingConditionId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/preExistingConditions/{preExistingConditionId}'
    if (preExistingConditionId === undefined || preExistingConditionId === null)
      throw new Error("The parameter 'preExistingConditionId' must be defined.")
    url_ = url_.replace(
      '{preExistingConditionId}',
      encodeURIComponent('' + preExistingConditionId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivatePreExistingCondition(_response)
      )
    })
  }

  protected processReactivatePreExistingCondition(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archivePreExistingCondition(
    preExistingConditionId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/preExistingConditions/{preExistingConditionId}'
    if (preExistingConditionId === undefined || preExistingConditionId === null)
      throw new Error("The parameter 'preExistingConditionId' must be defined.")
    url_ = url_.replace(
      '{preExistingConditionId}',
      encodeURIComponent('' + preExistingConditionId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchivePreExistingCondition(_response)
      )
    })
  }

  protected processArchivePreExistingCondition(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllPreExistingConditions(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<PreExistingConditionDto[]>> {
    let url_ = this.baseUrl + '/api/preExistingCondition?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllPreExistingConditions(_response)
      )
    })
  }

  protected processGetAllPreExistingConditions(
    response: Response
  ): Promise<SwaggerResponse<PreExistingConditionDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200)
            result200.push(PreExistingConditionDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<PreExistingConditionDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newPreExistingCondition (optional)
   * @return Success
   */
  createPreExistingCondition(
    newPreExistingCondition?: PreExistingConditionDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/preExistingCondition'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newPreExistingCondition)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreatePreExistingCondition(_response)
      )
    })
  }

  protected processCreatePreExistingCondition(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getProcedureById(procedureId: string): Promise<SwaggerResponse<ProcedureDto>> {
    let url_ = this.baseUrl + '/api/procedures/{procedureId}'
    if (procedureId === undefined || procedureId === null)
      throw new Error("The parameter 'procedureId' must be defined.")
    url_ = url_.replace('{procedureId}', encodeURIComponent('' + procedureId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetProcedureById(_response)
      )
    })
  }

  protected processGetProcedureById(
    response: Response
  ): Promise<SwaggerResponse<ProcedureDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? ProcedureDto.fromJS(resultData200)
          : new ProcedureDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ProcedureDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedProcedure (optional)
   * @return Success
   */
  updateProcedure(
    procedureId: string,
    updatedProcedure?: ProcedureDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/procedures/{procedureId}'
    if (procedureId === undefined || procedureId === null)
      throw new Error("The parameter 'procedureId' must be defined.")
    url_ = url_.replace('{procedureId}', encodeURIComponent('' + procedureId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedProcedure)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateProcedure(_response)
      )
    })
  }

  protected processUpdateProcedure(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateProcedure(procedureId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/procedures/{procedureId}'
    if (procedureId === undefined || procedureId === null)
      throw new Error("The parameter 'procedureId' must be defined.")
    url_ = url_.replace('{procedureId}', encodeURIComponent('' + procedureId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateProcedure(_response)
      )
    })
  }

  protected processReactivateProcedure(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveProcedure(procedureId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/procedures/{procedureId}'
    if (procedureId === undefined || procedureId === null)
      throw new Error("The parameter 'procedureId' must be defined.")
    url_ = url_.replace('{procedureId}', encodeURIComponent('' + procedureId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveProcedure(_response)
      )
    })
  }

  protected processArchiveProcedure(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllProcedures(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ProcedureDto[]>> {
    let url_ = this.baseUrl + '/api/procedures?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllProcedures(_response)
      )
    })
  }

  protected processGetAllProcedures(
    response: Response
  ): Promise<SwaggerResponse<ProcedureDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ProcedureDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ProcedureDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newProcedure (optional)
   * @return Success
   */
  createProcedure(
    newProcedure?: ProcedureDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/procedures'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newProcedure)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateProcedure(_response)
      )
    })
  }

  protected processCreateProcedure(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getProviderById(providerId: string): Promise<SwaggerResponse<ProviderDto>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetProviderById(_response)
      )
    })
  }

  protected processGetProviderById(
    response: Response
  ): Promise<SwaggerResponse<ProviderDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? ProviderDto.fromJS(resultData200) : new ProviderDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ProviderDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateProvider(providerId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateProvider(_response)
      )
    })
  }

  protected processReactivateProvider(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveProvider(providerId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/providers/{providerId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveProvider(_response)
      )
    })
  }

  protected processArchiveProvider(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param providerTypeId (optional)
   * @param organizationId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllProviders(
    filter?: string | null | undefined,
    providerTypeId?: string | null | undefined,
    organizationId?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ProviderDto[]>> {
    let url_ = this.baseUrl + '/api/providers?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (providerTypeId !== undefined)
      url_ += 'providerTypeId=' + encodeURIComponent('' + providerTypeId) + '&'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllProviders(_response)
      )
    })
  }

  protected processGetAllProviders(
    response: Response
  ): Promise<SwaggerResponse<ProviderDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ProviderDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ProviderDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param providerId (optional)
   * @param cms1500OrganizationId (optional)
   * @return OK
   */
  getAllProviderBills(
    providerId?: string | null | undefined,
    cms1500OrganizationId?: string | null | undefined
  ): Promise<SwaggerResponse<ProviderDto[]>> {
    let url_ = this.baseUrl + '/api/providers/surgery-bills?'
    if (providerId !== undefined)
      url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&'
    if (cms1500OrganizationId !== undefined)
      url_ +=
        'cms1500OrganizationId=' + encodeURIComponent('' + cms1500OrganizationId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllProviderBills(_response)
      )
    })
  }

  protected processGetAllProviderBills(
    response: Response
  ): Promise<SwaggerResponse<ProviderDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ProviderDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ProviderDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getProviderTypes(): Promise<SwaggerResponse<ProviderTypeDto[]>> {
    let url_ = this.baseUrl + '/api/providerTypes'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetProviderTypes(_response)
      )
    })
  }

  protected processGetProviderTypes(
    response: Response
  ): Promise<SwaggerResponse<ProviderTypeDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ProviderTypeDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ProviderTypeDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getProviderContractType(providerId: string): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + '/api/providerContractType/{providerId}'
    if (providerId === undefined || providerId === null)
      throw new Error("The parameter 'providerId' must be defined.")
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetProviderContractType(_response)
      )
    })
  }

  protected processGetProviderContractType(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllReferrals(
    patientId: string,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ReferralDto[]>> {
    let url_ = this.baseUrl + '/api/patients/{patientId}/referrals?'
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.")
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId))
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllReferrals(_response)
      )
    })
  }

  protected processGetAllReferrals(
    response: Response
  ): Promise<SwaggerResponse<ReferralDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ReferralDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ReferralDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  episodesOfCareFlaggedAsIssueCount(): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/EpisodesOfCareFlaggedAsIssueCount'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processEpisodesOfCareFlaggedAsIssueCount(_response)
      )
    })
  }

  protected processEpisodesOfCareFlaggedAsIssueCount(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param flowFilter (optional)
   * @param careCoordinatorId (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  diagnosticPatientFlow(
    flowFilter?: number | null | undefined,
    careCoordinatorId?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ReferralDto[]>> {
    let url_ = this.baseUrl + '/api/diagnosticPatientFlow?'
    if (flowFilter !== undefined)
      url_ += 'flowFilter=' + encodeURIComponent('' + flowFilter) + '&'
    if (careCoordinatorId !== undefined)
      url_ += 'careCoordinatorId=' + encodeURIComponent('' + careCoordinatorId) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processDiagnosticPatientFlow(_response)
      )
    })
  }

  protected processDiagnosticPatientFlow(
    response: Response
  ): Promise<SwaggerResponse<ReferralDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ReferralDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ReferralDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getReferringDoctorById(
    referringDoctorId: string
  ): Promise<SwaggerResponse<ReferringDoctorDto>> {
    let url_ = this.baseUrl + '/api/referringDoctors/{referringDoctorId}'
    if (referringDoctorId === undefined || referringDoctorId === null)
      throw new Error("The parameter 'referringDoctorId' must be defined.")
    url_ = url_.replace('{referringDoctorId}', encodeURIComponent('' + referringDoctorId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetReferringDoctorById(_response)
      )
    })
  }

  protected processGetReferringDoctorById(
    response: Response
  ): Promise<SwaggerResponse<ReferringDoctorDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? ReferringDoctorDto.fromJS(resultData200)
          : new ReferringDoctorDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ReferringDoctorDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedReferringDoctor (optional)
   * @return Success
   */
  updateReferringDoctor(
    referringDoctorId: string,
    updatedReferringDoctor?: ReferringDoctorDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/referringDoctors/{referringDoctorId}'
    if (referringDoctorId === undefined || referringDoctorId === null)
      throw new Error("The parameter 'referringDoctorId' must be defined.")
    url_ = url_.replace('{referringDoctorId}', encodeURIComponent('' + referringDoctorId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedReferringDoctor)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateReferringDoctor(_response)
      )
    })
  }

  protected processUpdateReferringDoctor(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateReferringDoctor(referringDoctorId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/referringDoctors/{referringDoctorId}'
    if (referringDoctorId === undefined || referringDoctorId === null)
      throw new Error("The parameter 'referringDoctorId' must be defined.")
    url_ = url_.replace('{referringDoctorId}', encodeURIComponent('' + referringDoctorId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateReferringDoctor(_response)
      )
    })
  }

  protected processReactivateReferringDoctor(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveReferringDoctor(referringDoctorId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/referringDoctors/{referringDoctorId}'
    if (referringDoctorId === undefined || referringDoctorId === null)
      throw new Error("The parameter 'referringDoctorId' must be defined.")
    url_ = url_.replace('{referringDoctorId}', encodeURIComponent('' + referringDoctorId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveReferringDoctor(_response)
      )
    })
  }

  protected processArchiveReferringDoctor(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllReferringDoctors(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ReferringDoctorDto[]>> {
    let url_ = this.baseUrl + '/api/referringDoctors?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllReferringDoctors(_response)
      )
    })
  }

  protected processGetAllReferringDoctors(
    response: Response
  ): Promise<SwaggerResponse<ReferringDoctorDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ReferringDoctorDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ReferringDoctorDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newReferringDoctor (optional)
   * @return Success
   */
  createReferringDoctor(
    newReferringDoctor?: ReferringDoctorDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/referringDoctors'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newReferringDoctor)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateReferringDoctor(_response)
      )
    })
  }

  protected processCreateReferringDoctor(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @return Success
   */
  apiRolesGet(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined
  ): Promise<SwaggerResponse<RoleDto[]>> {
    let url_ = this.baseUrl + '/api/Roles?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiRolesGet(_response)
      )
    })
  }

  protected processApiRolesGet(response: Response): Promise<SwaggerResponse<RoleDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(RoleDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<RoleDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param role (optional)
   * @return Success
   */
  apiRolesPost(role?: RoleDto | null | undefined): Promise<SwaggerResponse<RoleDto>> {
    let url_ = this.baseUrl + '/api/Roles'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(role)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiRolesPost(_response)
      )
    })
  }

  protected processApiRolesPost(response: Response): Promise<SwaggerResponse<RoleDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<RoleDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiRolesByRoleIdDelete(roleId: string): Promise<SwaggerResponse<RoleDto>> {
    let url_ = this.baseUrl + '/api/Roles/{roleId}'
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.")
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiRolesByRoleIdDelete(_response)
      )
    })
  }

  protected processApiRolesByRoleIdDelete(
    response: Response
  ): Promise<SwaggerResponse<RoleDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<RoleDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getScheduleAppointmentTaskById(
    scheduleAppointmentTaskId: string
  ): Promise<SwaggerResponse<ScheduleAppointmentTaskDto>> {
    let url_ = this.baseUrl + '/api/scheduleAppointmentTasks/{scheduleAppointmentTaskId}'
    if (scheduleAppointmentTaskId === undefined || scheduleAppointmentTaskId === null)
      throw new Error("The parameter 'scheduleAppointmentTaskId' must be defined.")
    url_ = url_.replace(
      '{scheduleAppointmentTaskId}',
      encodeURIComponent('' + scheduleAppointmentTaskId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetScheduleAppointmentTaskById(_response)
      )
    })
  }

  protected processGetScheduleAppointmentTaskById(
    response: Response
  ): Promise<SwaggerResponse<ScheduleAppointmentTaskDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200
          ? ScheduleAppointmentTaskDto.fromJS(resultData200)
          : new ScheduleAppointmentTaskDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ScheduleAppointmentTaskDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedScheduleAppointmentTask (optional)
   * @return Success
   */
  updateScheduleAppointmentTask(
    scheduleAppointmentTaskId: string,
    updatedScheduleAppointmentTask?: ScheduleAppointmentTaskDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/scheduleAppointmentTasks/{scheduleAppointmentTaskId}'
    if (scheduleAppointmentTaskId === undefined || scheduleAppointmentTaskId === null)
      throw new Error("The parameter 'scheduleAppointmentTaskId' must be defined.")
    url_ = url_.replace(
      '{scheduleAppointmentTaskId}',
      encodeURIComponent('' + scheduleAppointmentTaskId)
    )
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedScheduleAppointmentTask)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateScheduleAppointmentTask(_response)
      )
    })
  }

  protected processUpdateScheduleAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateScheduleAppointmentTask(
    scheduleAppointmentTaskId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/scheduleAppointmentTasks/{scheduleAppointmentTaskId}'
    if (scheduleAppointmentTaskId === undefined || scheduleAppointmentTaskId === null)
      throw new Error("The parameter 'scheduleAppointmentTaskId' must be defined.")
    url_ = url_.replace(
      '{scheduleAppointmentTaskId}',
      encodeURIComponent('' + scheduleAppointmentTaskId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateScheduleAppointmentTask(_response)
      )
    })
  }

  protected processReactivateScheduleAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveScheduleAppointmentTask(
    scheduleAppointmentTaskId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/scheduleAppointmentTasks/{scheduleAppointmentTaskId}'
    if (scheduleAppointmentTaskId === undefined || scheduleAppointmentTaskId === null)
      throw new Error("The parameter 'scheduleAppointmentTaskId' must be defined.")
    url_ = url_.replace(
      '{scheduleAppointmentTaskId}',
      encodeURIComponent('' + scheduleAppointmentTaskId)
    )
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveScheduleAppointmentTask(_response)
      )
    })
  }

  protected processArchiveScheduleAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param organizationId (optional)
   * @param scheduleId (optional)
   * @param careCoordinatorId (optional)
   * @param isOverdue (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllScheduleAppointmentTasks(
    organizationId?: string | null | undefined,
    scheduleId?: string | null | undefined,
    careCoordinatorId?: string | null | undefined,
    isOverdue?: boolean | null | undefined,
    startDate?: Date | null | undefined,
    endDate?: Date | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ScheduleAppointmentTaskDto[]>> {
    let url_ = this.baseUrl + '/api/scheduleAppointmentTasks?'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (scheduleId !== undefined)
      url_ += 'scheduleId=' + encodeURIComponent('' + scheduleId) + '&'
    if (careCoordinatorId !== undefined)
      url_ += 'careCoordinatorId=' + encodeURIComponent('' + careCoordinatorId) + '&'
    if (isOverdue !== undefined)
      url_ += 'isOverdue=' + encodeURIComponent('' + isOverdue) + '&'
    if (startDate !== undefined)
      url_ +=
        'startDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&'
    if (endDate !== undefined)
      url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllScheduleAppointmentTasks(_response)
      )
    })
  }

  protected processGetAllScheduleAppointmentTasks(
    response: Response
  ): Promise<SwaggerResponse<ScheduleAppointmentTaskDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200)
            result200.push(ScheduleAppointmentTaskDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ScheduleAppointmentTaskDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newScheduleAppointmentTask (optional)
   * @return Success
   */
  createScheduleAppointmentTask(
    newScheduleAppointmentTask?: ScheduleAppointmentTaskDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/scheduleAppointmentTasks'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newScheduleAppointmentTask)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateScheduleAppointmentTask(_response)
      )
    })
  }

  protected processCreateScheduleAppointmentTask(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getCountAllOpenTasks(): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/allOpenTaskCount'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetCountAllOpenTasks(_response)
      )
    })
  }

  protected processGetCountAllOpenTasks(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getScheduleById(scheduleId: string): Promise<SwaggerResponse<ScheduleDto>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetScheduleById(_response)
      )
    })
  }

  protected processGetScheduleById(
    response: Response
  ): Promise<SwaggerResponse<ScheduleDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? ScheduleDto.fromJS(resultData200) : new ScheduleDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ScheduleDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedSchedule (optional)
   * @return Success
   */
  updateSchedule(
    scheduleId: string,
    updatedSchedule?: ScheduleDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedSchedule)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateSchedule(_response)
      )
    })
  }

  protected processUpdateSchedule(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateSchedule(scheduleId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateSchedule(_response)
      )
    })
  }

  protected processReactivateSchedule(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveSchedule(scheduleId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveSchedule(_response)
      )
    })
  }

  protected processArchiveSchedule(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param organizationId (optional)
   * @param episodeOfCareId (optional)
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return OK
   */
  getAllSchedules(
    organizationId?: string | null | undefined,
    episodeOfCareId?: string | null | undefined,
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<ScheduleDto[]>> {
    let url_ = this.baseUrl + '/api/schedules?'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (episodeOfCareId !== undefined)
      url_ += 'episodeOfCareId=' + encodeURIComponent('' + episodeOfCareId) + '&'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllSchedules(_response)
      )
    })
  }

  protected processGetAllSchedules(
    response: Response
  ): Promise<SwaggerResponse<ScheduleDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(ScheduleDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<ScheduleDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newSchedule (optional)
   * @return Success
   */
  createSchedule(
    newSchedule?: ScheduleDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/schedules'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newSchedule)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateSchedule(_response)
      )
    })
  }

  protected processCreateSchedule(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  createAppointmentConfirmation(scheduleId: string): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}/confirm'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateAppointmentConfirmation(_response)
      )
    })
  }

  protected processCreateAppointmentConfirmation(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  createAuthorizationPdf(scheduleId: string): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}/authorize'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateAuthorizationPdf(_response)
      )
    })
  }

  protected processCreateAuthorizationPdf(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  createResultsPdf(scheduleId: string): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}/results'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateResultsPdf(_response)
      )
    })
  }

  protected processCreateResultsPdf(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param dto (optional)
   * @return Success
   */
  createSingleCaseAgreementPdf(
    scheduleId: string,
    dto?: SingleCaseAgreementTextDto | null | undefined
  ): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/schedules/{scheduleId}/singleCaseAgreement'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(dto)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateSingleCaseAgreementPdf(_response)
      )
    })
  }

  protected processCreateSingleCaseAgreementPdf(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  addScheduleProviderLocation(
    scheduleId: string,
    locationId: string
  ): Promise<SwaggerResponse<void>> {
    let url_ =
      this.baseUrl + '/api/schedules/{scheduleId}/SecondaryProviderLocation/{locationId}'
    if (scheduleId === undefined || scheduleId === null)
      throw new Error("The parameter 'scheduleId' must be defined.")
    url_ = url_.replace('{scheduleId}', encodeURIComponent('' + scheduleId))
    if (locationId === undefined || locationId === null)
      throw new Error("The parameter 'locationId' must be defined.")
    url_ = url_.replace('{locationId}', encodeURIComponent('' + locationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processAddScheduleProviderLocation(_response)
      )
    })
  }

  protected processAddScheduleProviderLocation(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getAllSpecialties(): Promise<SwaggerResponse<SpecialtyDto[]>> {
    let url_ = this.baseUrl + '/api/specialties'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllSpecialties(_response)
      )
    })
  }

  protected processGetAllSpecialties(
    response: Response
  ): Promise<SwaggerResponse<SpecialtyDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(SpecialtyDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<SpecialtyDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getAllSubSpecialties(): Promise<SwaggerResponse<SubSpecialtyDto[]>> {
    let url_ = this.baseUrl + '/api/subSpecialties'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllSubSpecialties(_response)
      )
    })
  }

  protected processGetAllSubSpecialties(
    response: Response
  ): Promise<SwaggerResponse<SubSpecialtyDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(SubSpecialtyDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<SubSpecialtyDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  archiveTag(tagId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/Tags/{TagId}'
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.")
    url_ = url_.replace('{TagId}', encodeURIComponent('' + tagId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processArchiveTag(_response)
      )
    })
  }

  protected processArchiveTag(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @param includeSystem (optional)
   * @return OK
   */
  getAllTags(
    filter?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined,
    includeSystem?: boolean | null | undefined
  ): Promise<SwaggerResponse<TagDto[]>> {
    let url_ = this.baseUrl + '/api/tags?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    if (includeSystem !== undefined)
      url_ += 'includeSystem=' + encodeURIComponent('' + includeSystem) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetAllTags(_response)
      )
    })
  }

  protected processGetAllTags(response: Response): Promise<SwaggerResponse<TagDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(TagDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<TagDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param newTag (optional)
   * @return Success
   */
  createTag(newTag?: TagDto | null | undefined): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/tags'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(newTag)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processCreateTag(_response)
      )
    })
  }

  protected processCreateTag(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getTagById(tagId: string): Promise<SwaggerResponse<TagDto>> {
    let url_ = this.baseUrl + '/api/tags/{tagId}'
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.")
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetTagById(_response)
      )
    })
  }

  protected processGetTagById(response: Response): Promise<SwaggerResponse<TagDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? TagDto.fromJS(resultData200) : new TagDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<TagDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param updatedTag (optional)
   * @return Success
   */
  updateTag(
    tagId: string,
    updatedTag?: TagDto | null | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/tags/{tagId}'
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.")
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(updatedTag)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processUpdateTag(_response)
      )
    })
  }

  protected processUpdateTag(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  reactivateTag(tagId: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/tags/{tagId}'
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.")
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processReactivateTag(_response)
      )
    })
  }

  protected processReactivateTag(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return OK
   */
  getTagReferences(tagId: string): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/api/tags/{tagId}/references'
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.")
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetTagReferences(_response)
      )
    })
  }

  protected processGetTagReferences(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param type (optional)
   * @return OK
   */
  getTypesByCategory(
    type?: string | null | undefined
  ): Promise<SwaggerResponse<TypeDto[]>> {
    let url_ = this.baseUrl + '/api/types?'
    if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processGetTypesByCategory(_response)
      )
    })
  }

  protected processGetTypesByCategory(
    response: Response
  ): Promise<SwaggerResponse<TypeDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(TypeDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<TypeDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param filter (optional)
   * @param roleFilter (optional)
   * @param organizationId (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param includeInactives (optional)
   * @return Success
   */
  apiUsersGet(
    filter?: string | null | undefined,
    roleFilter?: string | null | undefined,
    organizationId?: string | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    orderBy?: string | null | undefined,
    includeInactives?: boolean | null | undefined
  ): Promise<SwaggerResponse<UserDto[]>> {
    let url_ = this.baseUrl + '/api/users?'
    if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&'
    if (roleFilter !== undefined)
      url_ += 'roleFilter=' + encodeURIComponent('' + roleFilter) + '&'
    if (organizationId !== undefined)
      url_ += 'organizationId=' + encodeURIComponent('' + organizationId) + '&'
    if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&'
    if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&'
    if (orderBy !== undefined) url_ += 'orderBy=' + encodeURIComponent('' + orderBy) + '&'
    if (includeInactives !== undefined)
      url_ += 'includeInactives=' + encodeURIComponent('' + includeInactives) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersGet(_response)
      )
    })
  }

  protected processApiUsersGet(response: Response): Promise<SwaggerResponse<UserDto[]>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (resultData200 && resultData200.constructor === Array) {
          result200 = []
          for (let item of resultData200) result200.push(UserDto.fromJS(item))
        }
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param user (optional)
   * @return Success
   */
  apiUsersPost(user?: UserDto | null | undefined): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/api/Users'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(user)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersPost(_response)
      )
    })
  }

  protected processApiUsersPost(response: Response): Promise<SwaggerResponse<UserDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param user (optional)
   * @return Success
   */
  apiUsersProfileImagePost(
    user?: UserDto | null | undefined
  ): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/api/Users/ProfileImage'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(user)

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersProfileImagePost(_response)
      )
    })
  }

  protected processApiUsersProfileImagePost(
    response: Response
  ): Promise<SwaggerResponse<UserDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiUsersByIdGet(id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/Users/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {},
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersByIdGet(_response)
      )
    })
  }

  protected processApiUsersByIdGet(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param user (optional)
   * @return Success
   */
  apiUsersByIdPut(
    id: string,
    user?: UserDto | null | undefined
  ): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/api/Users/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(user)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersByIdPut(_response)
      )
    })
  }

  protected processApiUsersByIdPut(
    response: Response
  ): Promise<SwaggerResponse<UserDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param user (optional)
   * @return Success
   */
  apiUserPasswordUpdate(
    id: string,
    user?: UserDto | null | undefined
  ): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/api/Users/{id}/change-password'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(user)

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiPasswordUpdate(_response)
      )
    })
  }

  protected processApiPasswordUpdate(
    response: Response
  ): Promise<SwaggerResponse<UserDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @return Success
   */
  apiUsersByIdDelete(id: string): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/api/Users/{id}'
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersByIdDelete(_response)
      )
    })
  }

  protected processApiUsersByIdDelete(
    response: Response
  ): Promise<SwaggerResponse<UserDto>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto()
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param userId (optional)
   * @param username (optional)
   * @return Success
   */
  apiUsersUsernameAvailableGet(
    userId?: string | null | undefined,
    username?: string | null | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + '/api/Users/username/available?'
    if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&'
    if (username !== undefined)
      url_ += 'username=' + encodeURIComponent('' + username) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersUsernameAvailableGet(_response)
      )
    })
  }

  protected processApiUsersUsernameAvailableGet(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }

  /**
   * @param userId (optional)
   * @param email (optional)
   * @return Success
   */
  apiUsersEmailAvailableGet(
    userId?: string | null | undefined,
    email?: string | null | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + '/api/Users/email/available?'
    if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&'
    if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.transformResult(url_, _response, (_response: Response) =>
        this.processApiUsersEmailAvailableGet(_response)
      )
    })
  }

  protected processApiUsersEmailAvailableGet(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 =
          _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = resultData200 !== undefined ? resultData200 : <any>null
        return new SwaggerResponse(status, _headers, result200)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        )
      })
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, <any>null)
    )
  }
}

export class AppointmentTaskDto implements IAppointmentTaskDto {
  organizationId?: string | undefined
  isActive?: boolean | undefined
  isLocked?: boolean | undefined
  name?: string | undefined
  days?: number | undefined
  displayOrder?: number | undefined
  timing?: string | undefined
  priority?: number | undefined
  priorityName?: string | undefined
  requiresApproval?: boolean | undefined
  authorizationType?: string | undefined
  legacyId?: string | undefined
  componentId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  appointmentTaskType?: number | undefined

  constructor(data?: IAppointmentTaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.organizationId = data['organizationId']
      this.isActive = data['isActive']
      this.isLocked = data['isLocked']
      this.name = data['name']
      this.days = data['days']
      this.displayOrder = data['displayOrder']
      this.timing = data['timing']
      this.priority = data['priority']
      this.priorityName = data['priorityName']
      this.requiresApproval = data['requiresApproval']
      this.authorizationType = data['authorizationType']
      this.legacyId = data['legacyId']
      this.componentId = data['componentId']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.appointmentTaskType = data['appointmentTaskType']
    }
  }

  static fromJS(data: any): AppointmentTaskDto {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentTaskDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['organizationId'] = this.organizationId
    data['isActive'] = this.isActive
    data['isLocked'] = this.isLocked
    data['name'] = this.name
    data['days'] = this.days
    data['displayOrder'] = this.displayOrder
    data['timing'] = this.timing
    data['priority'] = this.priority
    data['priorityName'] = this.priorityName
    data['requiresApproval'] = this.requiresApproval
    data['authorizationType'] = this.authorizationType
    data['legacyId'] = this.legacyId
    data['componentId'] = this.componentId
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['appointmentTaskType'] = this.appointmentTaskType
    return data
  }
}

export interface IAppointmentTaskDto {
  organizationId?: string | undefined
  isActive?: boolean | undefined
  isLocked?: boolean | undefined
  name?: string | undefined
  days?: number | undefined
  displayOrder?: number | undefined
  timing?: string | undefined
  priority?: number | undefined
  priorityName?: string | undefined
  requiresApproval?: boolean | undefined
  authorizationType?: string | undefined
  legacyId?: string | undefined
  componentId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  appointmentTaskType?: number | undefined
}

export class AttachmentFileDto implements IAttachmentFileDto {
  url?: string | undefined
  content?: string | undefined
  mimeType?: string | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IAttachmentFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.url = data['url']
      this.content = data['content']
      this.mimeType = data['mimeType']
      this.isActive = data['isActive']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): AttachmentFileDto {
    data = typeof data === 'object' ? data : {}
    let result = new AttachmentFileDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['url'] = this.url
    data['content'] = this.content
    data['mimeType'] = this.mimeType
    data['isActive'] = this.isActive
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IAttachmentFileDto {
  url?: string | undefined
  content?: string | undefined
  mimeType?: string | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class BodyPartDto implements IBodyPartDto {
  name?: string | undefined
  isActive?: boolean | undefined
  inactiveName?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IBodyPartDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.inactiveName = data['inactiveName']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): BodyPartDto {
    data = typeof data === 'object' ? data : {}
    let result = new BodyPartDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['inactiveName'] = this.inactiveName
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IBodyPartDto {
  name?: string | undefined
  isActive?: boolean | undefined
  inactiveName?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class CheckDto implements ICheckDto {
  amount?: number | undefined
  checkNumber?: string | undefined
  datePaid?: Date | undefined
  billChecks?: BillCheckDto[] | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
  receivedCheck?: boolean | undefined
  payer?: string | undefined

  constructor(data?: ICheckDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.amount = data['amount']
      this.checkNumber = data['checkNumber']
      this.datePaid = data['datePaid']
        ? new Date(data['datePaid'].toString())
        : <any>undefined
      if (data['billChecks'] && data['billChecks'].constructor === Array) {
        this.billChecks = []
        for (let item of data['billChecks'])
          this.billChecks.push(BillCheckDto.fromJS(item))
      }
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isActive = data['isActive']
      this.receivedCheck = data['receivedCheck']
      this.payer = data['payer']
    }
  }

  static fromJS(data: any): CheckDto {
    data = typeof data === 'object' ? data : {}
    let result = new CheckDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['amount'] = this.amount
    data['checkNumber'] = this.checkNumber
    data['datePaid'] = this.datePaid ? this.datePaid.toISOString() : <any>undefined
    if (this.billChecks && this.billChecks.constructor === Array) {
      data['billChecks'] = []
      for (let item of this.billChecks) data['billChecks'].push(item.toJSON())
    }
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isActive'] = this.isActive
    data['receivedCheck'] = this.receivedCheck
    data['payer'] = this.payer
    return data
  }
}

export interface ICheckDto {
  amount?: number | undefined
  checkNumber?: string | undefined
  datePaid?: Date | undefined
  billChecks?: BillCheckDto[] | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
  receivedCheck?: boolean | undefined
  payer?: string | undefined
}

export class BillCheckDto implements IBillCheckDto {
  amount?: number | undefined
  cmS1500Id?: string | undefined
  CMS1500LineItemId?: string | undefined
  checkId?: string | undefined
  check?: CheckDto | undefined
  comments?: string | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined

  constructor(data?: IBillCheckDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.amount = data['amount']
      this.cmS1500Id = data['cmS1500Id']
      this.CMS1500LineItemId = data['CMS1500LineItemId']
      this.checkId = data['checkId']
      this.check = data['check'] ? CheckDto.fromJS(data['check']) : <any>undefined
      this.comments = data['comments']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): BillCheckDto {
    data = typeof data === 'object' ? data : {}
    let result = new BillCheckDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['amount'] = this.amount
    data['cmS1500Id'] = this.cmS1500Id
    data['CMS1500LineItemId'] = this.CMS1500LineItemId
    data['checkId'] = this.checkId
    data['check'] = this.check ? this.check.toJSON() : <any>undefined
    data['comments'] = this.comments
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isActive'] = this.isActive
    return data
  }
}

export interface IBillCheckDto {
  amount?: number | undefined
  cmS1500Id?: string | undefined
  CMS1500LineItemId?: string | undefined
  checkId?: string | undefined
  check?: CheckDto | undefined
  comments?: string | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
}

export class TypeDto implements ITypeDto {
  id?: string | undefined
  name?: string | undefined

  constructor(data?: ITypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.name = data['name']
    }
  }

  static fromJS(data: any): TypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new TypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface ITypeDto {
  id?: string | undefined
  name?: string | undefined
}

export class AddressDto implements IAddressDto {
  id?: string | undefined
  line1?: string | undefined
  line2?: string | undefined
  city?: string | undefined
  state?: string | undefined
  zip?: string | undefined
  phoneNumber?: string | undefined
  faxNumber?: string | undefined
  website?: string | undefined
  email?: string | undefined
  latitude?: number | undefined
  longitude?: number | undefined
  name?: string | undefined
  addressDisplay?: string | undefined

  constructor(data?: IAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.line1 = data['line1']
      this.line2 = data['line2']
      this.city = data['city']
      this.state = data['state']
      this.zip = data['zip']
      this.phoneNumber = data['phoneNumber']
      this.faxNumber = data['faxNumber']
      this.website = data['website']
      this.email = data['email']
      this.latitude = data['latitude']
      this.longitude = data['longitude']
      this.name = data['name']
      this.addressDisplay = data['addressDisplay']
    }
  }

  static fromJS(data: any): AddressDto {
    data = typeof data === 'object' ? data : {}
    let result = new AddressDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['line1'] = this.line1
    data['line2'] = this.line2
    data['city'] = this.city
    data['state'] = this.state
    data['zip'] = this.zip
    data['phoneNumber'] = this.phoneNumber
    data['faxNumber'] = this.faxNumber
    data['website'] = this.website
    data['email'] = this.email
    data['latitude'] = this.latitude
    data['longitude'] = this.longitude
    data['name'] = this.name
    return data
  }
}

export interface IAddressDto {
  id?: string | undefined
  line1?: string | undefined
  line2?: string | undefined
  city?: string | undefined
  state?: string | undefined
  zip?: string | undefined
  phoneNumber?: string | undefined
  faxNumber?: string | undefined
  website?: string | undefined
  email?: string | undefined
  latitude?: number | undefined
  longitude?: number | undefined
  name?: string | undefined
  addressDisplay?: string | undefined
}

export class EpisodeOfCareDto implements IEpisodeOfCareDto {
  name?: string | undefined
  isActive?: boolean | undefined
  referralId?: string | undefined
  referral?: ReferralDto | undefined
  referralDate?: Date | undefined
  referringDoctor?: ReferringDoctorDto | undefined
  referringDoctorName?: string | undefined
  referringDoctorId?: string | undefined
  referringDoctorContact?: ContactDto | undefined
  referringDoctorContactId?: string | undefined
  referralDOI?: Date | undefined
  episodeOfCareNumber?: number | undefined
  episodeOfCareGeneratedNumber?: string | undefined
  episodeOfCareNumberOrLegacyId?: string | undefined
  invoiceStatus?: string | undefined
  effectiveDate?: Date | undefined
  invoiceSurgeryStatus?: string | undefined
  bodyPartText?: string | undefined
  notes?: string | undefined
  abbreviatedNotes?: string | undefined
  cptCodes?: SurgeryCodeDto[] | undefined
  dxCodes?: SurgeryCodeDto[] | undefined
  mri?: string | undefined
  emg?: string | undefined
  xRay?: string | undefined
  ctScan?: string | undefined
  isClinicalNotesReceived?: boolean | undefined
  isPatientOnboarding?: boolean | undefined
  isNoPtToBeScheduled?: boolean | undefined
  careCoordinatorId?: string | undefined
  careCoordinator?: UserDto | undefined
  careCoordinatorName?: string | undefined
  schedules?: ScheduleDto[] | undefined
  quoteId?: string | undefined
  quote?: QuoteDto | undefined
  organizationId?: string | undefined
  organization?: SimpleEntityDto | undefined
  tests?: TestDto[] | undefined
  org?: string | undefined
  calledPatientFlag?: boolean | undefined
  noAnswerFlag?: boolean | undefined
  leftVoicemailFlag?: boolean | undefined
  sentTextFlag?: boolean | undefined
  readyToScheduleFlag?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  claimNotes?: string | undefined
  lightDutyScheduleAppointmentTaskCompletionDate?: Date | undefined
  fullDutyScheduleAppointmentTaskCompletionDate?: Date | undefined
  lightDutyPermanentScheduleAppointmentTaskCompletionDate?: Date | undefined
  unableToWorkScheduleAppointmentTaskCompletionDate?: Date | undefined
  coordinationStatus?: number | undefined

  constructor(data?: IEpisodeOfCareDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.referralId = data['referralId']
      this.referral = data['referral']
        ? ReferralDto.fromJS(data['referral'])
        : <any>undefined
      this.referralDate = data['referralDate']
        ? new Date(data['referralDate'].toString())
        : <any>undefined
      this.referringDoctor = data['referringDoctor']
        ? ReferringDoctorDto.fromJS(data['referringDoctor'])
        : <any>undefined
      this.referringDoctorName = data['referringDoctorName']
      this.referringDoctorId = data['referringDoctorId']
      this.referringDoctorContact = data['referringDoctorContact']
        ? ContactDto.fromJS(data['referringDoctorContact'])
        : <any>undefined
      this.referringDoctorContactId = data['referringDoctorContactId']
      this.referralDOI = data['referralDOI']
        ? new Date(data['referralDOI'].toString())
        : <any>undefined
      this.episodeOfCareNumber = data['episodeOfCareNumber']
      this.episodeOfCareGeneratedNumber = data['episodeOfCareGeneratedNumber']
      this.episodeOfCareNumberOrLegacyId = data['episodeOfCareNumberOrLegacyId']
      this.invoiceStatus = data['invoiceStatus']
      this.effectiveDate = data['effectiveDate']
        ? new Date(data['effectiveDate'].toString())
        : <any>undefined
      this.invoiceSurgeryStatus = data['invoiceSurgeryStatus']
      this.bodyPartText = data['bodyPartText']
      this.notes = data['notes']
      this.abbreviatedNotes = data['abbreviatedNotes']
      if (data['cptCodes'] && data['cptCodes'].constructor === Array) {
        this.cptCodes = []
        for (let item of data['cptCodes']) this.cptCodes.push(SurgeryCodeDto.fromJS(item))
      }
      if (data['dxCodes'] && data['dxCodes'].constructor === Array) {
        this.dxCodes = []
        for (let item of data['dxCodes']) this.dxCodes.push(SurgeryCodeDto.fromJS(item))
      }
      this.mri = data['mri']
      this.emg = data['emg']
      this.xRay = data['xRay']
      this.ctScan = data['ctScan']
      this.isClinicalNotesReceived = data['isClinicalNotesReceived']
      this.isPatientOnboarding = data['isPatientOnboarding']
      this.isNoPtToBeScheduled = data['isNoPtToBeScheduled']
      this.careCoordinatorId = data['careCoordinatorId']
      this.careCoordinator = data['careCoordinator']
        ? UserDto.fromJS(data['careCoordinator'])
        : <any>undefined
      this.careCoordinatorName = data['careCoordinatorName']
      if (data['schedules'] && data['schedules'].constructor === Array) {
        this.schedules = []
        for (let item of data['schedules']) this.schedules.push(ScheduleDto.fromJS(item))
      }
      this.quoteId = data['quoteId']
      this.quote = data['quote'] ? QuoteDto.fromJS(data['quote']) : <any>undefined
      this.organizationId = data['organizationId']
      this.organization = data['organization']
        ? SimpleEntityDto.fromJS(data['organization'])
        : <any>undefined
      if (data['tests'] && data['tests'].constructor === Array) {
        this.tests = []
        for (let item of data['tests']) this.tests.push(TestDto.fromJS(item))
      }
      this.org = data['org']
      this.calledPatientFlag = data['calledPatientFlag']
      this.noAnswerFlag = data['noAnswerFlag']
      this.leftVoicemailFlag = data['leftVoicemailFlag']
      this.sentTextFlag = data['sentTextFlag']
      this.readyToScheduleFlag = data['readyToScheduleFlag']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.claimNotes = data['claimNotes']
      this.lightDutyScheduleAppointmentTaskCompletionDate =
        data['lightDutyScheduleAppointmentTaskCompletionDate']
      this.fullDutyScheduleAppointmentTaskCompletionDate =
        data['fullDutyScheduleAppointmentTaskCompletionDate']
      this.lightDutyPermanentScheduleAppointmentTaskCompletionDate =
        data['lightDutyPermanentScheduleAppointmentTaskCompletionDate']
      this.unableToWorkScheduleAppointmentTaskCompletionDate =
        data['unableToWorkScheduleAppointmentTaskCompletionDate']
      this.coordinationStatus = data['coordinationStatus']
    }
  }

  static fromJS(data: any): EpisodeOfCareDto {
    data = typeof data === 'object' ? data : {}
    let result = new EpisodeOfCareDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['referralId'] = this.referralId
    data['referral'] = this.referral ? this.referral.toJSON() : <any>undefined
    data['referralDate'] = this.referralDate
      ? this.referralDate.toISOString()
      : <any>undefined
    data['referringDoctor'] = this.referringDoctor
      ? this.referringDoctor.toJSON()
      : <any>undefined
    data['referringDoctorName'] = this.referringDoctorName
    data['referringDoctorId'] = this.referringDoctorId
    data['referringDoctorContact'] = this.referringDoctorContact
      ? this.referringDoctorContact.toJSON()
      : <any>undefined
    data['referringDoctorContactId'] = this.referringDoctorContactId
    data['referralDOI'] = this.referralDOI
      ? this.referralDOI.toISOString()
      : <any>undefined
    data['episodeOfCareNumber'] = this.episodeOfCareNumber
    data['episodeOfCareGeneratedNumber'] = this.episodeOfCareGeneratedNumber
    data['episodeOfCareNumberOrLegacyId'] = this.episodeOfCareNumberOrLegacyId
    data['invoiceStatus'] = this.invoiceStatus
    data['effectiveDate'] = this.effectiveDate
      ? this.effectiveDate.toISOString()
      : <any>undefined
    data['invoiceSurgeryStatus'] = this.invoiceSurgeryStatus
    data['bodyPartText'] = this.bodyPartText
    data['notes'] = this.notes
    data['abbreviatedNotes'] = this.abbreviatedNotes
    if (this.cptCodes && this.cptCodes.constructor === Array) {
      data['cptCodes'] = []
      for (let item of this.cptCodes) data['cptCodes'].push(item.toJSON())
    }
    if (this.dxCodes && this.dxCodes.constructor === Array) {
      data['dxCodes'] = []
      for (let item of this.dxCodes) data['dxCodes'].push(item.toJSON())
    }
    data['mri'] = this.mri
    data['emg'] = this.emg
    data['xRay'] = this.xRay
    data['ctScan'] = this.ctScan
    data['isClinicalNotesReceived'] = this.isClinicalNotesReceived
    data['isPatientOnboarding'] = this.isPatientOnboarding
    data['isNoPtToBeScheduled'] = this.isNoPtToBeScheduled
    data['careCoordinatorId'] = this.careCoordinatorId
    data['careCoordinator'] = this.careCoordinator
      ? this.careCoordinator.toJSON()
      : <any>undefined
    data['careCoordinatorName'] = this.careCoordinatorName
    if (this.schedules && this.schedules.constructor === Array) {
      data['schedules'] = []
      for (let item of this.schedules) data['schedules'].push(item.toJSON())
    }
    data['quoteId'] = this.quoteId
    data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined
    data['organizationId'] = this.organizationId
    data['organization'] = this.organization ? this.organization.toJSON() : <any>undefined
    if (this.tests && this.tests.constructor === Array) {
      data['tests'] = []
      for (let item of this.tests) data['tests'].push(item.toJSON())
    }
    data['org'] = this.org
    data['calledPatientFlag'] = this.calledPatientFlag
    data['noAnswerFlag'] = this.noAnswerFlag
    data['leftVoicemailFlag'] = this.leftVoicemailFlag
    data['sentTextFlag'] = this.sentTextFlag
    data['readyToScheduleFlag'] = this.readyToScheduleFlag
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['claimNotes'] = this.claimNotes
    data['lightDutyScheduleAppointmentTaskCompletionDate'] =
      this.lightDutyScheduleAppointmentTaskCompletionDate
    data['fullDutyScheduleAppointmentTaskCompletionDate'] =
      this.fullDutyScheduleAppointmentTaskCompletionDate
    data['lightDutyPermanentScheduleAppointmentTaskCompletionDate'] =
      this.lightDutyPermanentScheduleAppointmentTaskCompletionDate
    data['unableToWorkScheduleAppointmentTaskCompletionDate'] =
      this.unableToWorkScheduleAppointmentTaskCompletionDate
    data['coordinationStatus'] = this.coordinationStatus
    return data
  }
}

export interface IEpisodeOfCareDto {
  name?: string | undefined
  isActive?: boolean | undefined
  referralId?: string | undefined
  referral?: ReferralDto | undefined
  referralDate?: Date | undefined
  referringDoctor?: ReferringDoctorDto | undefined
  referringDoctorName?: string | undefined
  referringDoctorId?: string | undefined
  referringDoctorContact?: ContactDto | undefined
  referringDoctorContactId?: string | undefined
  referralDOI?: Date | undefined
  episodeOfCareNumber?: number | undefined
  episodeOfCareGeneratedNumber?: string | undefined
  episodeOfCareNumberOrLegacyId?: string | undefined
  invoiceStatus?: string | undefined
  effectiveDate?: Date | undefined
  invoiceSurgeryStatus?: string | undefined
  bodyPartText?: string | undefined
  notes?: string | undefined
  abbreviatedNotes?: string | undefined
  cptCodes?: SurgeryCodeDto[] | undefined
  dxCodes?: SurgeryCodeDto[] | undefined
  mri?: string | undefined
  emg?: string | undefined
  xRay?: string | undefined
  ctScan?: string | undefined
  isClinicalNotesReceived?: boolean | undefined
  isPatientOnboarding?: boolean | undefined
  isNoPtToBeScheduled?: boolean | undefined
  careCoordinatorId?: string | undefined
  careCoordinator?: UserDto | undefined
  careCoordinatorName?: string | undefined
  schedules?: ScheduleDto[] | undefined
  quoteId?: string | undefined
  quote?: QuoteDto | undefined
  organizationId?: string | undefined
  organization?: SimpleEntityDto | undefined
  tests?: TestDto[] | undefined
  org?: string | undefined
  calledPatientFlag?: boolean | undefined
  noAnswerFlag?: boolean | undefined
  leftVoicemailFlag?: boolean | undefined
  sentTextFlag?: boolean | undefined
  readyToScheduleFlag?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  claimNotes?: string | undefined
  menuReplacer?: JSX.Element | undefined
  lightDutyScheduleAppointmentTaskCompletionDate?: Date | undefined
  fullDutyScheduleAppointmentTaskCompletionDate?: Date | undefined
  lightDutyPermanentScheduleAppointmentTaskCompletionDate?: Date | undefined
  unableToWorkScheduleAppointmentTaskCompletionDate?: Date | undefined
  coordinationStatus?: number | undefined
}

export class ProviderDto implements IProviderDto {
  organizationId?: string | undefined
  name?: string | undefined
  providerTypes?: ProviderTypeDto[] | undefined
  legalName?: string | undefined
  billingServicer?: string | undefined
  physicalAddress?: AddressDto | undefined
  displayStreetAddress?: string | undefined
  displayCity?: string | undefined
  displayState?: string | undefined
  displayZip?: string | undefined
  displayPhone?: string | undefined
  billingAddress?: AddressDto | undefined
  ccn?: string | undefined
  isSingleLocation?: boolean | undefined
  npiNumber?: string | undefined
  locationCount?: number | undefined
  physicianCount?: number | undefined
  contractCount?: number | undefined
  contracts?: ContractDto[] | undefined
  communicationCount?: number | undefined
  paymentTierInDays?: number | undefined
  providerTags?: TagDto[] | undefined
  displayTags?: TagDto[] | undefined
  isActive?: boolean | undefined
  cmS1500s?: CMS1500Dto[] | undefined
  legacyId?: string | undefined
  requiresSingleCaseAgreement?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  contractLink?: string | undefined
  contractSummary?: string | undefined
  notes?: string | undefined

  constructor(data?: IProviderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.organizationId = data['organizationId']
      this.name = data['name']
      if (data['providerTypes'] && data['providerTypes'].constructor === Array) {
        this.providerTypes = []
        for (let item of data['providerTypes'])
          this.providerTypes.push(ProviderTypeDto.fromJS(item))
      }
      this.legalName = data['legalName']
      this.billingServicer = data['billingServicer']
      this.physicalAddress = data['physicalAddress']
        ? AddressDto.fromJS(data['physicalAddress'])
        : <any>undefined
      this.displayStreetAddress = data['displayStreetAddress']
      this.displayCity = data['displayCity']
      this.displayState = data['displayState']
      this.displayZip = data['displayZip']
      this.displayPhone = data['displayPhone']
      this.billingAddress = data['billingAddress']
        ? AddressDto.fromJS(data['billingAddress'])
        : <any>undefined
      this.ccn = data['ccn']
      this.isSingleLocation = data['isSingleLocation']
      this.npiNumber = data['npiNumber']
      this.paymentTierInDays = data['paymentTierInDays']
      this.locationCount = data['locationCount']
      this.physicianCount = data['physicianCount']
      this.contractCount = data['contractCount']
      if (data['contracts'] && data['contracts'].constructor === Array) {
        this.contracts = []
        for (let item of data['contracts']) this.contracts.push(ContractDto.fromJS(item))
      }
      this.communicationCount = data['communicationCount']
      if (data['providerTags'] && data['providerTags'].constructor === Array) {
        this.providerTags = []
        for (let item of data['providerTags']) this.providerTags.push(TagDto.fromJS(item))
      }
      if (data['displayTags'] && data['displayTags'].constructor === Array) {
        this.displayTags = []
        for (let item of data['displayTags']) this.displayTags.push(TagDto.fromJS(item))
      }
      this.isActive = data['isActive']
      if (data['cmS1500s'] && data['cmS1500s'].constructor === Array) {
        this.cmS1500s = []
        for (let item of data['cmS1500s']) this.cmS1500s.push(CMS1500Dto.fromJS(item))
      }
      this.legacyId = data['legacyId']
      this.requiresSingleCaseAgreement = data['requiresSingleCaseAgreement']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.contractLink = data['contractLink']
      this.contractSummary = data['contractSummary']
      this.notes = data['notes']
    }
  }

  static fromJS(data: any): ProviderDto {
    data = typeof data === 'object' ? data : {}
    let result = new ProviderDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['organizationId'] = this.organizationId
    data['name'] = this.name
    if (this.providerTypes && this.providerTypes.constructor === Array) {
      data['providerTypes'] = []
      for (let item of this.providerTypes) data['providerTypes'].push(item.toJSON())
    }
    data['legalName'] = this.legalName
    data['billingServicer'] = this.billingServicer
    data['physicalAddress'] = this.physicalAddress
      ? this.physicalAddress.toJSON()
      : <any>undefined
    data['displayStreetAddress'] = this.displayStreetAddress
    data['displayCity'] = this.displayCity
    data['displayState'] = this.displayState
    data['displayZip'] = this.displayZip
    data['displayPhone'] = this.displayPhone
    data['billingAddress'] = this.billingAddress
      ? this.billingAddress.toJSON()
      : <any>undefined
    data['ccn'] = this.ccn
    data['isSingleLocation'] = this.isSingleLocation
    data['npiNumber'] = this.npiNumber
    data['paymentTierInDays'] = this.paymentTierInDays
    data['locationCount'] = this.locationCount
    data['physicianCount'] = this.physicianCount
    data['contractCount'] = this.contractCount
    if (this.contracts && this.contracts.constructor === Array) {
      data['contracts'] = []
      for (let item of this.contracts) data['contracts'].push(item.toJSON())
    }
    data['communicationCount'] = this.communicationCount
    if (this.providerTags && this.providerTags.constructor === Array) {
      data['providerTags'] = []
      for (let item of this.providerTags) data['providerTags'].push(item.toJSON())
    }
    if (this.displayTags && this.displayTags.constructor === Array) {
      data['displayTags'] = []
      for (let item of this.displayTags) data['displayTags'].push(item.toJSON())
    }
    data['isActive'] = this.isActive
    if (this.cmS1500s && this.cmS1500s.constructor === Array) {
      data['cmS1500s'] = []
      for (let item of this.cmS1500s) data['cmS1500s'].push(item.toJSON())
    }
    data['legacyId'] = this.legacyId
    data['requiresSingleCaseAgreement'] = this.requiresSingleCaseAgreement
    data['id'] = this.id
    data['createdOn'] = this.createdOn
      ? new Date(this.createdOn).toISOString()
      : <any>undefined
    data['modifiedOn'] = this.modifiedOn
      ? new Date(this.modifiedOn).toISOString()
      : <any>undefined
    data['deletedOn'] = this.deletedOn
      ? new Date(this.deletedOn).toISOString()
      : <any>undefined
    data['contractLink'] = this.contractLink
    data['contractSummary'] = this.contractSummary
    data['notes'] = this.notes
    return data
  }
}

export interface IProviderDto {
  organizationId?: string | undefined
  name?: string | undefined
  providerTypes?: ProviderTypeDto[] | undefined
  legalName?: string | undefined
  billingServicer?: string | undefined
  physicalAddress?: AddressDto | undefined
  displayStreetAddress?: string | undefined
  displayCity?: string | undefined
  displayState?: string | undefined
  displayZip?: string | undefined
  displayPhone?: string | undefined
  billingAddress?: AddressDto | undefined
  ccn?: string | undefined
  isSingleLocation?: boolean | undefined
  npiNumber?: string | undefined
  paymentTierInDays?: number | undefined
  locationCount?: number | undefined
  physicianCount?: number | undefined
  contractCount?: number | undefined
  contracts?: ContractDto[] | undefined
  communicationCount?: number | undefined
  providerTags?: TagDto[] | undefined
  displayTags?: TagDto[] | undefined
  isActive?: boolean | undefined
  cmS1500s?: CMS1500Dto[] | undefined
  legacyId?: string | undefined
  requiresSingleCaseAgreement?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  contractLink?: string | undefined
  contractSummary?: string | undefined
  notes?: string | undefined
}

export class ClaimEventDto implements IClaimEventDto {
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  locationId?: string | undefined
  location?: LocationDto | undefined
  testId?: string | undefined
  test?: TestDto | undefined
  cmS1500Id?: string | undefined
  cmS1500?: CMS1500Dto | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined

  constructor(data?: IClaimEventDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.scheduleId = data['scheduleId']
      this.schedule = data['schedule']
        ? ScheduleDto.fromJS(data['schedule'])
        : <any>undefined
      this.locationId = data['locationId']
      this.location = data['location']
        ? LocationDto.fromJS(data['location'])
        : <any>undefined
      this.testId = data['testId']
      this.test = data['test'] ? TestDto.fromJS(data['test']) : <any>undefined
      this.cmS1500Id = data['cmS1500Id']
      this.cmS1500 = data['cmS1500'] ? CMS1500Dto.fromJS(data['cmS1500']) : <any>undefined
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): ClaimEventDto {
    data = typeof data === 'object' ? data : {}
    let result = new ClaimEventDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['scheduleId'] = this.scheduleId
    data['schedule'] = this.schedule ? this.schedule.toJSON() : <any>undefined
    data['locationId'] = this.locationId
    data['location'] = this.location ? this.location.toJSON() : <any>undefined
    data['testId'] = this.testId
    data['test'] = this.test ? this.test.toJSON() : <any>undefined
    data['cmS1500Id'] = this.cmS1500Id
    data['cmS1500'] = this.cmS1500 ? this.cmS1500.toJSON() : <any>undefined
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isActive'] = this.isActive
    return data
  }
}

export interface IClaimEventDto {
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  locationId?: string | undefined
  location?: LocationDto | undefined
  testId?: string | undefined
  test?: TestDto | undefined
  cmS1500Id?: string | undefined
  cmS1500?: CMS1500Dto | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
}

export class ReferralDto implements IReferralDto {
  name?: string | undefined
  isActive?: boolean | undefined
  patientId?: string | undefined
  patient?: PatientDto | undefined
  patientIdNumber?: string | undefined
  doi?: Date | undefined
  referralDate?: Date | undefined
  referralTime?: string | undefined
  employer?: EmployerDto | undefined
  employerId?: string | undefined
  employerContact?: ContactDto | undefined
  employerContactId?: string | undefined
  occupation?: string | undefined
  insuranceCompany?: InsuranceCompanyDto | undefined
  insuranceCompanyId?: string | undefined
  insuranceCompanyContact?: ContactDto | undefined
  insuranceCompanyContactId?: string | undefined
  additionalInsuranceContacts?: ReferralContactDTO[] | undefined
  additionalNCMContacts?: ReferralContactDTO[] | undefined
  nurseCaseManager?: NurseCaseManagerDto | undefined
  nurseCaseManagerId?: string | undefined
  nurseCaseManagerContact?: ContactDto | undefined
  nurseCaseManagerContactId?: string | undefined
  referralCaller?: string | undefined
  claimNumber?: string | undefined
  health?: boolean | undefined
  initials?: string | undefined
  episodesOfCare?: EpisodeOfCareDto[] | undefined
  patientName?: string | undefined
  episodeOfCareNumber?: number | undefined
  dateOfBirth?: Date | undefined
  appointmentTask?: string | undefined
  careCoordinator?: string | undefined
  dueDate?: Date | undefined
  overdue?: string | undefined
  episodeOfCareIdForPatientFlow?: string | undefined
  scheduleIdForPatientFlow?: string | undefined
  scheduleAppointmentTaskForPatientFlow?: ScheduleAppointmentTaskDto | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IReferralDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.patientId = data['patientId']
      this.patient = data['patient'] ? PatientDto.fromJS(data['patient']) : <any>undefined
      this.patientIdNumber = data['patientIdNumber']
      this.doi = data['doi'] ? new Date(data['doi'].toString()) : <any>undefined
      this.referralDate = data['referralDate']
        ? new Date(data['referralDate'].toString())
        : <any>undefined
      this.referralTime = data['referralTime']
      this.employer = data['employer']
        ? EmployerDto.fromJS(data['employer'])
        : <any>undefined
      this.employerId = data['employerId']
      this.employerContact = data['employerContact']
        ? ContactDto.fromJS(data['employerContact'])
        : <any>undefined
      this.employerContactId = data['employerContactId']
      this.occupation = data['occupation']
      this.insuranceCompany = data['insuranceCompany']
        ? InsuranceCompanyDto.fromJS(data['insuranceCompany'])
        : <any>undefined
      this.insuranceCompanyId = data['insuranceCompanyId']
      this.insuranceCompanyContact = data['insuranceCompanyContact']
        ? ContactDto.fromJS(data['insuranceCompanyContact'])
        : <any>undefined
      this.insuranceCompanyContactId = data['insuranceCompanyContactId']
      this.additionalInsuranceContacts = data['additionalInsuranceContacts']
      this.additionalNCMContacts = data['additionalNCMContacts']
      this.nurseCaseManager = data['nurseCaseManager']
        ? NurseCaseManagerDto.fromJS(data['nurseCaseManager'])
        : <any>undefined
      this.nurseCaseManagerId = data['nurseCaseManagerId']
      this.nurseCaseManagerContact = data['nurseCaseManagerContact']
        ? ContactDto.fromJS(data['nurseCaseManagerContact'])
        : <any>undefined
      this.nurseCaseManagerContactId = data['nurseCaseManagerContactId']
      this.referralCaller = data['referralCaller']
      this.claimNumber = data['claimNumber']
      this.health = data['health']
      this.initials = data['initials']
      if (data['episodesOfCare'] && data['episodesOfCare'].constructor === Array) {
        this.episodesOfCare = []
        for (let item of data['episodesOfCare'])
          this.episodesOfCare.push(EpisodeOfCareDto.fromJS(item))
      }
      this.patientName = data['patientName']
      this.episodeOfCareNumber = data['episodeOfCareNumber']
      this.dateOfBirth = data['dateOfBirth']
        ? new Date(data['dateOfBirth'].toString())
        : <any>undefined
      this.appointmentTask = data['appointmentTask']
      this.careCoordinator = data['careCoordinator']
      this.dueDate = data['dueDate']
        ? new Date(data['dueDate'].toString())
        : <any>undefined
      this.overdue = data['overdue']
      this.episodeOfCareIdForPatientFlow = data['episodeOfCareIdForPatientFlow']
      this.scheduleIdForPatientFlow = data['scheduleIdForPatientFlow']
      this.scheduleAppointmentTaskForPatientFlow = data[
        'scheduleAppointmentTaskForPatientFlow'
      ]
        ? ScheduleAppointmentTaskDto.fromJS(data['scheduleAppointmentTaskForPatientFlow'])
        : <any>undefined
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ReferralDto {
    data = typeof data === 'object' ? data : {}
    let result = new ReferralDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['patientId'] = this.patientId
    data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined
    data['patientIdNumber'] = this.patientIdNumber
    data['doi'] = this.doi ? this.doi.toISOString() : <any>undefined
    data['referralDate'] = this.referralDate
      ? this.referralDate.toISOString()
      : <any>undefined
    data['referralTime'] = this.referralTime
    data['employer'] = this.employer ? this.employer.toJSON() : <any>undefined
    data['employerId'] = this.employerId
    data['employerContact'] = this.employerContact
      ? this.employerContact.toJSON()
      : <any>undefined
    data['employerContactId'] = this.employerContactId
    data['additionalInsuranceContacts'] = this.additionalInsuranceContacts
    data['additionalNCMContacts'] = this.additionalNCMContacts
    data['occupation'] = this.occupation
    data['insuranceCompany'] = this.insuranceCompany
      ? this.insuranceCompany.toJSON()
      : <any>undefined
    data['insuranceCompanyId'] = this.insuranceCompanyId
    data['insuranceCompanyContact'] = this.insuranceCompanyContact
      ? this.insuranceCompanyContact.toJSON()
      : <any>undefined
    data['insuranceCompanyContactId'] = this.insuranceCompanyContactId
    data['nurseCaseManager'] = this.nurseCaseManager
      ? this.nurseCaseManager.toJSON()
      : <any>undefined
    data['nurseCaseManagerId'] = this.nurseCaseManagerId
    data['nurseCaseManagerContact'] = this.nurseCaseManagerContact
      ? this.nurseCaseManagerContact.toJSON()
      : <any>undefined
    data['nurseCaseManagerContactId'] = this.nurseCaseManagerContactId
    data['referralCaller'] = this.referralCaller
    data['claimNumber'] = this.claimNumber
    data['health'] = this.health
    data['initials'] = this.initials
    if (this.episodesOfCare && this.episodesOfCare.constructor === Array) {
      data['episodesOfCare'] = []
      for (let item of this.episodesOfCare) data['episodesOfCare'].push(item.toJSON())
    }
    data['patientName'] = this.patientName
    data['episodeOfCareNumber'] = this.episodeOfCareNumber
    data['dateOfBirth'] = this.dateOfBirth
      ? this.dateOfBirth.toISOString()
      : <any>undefined
    data['appointmentTask'] = this.appointmentTask
    data['careCoordinator'] = this.careCoordinator
    data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined
    data['overdue'] = this.overdue
    data['episodeOfCareIdForPatientFlow'] = this.episodeOfCareIdForPatientFlow
    data['scheduleIdForPatientFlow'] = this.scheduleIdForPatientFlow
    data['scheduleAppointmentTaskForPatientFlow'] = this
      .scheduleAppointmentTaskForPatientFlow
      ? this.scheduleAppointmentTaskForPatientFlow.toJSON()
      : <any>undefined
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IReferralDto {
  name?: string | undefined
  isActive?: boolean | undefined
  patientId?: string | undefined
  patient?: PatientDto | undefined
  patientIdNumber?: string | undefined
  doi?: Date | undefined
  referralDate?: Date | undefined
  referralTime?: string | undefined
  employer?: EmployerDto | undefined
  employerId?: string | undefined
  employerContact?: ContactDto | undefined
  employerContactId?: string | undefined
  occupation?: string | undefined
  insuranceCompany?: InsuranceCompanyDto | undefined
  insuranceCompanyId?: string | undefined
  insuranceCompanyContact?: ContactDto | undefined
  insuranceCompanyContactId?: string | undefined
  additionalInsuranceContacts?: ReferralContactDTO[] | undefined
  additionalNCMContacts?: ReferralContactDTO[] | undefined
  nurseCaseManager?: NurseCaseManagerDto | undefined
  nurseCaseManagerId?: string | undefined
  nurseCaseManagerContact?: ContactDto | undefined
  nurseCaseManagerContactId?: string | undefined
  referralCaller?: string | undefined
  claimNumber?: string | undefined
  health?: boolean | undefined
  initials?: string | undefined
  episodesOfCare?: EpisodeOfCareDto[] | undefined
  patientName?: string | undefined
  episodeOfCareNumber?: number | undefined
  dateOfBirth?: Date | undefined
  appointmentTask?: string | undefined
  careCoordinator?: string | undefined
  dueDate?: Date | undefined
  overdue?: string | undefined
  episodeOfCareIdForPatientFlow?: string | undefined
  scheduleIdForPatientFlow?: string | undefined
  scheduleAppointmentTaskForPatientFlow?: ScheduleAppointmentTaskDto | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  menuReplacer?: JSX.Element | undefined
}

export class ReferringDoctorDto implements IReferringDoctorDto {
  name?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  suffix?: string | undefined
  npi?: string | undefined
  address?: AddressDto | undefined
  phoneNumber?: string | undefined
  faxNumber?: string | undefined
  preferences?: string | undefined
  contacts?: ContactDto[] | undefined
  isActive?: boolean | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IReferringDoctorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.firstName = data['firstName']
      this.lastName = data['lastName']
      this.suffix = data['suffix']
      this.npi = data['npi']
      this.address = data['address'] ? AddressDto.fromJS(data['address']) : <any>undefined
      this.phoneNumber = data['phoneNumber']
      this.faxNumber = data['faxNumber']
      this.preferences = data['preferences']
      this.contacts = []
      if (data['contacts'] && data['contacts'].constructor === Array) {
        for (let item of data['contacts']) this.contacts.push(ContactDto.fromJS(item))
      }
      this.isActive = data['isActive']
      this.legacyId = data['legacyId']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ReferringDoctorDto {
    data = typeof data === 'object' ? data : {}
    let result = new ReferringDoctorDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['suffix'] = this.suffix
    data['npi'] = this.npi
    data['address'] = this.address ? this.address.toJSON() : <any>undefined
    data['phoneNumber'] = this.phoneNumber
    data['faxNumber'] = this.faxNumber
    data['preferences'] = this.preferences
    data['contacts'] = []
    if (this.contacts && this.contacts.constructor === Array) {
      for (let item of this.contacts) data['contacts'].push(item.toJSON())
    }
    data['isActive'] = this.isActive
    data['legacyId'] = this.legacyId
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IReferringDoctorDto {
  name?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  suffix?: string | undefined
  npi?: string | undefined
  address?: AddressDto | undefined
  phoneNumber?: string | undefined
  faxNumber?: string | undefined
  preferences?: string | undefined
  contacts?: ContactDto[] | undefined
  isActive?: boolean | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class ContactDto implements IContactDto {
  name?: string | undefined
  isActive?: boolean | undefined
  dateIncentiveGiven?: Date | undefined
  providerId?: string | undefined
  insuranceCompanyId?: string | undefined
  insuranceCompany?: InsuranceCompanyDto | undefined
  referringDoctorId?: string | undefined
  nurseCaseManagerId?: string | undefined
  nurseCaseManager?: NurseCaseManagerDto | undefined
  title?: string | undefined
  email?: string | undefined
  contactType?: string | undefined
  comments?: string | undefined
  isSpecialPricing?: boolean | undefined
  isCostSavingsReport?: boolean | undefined
  contactTags?: TagDto[] | undefined
  displayTags?: TagDto[] | undefined
  importantTags?: string[] | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  suffix?: string | undefined
  cellNumber?: string | undefined
  officeNumber?: string | undefined
  faxNumber?: string | undefined
  employerId?: string | undefined
  directNumber?: string | undefined
  tollFreeNumber?: string | undefined
  phoneExtension?: string | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.dateIncentiveGiven = data['dateIncentiveGiven']
        ? new Date(data['dateIncentiveGiven'].toString())
        : <any>undefined
      this.providerId = data['providerId']
      this.insuranceCompanyId = data['insuranceCompanyId']
      this.insuranceCompany = data['insuranceCompany']
        ? InsuranceCompanyDto.fromJS(data['insuranceCompany'])
        : <any>undefined
      this.referringDoctorId = data['referringDoctorId']
      this.nurseCaseManagerId = data['nurseCaseManagerId']
      this.nurseCaseManager = data['nurseCaseManager']
        ? NurseCaseManagerDto.fromJS(data['nurseCaseManager'])
        : <any>undefined
      this.title = data['title']
      this.email = data['email']
      this.contactType = data['contactType']
      this.comments = data['comments']
      this.isSpecialPricing = data['isSpecialPricing']
      this.isCostSavingsReport = data['isCostSavingsReport']
      this.contactTags = []
      if (data['contactTags'] && data['contactTags'].constructor === Array) {
        for (let item of data['tags']) this.contactTags.push(TagDto.fromJS(item))
      }
      if (data['displayTags'] && data['displayTags'].constructor === Array) {
        this.displayTags = []
        for (let item of data['displayTags']) this.displayTags.push(TagDto.fromJS(item))
      }
      if (data['importantTags'] && data['importantTags'].constructor === Array) {
        this.importantTags = []
        for (let item of data['importantTags']) this.importantTags.push(item)
      }
      this.firstName = data['firstName']
      this.lastName = data['lastName']
      this.suffix = data['suffix']
      this.cellNumber = data['cellNumber']
      this.officeNumber = data['officeNumber']
      this.faxNumber = data['faxNumber']
      this.employerId = data['employerId']
      this.directNumber = data['directNumber']
      this.tollFreeNumber = data['tollFreeNumber']
      this.phoneExtension = data['phoneExtension']
      this.legacyId = data['legacyId']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ContactDto {
    data = typeof data === 'object' ? data : {}
    let result = new ContactDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['dateIncentiveGiven'] = this.dateIncentiveGiven
      ? this.dateIncentiveGiven.toISOString()
      : <any>undefined
    data['providerId'] = this.providerId
    data['insuranceCompanyId'] = this.insuranceCompanyId
    data['insuranceCompany'] = this.insuranceCompany
      ? this.insuranceCompany.toJSON()
      : <any>undefined
    data['referringDoctorId'] = this.referringDoctorId
    data['nurseCaseManagerId'] = this.nurseCaseManagerId
    data['nurseCaseManager'] = this.nurseCaseManager
      ? this.nurseCaseManager.toJSON()
      : <any>undefined
    data['title'] = this.title
    data['email'] = this.email
    data['contactType'] = this.contactType
    data['comments'] = this.comments
    data['isSpecialPricing'] = this.isSpecialPricing
    data['isCostSavingsReport'] = this.isCostSavingsReport
    if (this.contactTags && this.contactTags.constructor === Array) {
      data['contactTags'] = []
      for (let item of this.contactTags) data['contactTags'].push(item.toJSON())
    }
    if (this.displayTags && this.displayTags.constructor === Array) {
      data['displayTags'] = []
      for (let item of this.displayTags) data['displayTags'].push(item.toJSON())
    }
    if (this.importantTags && this.importantTags.constructor === Array) {
      data['importantTags'] = []
      for (let item of this.importantTags) data['importantTags'].push(item)
    }
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['suffix'] = this.suffix
    data['cellNumber'] = this.cellNumber
    data['officeNumber'] = this.officeNumber
    data['faxNumber'] = this.faxNumber
    data['employerId'] = this.employerId
    data['directNumber'] = this.directNumber
    data['tollFreeNumber'] = this.tollFreeNumber
    data['phoneExtension'] = this.phoneExtension
    data['legacyId'] = this.legacyId
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IContactDto {
  name?: string | undefined
  isActive?: boolean | undefined
  dateIncentiveGiven?: Date | undefined
  providerId?: string | undefined
  insuranceCompanyId?: string | undefined
  insuranceCompany?: InsuranceCompanyDto | undefined
  referringDoctorId?: string | undefined
  nurseCaseManagerId?: string | undefined
  nurseCaseManager?: NurseCaseManagerDto | undefined
  title?: string | undefined
  email?: string | undefined
  contactType?: string | undefined
  comments?: string | undefined
  isSpecialPricing?: boolean | undefined
  isCostSavingsReport?: boolean | undefined
  contactTags?: TagDto[] | undefined
  displayTags?: TagDto[] | undefined
  importantTags?: string[] | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  suffix?: string | undefined
  cellNumber?: string | undefined
  officeNumber?: string | undefined
  faxNumber?: string | undefined
  employerId?: string | undefined
  directNumber?: string | undefined
  tollFreeNumber?: string | undefined
  phoneExtension?: string | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class SurgeryCodeDto implements ISurgeryCodeDto {
  id?: string | undefined
  priority?: number | undefined
  code?: string | undefined

  constructor(data?: ISurgeryCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.priority = data['priority']
      this.code = data['code']
    }
  }

  static fromJS(data: any): SurgeryCodeDto {
    data = typeof data === 'object' ? data : {}
    let result = new SurgeryCodeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['priority'] = this.priority
    data['code'] = this.code
    return data
  }
}

export interface ISurgeryCodeDto {
  id?: string | undefined
  priority?: number | undefined
  code?: string | undefined
}

export class UserDto implements IUserDto {
  profileImageUrl?: string | undefined
  profileImageMimeType?: string | undefined
  profileImageName?: string | undefined
  profileImageContent?: string | undefined
  name?: string | undefined
  userName?: string | undefined
  oldPassword?: string | undefined
  password?: string | undefined
  daysUntilPasswordExpires?: number | undefined
  showPasswordExpirationWarning?: boolean | undefined
  jobTitle?: string | undefined
  phoneNumber?: string | undefined
  directNumber?: string | undefined
  tollFreeNumber?: string | undefined
  phoneExtension?: string | undefined
  address?: string | undefined
  city?: string | undefined
  state?: string | undefined
  zipCode?: string | undefined
  deactivatedOn?: Date | undefined
  organizationId?: string | undefined
  organization?: SimpleEntityDto | undefined
  roles?: string[] | undefined
  isLocked?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  email?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  isActive?: boolean | undefined

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.profileImageUrl = data['profileImageUrl']
      this.profileImageMimeType = data['profileImageMimeType']
      this.profileImageName = data['profileImageName']
      this.profileImageContent = data['profileImageContent']
      this.name = data['name']
      this.userName = data['userName']
      this.oldPassword = data['oldPassword']
      this.password = data['password']
      this.daysUntilPasswordExpires = data['daysUntilPasswordExpires']
      this.showPasswordExpirationWarning = data['showPasswordExpirationWarning']
      this.jobTitle = data['jobTitle']
      this.phoneNumber = data['phoneNumber']
      this.directNumber = data['directNumber']
      this.tollFreeNumber = data['tollFreeNumber']
      this.phoneExtension = data['phoneExtension']
      this.address = data['address']
      this.city = data['city']
      this.state = data['state']
      this.zipCode = data['zipCode']
      this.deactivatedOn = data['deactivatedOn']
        ? new Date(data['deactivatedOn'].toString())
        : <any>undefined
      this.organizationId = data['organizationId']
      this.organization = data['organization']
        ? SimpleEntityDto.fromJS(data['organization'])
        : <any>undefined
      if (data['roles'] && data['roles'].constructor === Array) {
        this.roles = []
        for (let item of data['roles']) this.roles.push(item)
      }
      this.isLocked = data['isLocked']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.email = data['email']
      this.firstName = data['firstName']
      this.lastName = data['lastName']
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === 'object' ? data : {}
    let result = new UserDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['profileImageUrl'] = this.profileImageUrl
    data['profileImageMimeType'] = this.profileImageMimeType
    data['profileImageName'] = this.profileImageName
    data['profileImageContent'] = this.profileImageContent
    data['name'] = this.name
    data['userName'] = this.userName
    data['oldPassword'] = this.oldPassword
    data['password'] = this.password
    data['daysUntilPasswordExpires'] = this.daysUntilPasswordExpires
    data['showPasswordExpirationWarning'] = this.showPasswordExpirationWarning
    data['jobTitle'] = this.jobTitle
    data['phoneNumber'] = this.phoneNumber
    data['directNumber'] = this.directNumber
    data['tollFreeNumber'] = this.tollFreeNumber
    data['phoneExtension'] = this.phoneExtension
    data['address'] = this.address
    data['city'] = this.city
    data['state'] = this.state
    data['zipCode'] = this.zipCode
    data['deactivatedOn'] = this.deactivatedOn
      ? this.deactivatedOn.toISOString()
      : <any>undefined
    data['organizationId'] = this.organizationId
    data['organization'] = this.organization ? this.organization.toJSON() : <any>undefined
    if (this.roles && this.roles.constructor === Array) {
      data['roles'] = []
      for (let item of this.roles) data['roles'].push(item)
    }
    data['isLocked'] = this.isLocked
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['email'] = this.email
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['isActive'] = this.isActive
    return data
  }
}

export interface IUserDto {
  profileImageUrl?: string | undefined
  profileImageMimeType?: string | undefined
  profileImageName?: string | undefined
  profileImageContent?: string | undefined
  name?: string | undefined
  userName?: string | undefined
  oldPassword?: string | undefined
  password?: string | undefined
  daysUntilPasswordExpires?: number | undefined
  showPasswordExpirationWarning?: boolean | undefined
  jobTitle?: string | undefined
  phoneNumber?: string | undefined
  directNumber?: string | undefined
  tollFreeNumber?: string | undefined
  phoneExtension?: string | undefined
  address?: string | undefined
  city?: string | undefined
  state?: string | undefined
  zipCode?: string | undefined
  deactivatedOn?: Date | undefined
  organizationId?: string | undefined
  organization?: SimpleEntityDto | undefined
  roles?: string[] | undefined
  isLocked?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  email?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  isActive?: boolean | undefined
}

export class QuoteDto implements IQuoteDto {
  preCertNumber?: string | undefined
  patientName?: string | undefined
  patientIdNumber?: string | undefined
  patientFirstName?: string | undefined
  patientLastName?: string | undefined
  name?: string | undefined
  surgeryDate?: Date | undefined
  bodyPartName?: string | undefined
  episodeOfCareId?: string | undefined
  episodeOfCare?: EpisodeOfCareDto | undefined
  episodeOfCareStatus?: string | undefined
  dateOfBirth?: Date | undefined
  episodeOfCareNumber?: number | undefined
  note?: string | undefined
  targetMargin?: number | undefined
  daysSinceSurgery?: string | undefined
  adjustedCost?: number | undefined
  professionalComponentStatus?: string | undefined
  technicalComponentStatus?: string | undefined
  anesthesiaStatus?: string | undefined
  physicalTherapyStatus?: string | undefined
  isAdjustedCostOverridden?: boolean | undefined
  adjustedCostOverriddenBy?: string | undefined
  adjustedCostOverriddenOn?: Date | undefined
  status?: QuoteStatus | undefined
  type?: QuoteType | undefined
  statusName?: string | undefined
  professionalComponentLineItems?: ProfessionalComponentLineItemDto[] | undefined
  technicalComponentLineItems?: TechnicalComponentLineItemDto[] | undefined
  anesthesiaLineItems?: AnesthesiaLineItemDto[] | undefined
  physicalTherapyLineItems?: PhysicalTherapyLineItemDto[] | undefined
  miscellaneousLineItems?: MiscellaneousLineItemDto[] | undefined
  isActive?: boolean | undefined
  globalInvoiceId?: string | undefined
  globalInvoice?: CMS1500Dto | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  endDate?: Date | undefined
  bundleDurationDays?: number

  constructor(data?: IQuoteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.preCertNumber = data['preCertNumber']
      this.patientName = data['patientName']
      this.patientIdNumber = data['patientIdNumber']
      this.patientFirstName = data['patientFirstName']
      this.patientLastName = data['patientLastName']
      this.name = data['name']
      this.surgeryDate = data['surgeryDate']
        ? new Date(data['surgeryDate'].toString())
        : <any>undefined
      this.bodyPartName = data['bodyPartName']
      this.episodeOfCareId = data['episodeOfCareId']
      this.episodeOfCare = data['episodeOfCare']
        ? EpisodeOfCareDto.fromJS(data['episodeOfCare'])
        : <any>undefined
      this.episodeOfCareStatus = data['episodeOfCareStatus']
      this.dateOfBirth = data['dateOfBirth']
        ? new Date(data['dateOfBirth'].toString())
        : <any>undefined
      this.episodeOfCareNumber = data['episodeOfCareNumber']
      this.note = data['note']
      this.targetMargin = data['targetMargin']
      this.daysSinceSurgery = data['daysSinceSurgery']
      this.adjustedCost = data['adjustedCost']
      this.professionalComponentStatus = data['professionalComponentStatus']
      this.technicalComponentStatus = data['technicalComponentStatus']
      this.anesthesiaStatus = data['anesthesiaStatus']
      this.physicalTherapyStatus = data['physicalTherapyStatus']
      this.isAdjustedCostOverridden = data['isAdjustedCostOverridden']
      this.adjustedCostOverriddenBy = data['adjustedCostOverriddenBy']
      this.adjustedCostOverriddenOn = data['adjustedCostOverriddenOn']
        ? new Date(data['adjustedCostOverriddenOn'].toString())
        : <any>undefined
      this.status = data['status']
      this.type = data['type']
      this.statusName = data['statusName']
      if (
        data['professionalComponentLineItems'] &&
        data['professionalComponentLineItems'].constructor === Array
      ) {
        this.professionalComponentLineItems = []
        for (let item of data['professionalComponentLineItems'])
          this.professionalComponentLineItems.push(
            ProfessionalComponentLineItemDto.fromJS(item)
          )
      }
      if (
        data['technicalComponentLineItems'] &&
        data['technicalComponentLineItems'].constructor === Array
      ) {
        this.technicalComponentLineItems = []
        for (let item of data['technicalComponentLineItems'])
          this.technicalComponentLineItems.push(
            TechnicalComponentLineItemDto.fromJS(item)
          )
      }
      if (
        data['anesthesiaLineItems'] &&
        data['anesthesiaLineItems'].constructor === Array
      ) {
        this.anesthesiaLineItems = []
        for (let item of data['anesthesiaLineItems'])
          this.anesthesiaLineItems.push(AnesthesiaLineItemDto.fromJS(item))
      }
      if (
        data['physicalTherapyLineItems'] &&
        data['physicalTherapyLineItems'].constructor === Array
      ) {
        this.physicalTherapyLineItems = []
        for (let item of data['physicalTherapyLineItems'])
          this.physicalTherapyLineItems.push(PhysicalTherapyLineItemDto.fromJS(item))
      }
      if (
        data['miscellaneousLineItems'] &&
        data['miscellaneousLineItems'].constructor === Array
      ) {
        this.miscellaneousLineItems = []
        for (let item of data['miscellaneousLineItems'])
          this.miscellaneousLineItems.push(MiscellaneousLineItemDto.fromJS(item))
      }
      this.isActive = data['isActive']
      this.globalInvoiceId = data['globalInvoiceId']
      this.globalInvoice = data['globalInvoice']
        ? CMS1500Dto.fromJS(data['globalInvoice'])
        : <any>undefined
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.endDate = data['endDate']
        ? new Date(data['endDate'].toString())
        : <any>undefined
      this.bundleDurationDays = data['bundleDurationDays']
    }
  }

  static fromJS(data: any): QuoteDto {
    data = typeof data === 'object' ? data : {}
    let result = new QuoteDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['preCertNumber'] = this.preCertNumber
    data['patientName'] = this.patientName
    data['patientIdNumber'] = this.patientIdNumber
    data['patientFirstName'] = this.patientFirstName
    data['patientLastName'] = this.patientLastName
    data['name'] = this.name
    data['surgeryDate'] = this.surgeryDate
      ? this.surgeryDate.toISOString()
      : <any>undefined
    data['bodyPartName'] = this.bodyPartName
    data['episodeOfCareId'] = this.episodeOfCareId
    data['episodeOfCare'] = this.episodeOfCare
      ? this.episodeOfCare.toJSON()
      : <any>undefined
    data['episodeOfCareStatus'] = this.episodeOfCareStatus
    data['dateOfBirth'] = this.dateOfBirth
      ? this.dateOfBirth.toISOString()
      : <any>undefined
    data['episodeOfCareNumber'] = this.episodeOfCareNumber
    data['note'] = this.note
    data['targetMargin'] = this.targetMargin
    data['daysSinceSurgery'] = this.daysSinceSurgery
    data['adjustedCost'] = this.adjustedCost
    data['professionalComponentStatus'] = this.professionalComponentStatus
    data['technicalComponentStatus'] = this.technicalComponentStatus
    data['anesthesiaStatus'] = this.anesthesiaStatus
    data['physicalTherapyStatus'] = this.physicalTherapyStatus
    data['isAdjustedCostOverridden'] = this.isAdjustedCostOverridden
    data['adjustedCostOverriddenBy'] = this.adjustedCostOverriddenBy
    data['adjustedCostOverriddenOn'] = this.adjustedCostOverriddenOn
      ? this.adjustedCostOverriddenOn.toISOString()
      : <any>undefined
    data['status'] = this.status
    data['type'] = this.type
    data['statusName'] = this.statusName
    if (
      this.professionalComponentLineItems &&
      this.professionalComponentLineItems.constructor === Array
    ) {
      data['professionalComponentLineItems'] = []
      for (let item of this.professionalComponentLineItems)
        data['professionalComponentLineItems'].push(item.toJSON())
    }
    if (
      this.technicalComponentLineItems &&
      this.technicalComponentLineItems.constructor === Array
    ) {
      data['technicalComponentLineItems'] = []
      for (let item of this.technicalComponentLineItems)
        data['technicalComponentLineItems'].push(item.toJSON())
    }
    if (this.anesthesiaLineItems && this.anesthesiaLineItems.constructor === Array) {
      data['anesthesiaLineItems'] = []
      for (let item of this.anesthesiaLineItems)
        data['anesthesiaLineItems'].push(item.toJSON())
    }
    if (
      this.physicalTherapyLineItems &&
      this.physicalTherapyLineItems.constructor === Array
    ) {
      data['physicalTherapyLineItems'] = []
      for (let item of this.physicalTherapyLineItems)
        data['physicalTherapyLineItems'].push(item.toJSON())
    }
    if (
      this.miscellaneousLineItems &&
      this.miscellaneousLineItems.constructor === Array
    ) {
      data['miscellaneousLineItems'] = []
      for (let item of this.miscellaneousLineItems)
        data['miscellaneousLineItems'].push(item.toJSON())
    }
    data['isActive'] = this.isActive
    data['globalInvoiceId'] = this.globalInvoiceId
    data['globalInvoice'] = this.globalInvoice
      ? this.globalInvoice.toJSON()
      : <any>undefined
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined
    data['bundleDurationDays'] = this.bundleDurationDays
    return data
  }
}

export interface IQuoteDto {
  preCertNumber?: string | undefined
  patientName?: string | undefined
  patientIdNumber?: string | undefined
  patientFirstName?: string | undefined
  patientLastName?: string | undefined
  name?: string | undefined
  surgeryDate?: Date | undefined
  bodyPartName?: string | undefined
  episodeOfCareId?: string | undefined
  episodeOfCare?: EpisodeOfCareDto | undefined
  episodeOfCareStatus?: string | undefined
  dateOfBirth?: Date | undefined
  episodeOfCareNumber?: number | undefined
  note?: string | undefined
  targetMargin?: number | undefined
  daysSinceSurgery?: string | undefined
  adjustedCost?: number | undefined
  professionalComponentStatus?: string | undefined
  technicalComponentStatus?: string | undefined
  anesthesiaStatus?: string | undefined
  physicalTherapyStatus?: string | undefined
  isAdjustedCostOverridden?: boolean | undefined
  adjustedCostOverriddenBy?: string | undefined
  adjustedCostOverriddenOn?: Date | undefined
  status?: QuoteStatus | undefined
  type?: QuoteType | undefined
  statusName?: string | undefined
  professionalComponentLineItems?: ProfessionalComponentLineItemDto[] | undefined
  technicalComponentLineItems?: TechnicalComponentLineItemDto[] | undefined
  anesthesiaLineItems?: AnesthesiaLineItemDto[] | undefined
  physicalTherapyLineItems?: PhysicalTherapyLineItemDto[] | undefined
  miscellaneousLineItems?: MiscellaneousLineItemDto[] | undefined
  isActive?: boolean | undefined
  globalInvoiceId?: string | undefined
  globalInvoice?: CMS1500Dto | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  endDate?: Date | undefined
  bundleDurationDays?: number
}

export class SimpleEntityDto implements ISimpleEntityDto {
  id?: string | undefined
  isActive?: boolean | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  name?: string | undefined

  constructor(data?: ISimpleEntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.isActive = data['isActive']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.name = data['name']
    }
  }

  static fromJS(data: any): SimpleEntityDto {
    data = typeof data === 'object' ? data : {}
    let result = new SimpleEntityDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['isActive'] = this.isActive
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['name'] = this.name
    return data
  }
}

export interface ISimpleEntityDto {
  id?: string | undefined
  isActive?: boolean | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  name?: string | undefined
}

export class TestDto implements ITestDto {
  name?: string | undefined
  isActive?: boolean | undefined
  procedureId?: string | undefined
  procedure?: ProcedureDto | undefined
  bodyPartId?: string | undefined
  bodyPart?: BodyPartDto | undefined
  episodeOfCareId?: string | undefined
  episodeOfCare?: EpisodeOfCareDto | undefined
  rxReceived?: boolean | undefined
  diagnosis?: string | undefined
  followUpDateTime?: Date | undefined
  status?: string | undefined
  testIssue?: boolean | undefined
  cptCodes?: SurgeryCodeDto[] | undefined
  dxCodes?: SurgeryCodeDto[] | undefined
  referralIssue?: boolean | undefined
  scheduleTests?: ScheduleTestDto[] | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: ITestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.procedureId = data['procedureId']
      this.procedure = data['procedure']
        ? ProcedureDto.fromJS(data['procedure'])
        : <any>undefined
      this.bodyPartId = data['bodyPartId']
      this.bodyPart = data['bodyPart']
        ? BodyPartDto.fromJS(data['bodyPart'])
        : <any>undefined
      this.episodeOfCareId = data['episodeOfCareId']
      this.episodeOfCare = data['episodeOfCare']
        ? EpisodeOfCareDto.fromJS(data['episodeOfCare'])
        : <any>undefined
      this.rxReceived = data['rxReceived']
      this.diagnosis = data['diagnosis']
      this.followUpDateTime = data['followUpDateTime']
        ? new Date(data['followUpDateTime'].toString())
        : <any>undefined
      this.status = data['status']
      this.testIssue = data['testIssue']
      if (data['cptCodes'] && data['cptCodes'].constructor === Array) {
        this.cptCodes = []
        for (let item of data['cptCodes']) this.cptCodes.push(SurgeryCodeDto.fromJS(item))
      }
      if (data['dxCodes'] && data['dxCodes'].constructor === Array) {
        this.dxCodes = []
        for (let item of data['dxCodes']) this.dxCodes.push(SurgeryCodeDto.fromJS(item))
      }
      this.referralIssue = data['referralIssue']
      if (data['scheduleTests'] && data['scheduleTests'].constructor === Array) {
        this.scheduleTests = []
        for (let item of data['scheduleTests'])
          this.scheduleTests.push(ScheduleTestDto.fromJS(item))
      }
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): TestDto {
    data = typeof data === 'object' ? data : {}
    let result = new TestDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['procedureId'] = this.procedureId
    data['procedure'] = this.procedure ? this.procedure.toJSON() : <any>undefined
    data['bodyPartId'] = this.bodyPartId
    data['bodyPart'] = this.bodyPart ? this.bodyPart.toJSON() : <any>undefined
    data['episodeOfCareId'] = this.episodeOfCareId
    data['episodeOfCare'] = this.episodeOfCare
      ? this.episodeOfCare.toJSON()
      : <any>undefined
    data['rxReceived'] = this.rxReceived
    data['diagnosis'] = this.diagnosis
    data['followUpDateTime'] = this.followUpDateTime
      ? this.followUpDateTime.toISOString()
      : <any>undefined
    data['status'] = this.status
    data['testIssue'] = this.testIssue
    if (this.cptCodes && this.cptCodes.constructor === Array) {
      data['cptCodes'] = []
      for (let item of this.cptCodes) data['cptCodes'].push(item.toJSON())
    }
    if (this.dxCodes && this.dxCodes.constructor === Array) {
      data['dxCodes'] = []
      for (let item of this.dxCodes) data['dxCodes'].push(item.toJSON())
    }
    data['referralIssue'] = this.referralIssue
    if (this.scheduleTests && this.scheduleTests.constructor === Array) {
      data['scheduleTests'] = []
      for (let item of this.scheduleTests) data['scheduleTests'].push(item.toJSON())
    }
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ITestDto {
  name?: string | undefined
  isActive?: boolean | undefined
  procedureId?: string | undefined
  procedure?: ProcedureDto | undefined
  bodyPartId?: string | undefined
  bodyPart?: BodyPartDto | undefined
  episodeOfCareId?: string | undefined
  episodeOfCare?: EpisodeOfCareDto | undefined
  rxReceived?: boolean | undefined
  diagnosis?: string | undefined
  followUpDateTime?: Date | undefined
  status?: string | undefined
  testIssue?: boolean | undefined
  cptCodes?: SurgeryCodeDto[] | undefined
  dxCodes?: SurgeryCodeDto[] | undefined
  referralIssue?: boolean | undefined
  scheduleTests?: ScheduleTestDto[] | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class ProviderTypeDto implements IProviderTypeDto {
  id?: string | undefined
  name?: string | undefined
  abbreviation?: string | undefined

  constructor(data?: IProviderTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.name = data['name']
      this.abbreviation = data['abbreviation']
    }
  }

  static fromJS(data: any): ProviderTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new ProviderTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['abbreviation'] = this.abbreviation
    return data
  }
}

export interface IProviderTypeDto {
  id?: string | undefined
  name?: string | undefined
  abbreviation?: string | undefined
}

export class ContractDto implements IContractDto {
  name?: string | undefined
  providerId?: string | undefined
  startedOn?: Date | undefined
  endedOn?: Date | undefined
  organization?: IdentifierEntityDto | undefined
  organizationName?: string | undefined
  note?: string | undefined
  usePercentageOfMedicare?: boolean | undefined
  percentageOfMedicare?: number | undefined
  percentageOfMedicareToDisplay?: string | undefined
  contractAttachmentFiles?: ContractAttachmentFileDto[] | undefined
  codes?: CodeDto[] | undefined
  useMultipleProcedureDiscount?: boolean | undefined
  multipleProcedureDiscounts?: MultipleProcedureDiscountDto[] | undefined
  isSingleCaseAgreement?: boolean | undefined
  preCertNumber?: string | undefined
  criticalCareAccess?: boolean | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IContractDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.providerId = data['providerId']
      this.startedOn = data['startedOn']
        ? new Date(data['startedOn'].toString())
        : <any>undefined
      this.endedOn = data['endedOn']
        ? new Date(data['endedOn'].toString())
        : <any>undefined
      this.organization = data['organization']
        ? IdentifierEntityDto.fromJS(data['organization'])
        : <any>undefined
      this.organizationName = data['organizationName']
      this.note = data['note']
      this.usePercentageOfMedicare = data['usePercentageOfMedicare']
      this.percentageOfMedicare = data['percentageOfMedicare']
      this.percentageOfMedicareToDisplay = data['percentageOfMedicareToDisplay']
      if (
        data['contractAttachmentFiles'] &&
        data['contractAttachmentFiles'].constructor === Array
      ) {
        this.contractAttachmentFiles = []
        for (let item of data['contractAttachmentFiles'])
          this.contractAttachmentFiles.push(ContractAttachmentFileDto.fromJS(item))
      }
      if (data['codes'] && data['codes'].constructor === Array) {
        this.codes = []
        for (let item of data['codes']) this.codes.push(CodeDto.fromJS(item))
      }
      this.useMultipleProcedureDiscount = data['useMultipleProcedureDiscount']
      if (
        data['multipleProcedureDiscounts'] &&
        data['multipleProcedureDiscounts'].constructor === Array
      ) {
        this.multipleProcedureDiscounts = []
        for (let item of data['multipleProcedureDiscounts'])
          this.multipleProcedureDiscounts.push(MultipleProcedureDiscountDto.fromJS(item))
      }
      this.isSingleCaseAgreement = data['isSingleCaseAgreement']
      this.preCertNumber = data['preCertNumber']
      this.criticalCareAccess = data['criticalCareAccess']
      this.isActive = data['isActive']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ContractDto {
    data = typeof data === 'object' ? data : {}
    let result = new ContractDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['providerId'] = this.providerId
    data['startedOn'] = this.startedOn ? this.startedOn.toISOString() : <any>undefined
    data['endedOn'] = this.endedOn ? this.endedOn.toISOString() : <any>undefined
    data['organization'] = this.organization ? this.organization.toJSON() : <any>undefined
    data['organizationName'] = this.organizationName
    data['note'] = this.note
    data['usePercentageOfMedicare'] = this.usePercentageOfMedicare
    data['percentageOfMedicare'] = this.percentageOfMedicare
    data['percentageOfMedicareToDisplay'] = this.percentageOfMedicareToDisplay
    if (
      this.contractAttachmentFiles &&
      this.contractAttachmentFiles.constructor === Array
    ) {
      data['contractAttachmentFiles'] = []
      for (let item of this.contractAttachmentFiles)
        data['contractAttachmentFiles'].push(item.toJSON())
    }
    if (this.codes && this.codes.constructor === Array) {
      data['codes'] = []
      for (let item of this.codes) data['codes'].push(item.toJSON())
    }
    data['useMultipleProcedureDiscount'] = this.useMultipleProcedureDiscount
    if (
      this.multipleProcedureDiscounts &&
      this.multipleProcedureDiscounts.constructor === Array
    ) {
      data['multipleProcedureDiscounts'] = []
      for (let item of this.multipleProcedureDiscounts)
        data['multipleProcedureDiscounts'].push(item.toJSON())
    }
    data['isSingleCaseAgreement'] = this.isSingleCaseAgreement
    data['preCertNumber'] = this.preCertNumber
    data['criticalCareAccess'] = this.criticalCareAccess
    data['isActive'] = this.isActive
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IContractDto {
  name?: string | undefined
  providerId?: string | undefined
  startedOn?: Date | undefined
  endedOn?: Date | undefined
  organization?: IdentifierEntityDto | undefined
  organizationName?: string | undefined
  note?: string | undefined
  usePercentageOfMedicare?: boolean | undefined
  percentageOfMedicare?: number | undefined
  percentageOfMedicareToDisplay?: string | undefined
  contractAttachmentFiles?: ContractAttachmentFileDto[] | undefined
  codes?: CodeDto[] | undefined
  useMultipleProcedureDiscount?: boolean | undefined
  multipleProcedureDiscounts?: MultipleProcedureDiscountDto[] | undefined
  isSingleCaseAgreement?: boolean | undefined
  preCertNumber?: string | undefined
  criticalCareAccess?: boolean | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class TagDto implements ITagDto {
  isActive?: boolean | undefined
  tagColor?: string | undefined
  isLocked?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isChecked?: boolean | undefined

  constructor(data?: ITagDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.tagColor = data['tagColor']
      this.isLocked = data['isLocked']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): TagDto {
    data = typeof data === 'object' ? data : {}
    let result = new TagDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['tagColor'] = this.tagColor
    data['isLocked'] = this.isLocked
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ITagDto {
  isActive?: boolean | undefined
  tagColor?: string | undefined
  isLocked?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isChecked?: boolean | undefined
}

export class LocationDto implements ILocationDto {
  npi?: string | undefined
  name?: string | undefined
  providerLocationName?: string | undefined
  providerId?: string | undefined
  provider?: ProviderDto | undefined
  physicalAddress?: AddressDto | undefined
  city?: string | undefined
  state?: string | undefined
  phone?: string | undefined
  isActive?: boolean | undefined
  procedure?: string | undefined
  distance?: number | undefined
  locationProcedures?: LocationProcedureDto[] | undefined
  phoneNumber?: string | undefined
  faxNumber?: string | undefined
  email?: string | undefined
  providerLocationComments?: string | undefined
  providerContractComments?: string | undefined
  careCoordinatorComments?: string | undefined
  legacyId?: string | undefined
  requiresSingleCaseAgreement?: boolean | undefined
  providerTypes?: ProviderTypeDto[] | undefined
  billingAddresses?: LocationBillingDto[] | undefined
  id?: string | undefined
  verified?: boolean | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: ILocationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.npi = data['npi']
      this.name = data['name']
      this.providerLocationName = data['providerLocationName']
      this.providerId = data['providerId']
      this.provider = data['provider']
        ? ProviderDto.fromJS(data['provider'])
        : <any>undefined
      this.physicalAddress = data['physicalAddress']
        ? AddressDto.fromJS(data['physicalAddress'])
        : <any>undefined
      this.city = data['city']
      this.state = data['state']
      this.phone = data['phone']
      this.isActive = data['isActive']
      this.procedure = data['procedure']
      this.distance = data['distance']
      if (
        data['locationProcedures'] &&
        data['locationProcedures'].constructor === Array
      ) {
        this.locationProcedures = []
        for (let item of data['locationProcedures'])
          this.locationProcedures.push(LocationProcedureDto.fromJS(item))
      }
      this.phoneNumber = data['phoneNumber']
      this.faxNumber = data['faxNumber']
      this.email = data['email']
      this.providerLocationComments = data['providerLocationComments']
      this.providerContractComments = data['providerContractComments']
      this.careCoordinatorComments = data['careCoordinatorComments']
      this.legacyId = data['legacyId']
      this.requiresSingleCaseAgreement = data['requiresSingleCaseAgreement']
      if (data['providerTypes'] && data['providerTypes'].constructor === Array) {
        this.providerTypes = []
        for (let item of data['providerTypes'])
          this.providerTypes.push(ProviderTypeDto.fromJS(item))
      }
      if (data['billingAddresses'] && data['billingAddresses'].constructor === Array) {
        this.billingAddresses = []
        for (let item of data['billingAddresses'])
          this.billingAddresses.push(LocationBillingDto.fromJS(item))
      }
      this.id = data['id']
      this.verified = data['verified']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): LocationDto {
    data = typeof data === 'object' ? data : {}
    let result = new LocationDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['npi'] = this.npi
    data['name'] = this.name
    data['providerLocationName'] = this.providerLocationName
    data['providerId'] = this.providerId
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['physicalAddress'] = this.physicalAddress
      ? this.physicalAddress.toJSON()
      : <any>undefined
    data['city'] = this.city
    data['state'] = this.state
    data['phone'] = this.phone
    data['isActive'] = this.isActive
    data['procedure'] = this.procedure
    data['distance'] = this.distance
    if (this.locationProcedures && this.locationProcedures.constructor === Array) {
      data['locationProcedures'] = []
      for (let item of this.locationProcedures)
        data['locationProcedures'].push(item.toJSON())
    }
    data['phoneNumber'] = this.phoneNumber
    data['faxNumber'] = this.faxNumber
    data['email'] = this.email
    data['providerLocationComments'] = this.providerLocationComments
    data['providerContractComments'] = this.providerContractComments
    data['careCoordinatorComments'] = this.careCoordinatorComments
    data['legacyId'] = this.legacyId
    data['requiresSingleCaseAgreement'] = this.requiresSingleCaseAgreement
    if (this.providerTypes && this.providerTypes.constructor === Array) {
      data['providerTypes'] = []
      for (let item of this.providerTypes) data['providerTypes'].push(item.toJSON())
    }
    if (this.billingAddresses && this.billingAddresses.constructor === Array) {
      data['billingAddresses'] = []
      for (let item of this.billingAddresses) data['billingAddresses'].push(item.toJSON())
    }
    data['id'] = this.id
    data['verified'] = this.verified
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ILocationDto {
  npi?: string | undefined
  name?: string | undefined
  providerLocationName?: string | undefined
  providerId?: string | undefined
  provider?: ProviderDto | undefined
  physicalAddress?: AddressDto | undefined
  city?: string | undefined
  state?: string | undefined
  phone?: string | undefined
  isActive?: boolean | undefined
  procedure?: string | undefined
  distance?: number | undefined
  locationProcedures?: LocationProcedureDto[] | undefined
  phoneNumber?: string | undefined
  faxNumber?: string | undefined
  email?: string | undefined
  providerLocationComments?: string | undefined
  providerContractComments?: string | undefined
  careCoordinatorComments?: string | undefined
  legacyId?: string | undefined
  requiresSingleCaseAgreement?: boolean | undefined
  providerTypes?: ProviderTypeDto[] | undefined
  billingAddresses?: LocationBillingDto[] | undefined
  id?: string | undefined
  verified?: boolean | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class PatientDto implements IPatientDto {
  isActive?: boolean | undefined
  patientIdNumber?: number | undefined
  patientId?: string | undefined
  name?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  dateOfBirth?: Date | undefined
  dateOfBirthText: string | undefined
  address?: AddressDto | undefined
  city?: string | undefined
  state?: string | undefined
  zip?: string | undefined
  phone?: string | undefined
  cellPhone?: string | undefined
  homePhone?: string | undefined
  workPhone?: string | undefined
  allowTexting?: boolean | undefined
  allowContact?: boolean | undefined
  gender?: string | undefined
  heightFeet?: number | undefined
  heightInches?: number | undefined
  weight?: number | undefined
  hxOfSx?: string | undefined
  patientComments?: string | undefined
  sSN?: string | undefined
  emailAddress?: string | undefined
  bMI?: number | undefined
  preExistingConditions?: PatientPreExistingConditionDto[] | undefined
  preCertNumber?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IPatientDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.patientIdNumber = data['patientIdNumber']
      this.patientId = data['patientId']
      this.name = data['name']
      this.firstName = data['firstName']
      this.lastName = data['lastName']
      this.dateOfBirth = data['dateOfBirth']
        ? new Date(data['dateOfBirth'].toString())
        : <any>undefined
      this.dateOfBirthText = data['dateOfBirthText']
      this.address = data['address'] ? AddressDto.fromJS(data['address']) : <any>undefined
      this.city = data['city']
      this.state = data['state']
      this.zip = data['zip']
      this.phone = data['phone']
      this.cellPhone = data['cellPhone']
      this.homePhone = data['homePhone']
      this.workPhone = data['workPhone']
      this.allowTexting = data['allowTexting']
      this.allowContact = data['allowContact']
      this.gender = data['gender']
      this.heightFeet = data['heightFeet']
      this.heightInches = data['heightInches']
      this.weight = data['weight']
      this.hxOfSx = data['hxOfSx']
      this.patientComments = data['patientComments']
      this.sSN = data['sSN']
      this.emailAddress = data['emailAddress']
      this.bMI = data['bMI']
      if (
        data['preExistingConditions'] &&
        data['preExistingConditions'].constructor === Array
      ) {
        this.preExistingConditions = []
        for (let item of data['preExistingConditions'])
          this.preExistingConditions.push(PatientPreExistingConditionDto.fromJS(item))
      }
      this.preCertNumber = data['preCertNumber']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): PatientDto {
    data = typeof data === 'object' ? data : {}
    let result = new PatientDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['patientIdNumber'] = this.patientIdNumber
    data['patientId'] = this.patientId
    data['name'] = this.name
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['dateOfBirth'] = this.dateOfBirth
      ? this.dateOfBirth.toISOString()
      : <any>undefined
    data['dateOfBirthText'] = this.dateOfBirthText
    data['address'] = this.address ? this.address.toJSON() : <any>undefined
    data['city'] = this.city
    data['state'] = this.state
    data['zip'] = this.zip
    data['phone'] = this.phone
    data['cellPhone'] = this.cellPhone
    data['homePhone'] = this.homePhone
    data['workPhone'] = this.workPhone
    data['allowTexting'] = this.allowTexting
    data['allowContact'] = this.allowContact
    data['gender'] = this.gender
    data['heightFeet'] = this.heightFeet
    data['heightInches'] = this.heightInches
    data['weight'] = this.weight
    data['hxOfSx'] = this.hxOfSx
    data['patientComments'] = this.patientComments
    data['sSN'] = this.sSN
    data['emailAddress'] = this.emailAddress
    data['bMI'] = this.bMI
    data['preExistingConditions'] = []
    if (this.preExistingConditions && this.preExistingConditions.constructor === Array) {
      for (let item of this.preExistingConditions)
        data['preExistingConditions'].push(item.toJSON())
    }
    data['preCertNumber'] = this.preCertNumber
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IPatientDto {
  isActive?: boolean | undefined
  patientIdNumber?: number | undefined
  patientId?: string | undefined
  name?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  dateOfBirth?: Date | undefined
  dateOfBirthText?: string | undefined
  address?: AddressDto | undefined
  city?: string | undefined
  state?: string | undefined
  zip?: string | undefined
  phone?: string | undefined
  cellPhone?: string | undefined
  homePhone?: string | undefined
  workPhone?: string | undefined
  allowTexting?: boolean | undefined
  allowContact?: boolean | undefined
  gender?: string | undefined
  heightFeet?: number | undefined
  heightInches?: number | undefined
  weight?: number | undefined
  hxOfSx?: string | undefined
  patientComments?: string | undefined
  sSN?: string | undefined
  emailAddress?: string | undefined
  bMI?: number | undefined
  preExistingConditions?: PatientPreExistingConditionDto[] | undefined
  preCertNumber?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  menuReplacer?: JSX.Element | undefined
}

export class EmployerDto implements IEmployerDto {
  name?: string | undefined
  isActive?: boolean | undefined
  comments?: string | undefined
  address?: AddressDto | undefined
  contacts?: ContactDto[] | undefined
  isSpecialPricing?: boolean | undefined
  displayAddress?: string | undefined
  displayCity?: string | undefined
  displayState?: string | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IEmployerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.comments = data['comments']
      this.address = data['address'] ? AddressDto.fromJS(data['address']) : <any>undefined
      this.contacts = []
      if (data['contacts'] && data['contacts'].constructor === Array) {
        for (let item of data['contacts']) this.contacts.push(ContactDto.fromJS(item))
      }
      this.isSpecialPricing = data['isSpecialPricing']
      this.displayAddress = data['displayAddress']
      this.displayCity = data['displayCity']
      this.displayState = data['displayState']
      this.legacyId = data['legacyId']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): EmployerDto {
    data = typeof data === 'object' ? data : {}
    let result = new EmployerDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['comments'] = this.comments
    data['address'] = this.address ? this.address.toJSON() : <any>undefined
    data['contacts'] = []
    if (this.contacts && this.contacts.constructor === Array) {
      for (let item of this.contacts) data['contacts'].push(item.toJSON())
    }
    data['isSpecialPricing'] = this.isSpecialPricing
    data['displayAddress'] = this.displayAddress
    data['displayCity'] = this.displayCity
    data['displayState'] = this.displayState
    data['legacyId'] = this.legacyId
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IEmployerDto {
  name?: string | undefined
  isActive?: boolean | undefined
  comments?: string | undefined
  address?: AddressDto | undefined
  contacts?: ContactDto[] | undefined
  isSpecialPricing?: boolean | undefined
  displayAddress?: string | undefined
  displayCity?: string | undefined
  displayState?: string | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class InsuranceCompanyDto implements IInsuranceCompanyDto {
  isActive?: boolean | undefined
  name?: string | undefined
  billingAddress?: AddressDto | undefined
  physicalAddress?: AddressDto | undefined
  streetAddress?: string | undefined
  city?: string | undefined
  state?: string | undefined
  billingFaxNumber?: string | undefined
  claimsEmail?: string | undefined
  contacts?: ContactDto[] | undefined
  legacyId?: string | undefined
  isSpecialPricing?: boolean | undefined
  includeNurseCaseManager?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IInsuranceCompanyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.name = data['name']
      this.billingAddress = data['billingAddress']
        ? AddressDto.fromJS(data['billingAddress'])
        : <any>undefined
      this.physicalAddress = data['physicalAddress']
        ? AddressDto.fromJS(data['physicalAddress'])
        : <any>undefined
      this.streetAddress = data['streetAddress']
      this.city = data['city']
      this.state = data['state']
      this.billingFaxNumber = data['billingFaxNumber']
      this.claimsEmail = data['claimsEmail']
      this.contacts = []
      if (data['contacts'] && data['contacts'].constructor === Array) {
        for (let item of data['contacts']) this.contacts.push(ContactDto.fromJS(item))
      }
      this.legacyId = data['legacyId']
      this.isSpecialPricing = data['isSpecialPricing']
      this.includeNurseCaseManager = data['includeNurseCaseManager']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): InsuranceCompanyDto {
    data = typeof data === 'object' ? data : {}
    let result = new InsuranceCompanyDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['name'] = this.name
    data['billingAddress'] = this.billingAddress
      ? this.billingAddress.toJSON()
      : <any>undefined
    data['physicalAddress'] = this.physicalAddress
      ? this.physicalAddress.toJSON()
      : <any>undefined
    data['streetAddress'] = this.streetAddress
    data['city'] = this.city
    data['state'] = this.state
    data['billingFaxNumber'] = this.billingFaxNumber
    data['claimsEmail'] = this.claimsEmail
    data['contacts'] = []
    if (this.contacts && this.contacts.constructor === Array) {
      for (let item of this.contacts) data['contacts'].push(item.toJSON())
    }
    data['legacyId'] = this.legacyId
    data['isSpecialPricing'] = this.isSpecialPricing
    data['includeNurseCaseManager'] = this.includeNurseCaseManager
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IInsuranceCompanyDto {
  isActive?: boolean | undefined
  name?: string | undefined
  billingAddress?: AddressDto | undefined
  physicalAddress?: AddressDto | undefined
  streetAddress?: string | undefined
  city?: string | undefined
  state?: string | undefined
  billingFaxNumber?: string | undefined
  claimsEmail?: string | undefined
  contacts?: ContactDto[] | undefined
  legacyId?: string | undefined
  isSpecialPricing?: boolean | undefined
  includeNurseCaseManager?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class NurseCaseManagerDto implements INurseCaseManagerDto {
  company?: string | undefined
  name?: string | undefined
  address?: AddressDto | undefined
  street?: string | undefined
  city?: string | undefined
  state?: string | undefined
  preferences?: string | undefined
  isSpecialPricing?: boolean | undefined
  contacts?: ContactDto[] | undefined
  isActive?: boolean | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: INurseCaseManagerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.company = data['company']
      this.name = data['name']
      this.address = data['address'] ? AddressDto.fromJS(data['address']) : <any>undefined
      this.street = data['street']
      this.city = data['city']
      this.state = data['state']
      this.preferences = data['preferences']
      this.isSpecialPricing = data['isSpecialPricing']
      this.contacts = []
      if (data['contacts'] && data['contacts'].constructor === Array) {
        for (let item of data['contacts']) this.contacts.push(ContactDto.fromJS(item))
      }
      this.isActive = data['isActive']
      this.legacyId = data['legacyId']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): NurseCaseManagerDto {
    data = typeof data === 'object' ? data : {}
    let result = new NurseCaseManagerDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['company'] = this.company
    data['name'] = this.name
    data['address'] = this.address ? this.address.toJSON() : <any>undefined
    data['street'] = this.street
    data['city'] = this.city
    data['state'] = this.state
    data['preferences'] = this.preferences
    data['isSpecialPricing'] = this.isSpecialPricing
    data['contacts'] = []
    if (this.contacts && this.contacts.constructor === Array) {
      for (let item of this.contacts) data['contacts'].push(item.toJSON())
    }
    data['isActive'] = this.isActive
    data['legacyId'] = this.legacyId
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface INurseCaseManagerDto {
  company?: string | undefined
  name?: string | undefined
  address?: AddressDto | undefined
  street?: string | undefined
  city?: string | undefined
  state?: string | undefined
  preferences?: string | undefined
  isSpecialPricing?: boolean | undefined
  contacts?: ContactDto[] | undefined
  isActive?: boolean | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class ScheduleAppointmentTaskDto implements IScheduleAppointmentTaskDto {
  organizationId?: string | undefined
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  name?: string | undefined
  applicationTask?: string | undefined
  dateCompleted?: Date | undefined
  taskNotApplicable?: boolean | undefined
  taskApplicable?: boolean | undefined
  comments?: string | undefined
  abbreviatedComments?: string | undefined
  componentId?: string | undefined
  days?: number | undefined
  dueDate?: Date | undefined
  timing?: string | undefined
  priority?: number | undefined
  requiresApproval?: boolean | undefined
  authorizationType?: string | undefined
  isActive?: boolean | undefined
  patientIdNum?: number | undefined
  patientName?: string | undefined
  dateOfBirth?: Date | undefined
  apptDate?: Date | undefined
  referralDate?: Date | undefined
  careCoordinator?: string | undefined
  overdue?: string | undefined
  isWorkRestrictionTask?: boolean | undefined
  updatedByUserId?: string | undefined
  updatedByUser?: UserDto | undefined
  updatedByDate?: Date | undefined
  displayOrder?: number | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IScheduleAppointmentTaskDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.organizationId = data['organizationId']
      this.scheduleId = data['scheduleId']
      this.schedule = data['schedule']
        ? ScheduleDto.fromJS(data['schedule'])
        : <any>undefined
      this.name = data['name']
      this.applicationTask = data['applicationTask']
      this.dateCompleted = data['dateCompleted']
        ? new Date(data['dateCompleted'].toString())
        : <any>undefined
      this.taskNotApplicable = data['taskNotApplicable']
      this.taskApplicable = data['taskApplicable']
      this.comments = data['comments']
      this.abbreviatedComments = data['abbreviatedComments']
      this.componentId = data['componentId']
      this.days = data['days']
      this.dueDate = data['dueDate']
        ? new Date(data['dueDate'].toString())
        : <any>undefined
      this.timing = data['timing']
      this.priority = data['priority']
      this.requiresApproval = data['requiresApproval']
      this.authorizationType = data['authorizationType']
      this.isActive = data['isActive']
      this.patientIdNum = data['patientIdNum']
      this.patientName = data['patientName']
      this.dateOfBirth = data['dateOfBirth']
        ? new Date(data['dateOfBirth'].toString())
        : <any>undefined
      this.apptDate = data['apptDate']
        ? new Date(data['apptDate'].toString())
        : <any>undefined
      this.referralDate = data['referralDate']
        ? new Date(data['referralDate'].toString())
        : <any>undefined
      this.careCoordinator = data['careCoordinator']
      this.overdue = data['overdue']
      this.isWorkRestrictionTask = data['isWorkRestrictionTask']
      this.updatedByUserId = data['updatedByUserId']
      this.updatedByUser = data['updatedByUser']
        ? UserDto.fromJS(data['updatedByUser'])
        : <any>undefined
      this.updatedByDate = data['updatedByDate']
        ? new Date(data['updatedByDate'].toString())
        : <any>undefined
      this.displayOrder = data['displayOrder']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ScheduleAppointmentTaskDto {
    data = typeof data === 'object' ? data : {}
    let result = new ScheduleAppointmentTaskDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['organizationId'] = this.organizationId
    data['scheduleId'] = this.scheduleId
    data['schedule'] = this.schedule ? this.schedule.toJSON() : <any>undefined
    data['name'] = this.name
    data['applicationTask'] = this.applicationTask
    data['dateCompleted'] = this.dateCompleted
      ? this.dateCompleted.toISOString()
      : <any>undefined
    data['taskNotApplicable'] = this.taskNotApplicable
    data['taskApplicable'] = this.taskApplicable
    data['comments'] = this.comments
    data['abbreviatedComments'] = this.abbreviatedComments
    data['componentId'] = this.componentId
    data['days'] = this.days
    data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined
    data['timing'] = this.timing
    data['priority'] = this.priority
    data['requiresApproval'] = this.requiresApproval
    data['authorizationType'] = this.authorizationType
    data['isActive'] = this.isActive
    data['patientIdNum'] = this.patientIdNum
    data['patientName'] = this.patientName
    data['dateOfBirth'] = this.dateOfBirth
      ? this.dateOfBirth.toISOString()
      : <any>undefined
    data['apptDate'] = this.apptDate ? this.apptDate.toISOString() : <any>undefined
    data['referralDate'] = this.referralDate
      ? this.referralDate.toISOString()
      : <any>undefined
    data['careCoordinator'] = this.careCoordinator
    data['overdue'] = this.overdue
    data['isWorkRestrictionTask'] = this.isWorkRestrictionTask
    data['updatedByUserId'] = this.updatedByUserId
    data['updatedByUser'] = this.updatedByUser
      ? this.updatedByUser.toJSON()
      : <any>undefined
    data['updatedByDate'] = this.updatedByDate
      ? this.updatedByDate.toISOString()
      : <any>undefined
    data['displayOrder'] = this.displayOrder
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IScheduleAppointmentTaskDto {
  organizationId?: string | undefined
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  name?: string | undefined
  applicationTask?: string | undefined
  dateCompleted?: Date | undefined
  taskNotApplicable?: boolean | undefined
  taskApplicable?: boolean | undefined
  comments?: string | undefined
  abbreviatedComments?: string | undefined
  componentId?: string | undefined
  days?: number | undefined
  dueDate?: Date | undefined
  isWorkRestrictionTask?: boolean | undefined
  timing?: string | undefined
  priority?: number | undefined
  requiresApproval?: boolean | undefined
  authorizationType?: string | undefined
  isActive?: boolean | undefined
  patientIdNum?: number | undefined
  patientName?: string | undefined
  dateOfBirth?: Date | undefined
  apptDate?: Date | undefined
  referralDate?: Date | undefined
  careCoordinator?: string | undefined
  overdue?: string | undefined
  updatedByUserId?: string | undefined
  updatedByUser?: UserDto | undefined
  updatedByDate?: Date | undefined
  displayOrder?: number | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class ScheduleTestDto implements IScheduleTestDto {
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  testId?: string | undefined
  test?: TestDto | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined

  constructor(data?: IScheduleTestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.scheduleId = data['scheduleId']
      this.schedule = data['schedule']
        ? ScheduleDto.fromJS(data['schedule'])
        : <any>undefined
      this.testId = data['testId']
      this.test = data['test'] ? TestDto.fromJS(data['test']) : <any>undefined
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): ScheduleTestDto {
    data = typeof data === 'object' ? data : {}
    let result = new ScheduleTestDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['scheduleId'] = this.scheduleId
    data['schedule'] = this.schedule ? this.schedule.toJSON() : <any>undefined
    data['testId'] = this.testId
    data['test'] = this.test ? this.test.toJSON() : <any>undefined
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isActive'] = this.isActive
    return data
  }
}

export interface IScheduleTestDto {
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  testId?: string | undefined
  test?: TestDto | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
}

export class ScheduleProviderLocationDto implements IScheduleProviderLocationDto {
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  locationId?: string | undefined
  location?: LocationDto | undefined
  isPrimaryLocation?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined

  constructor(data?: IScheduleProviderLocationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.scheduleId = data['scheduleId']
      this.schedule = data['schedule']
        ? ScheduleDto.fromJS(data['schedule'])
        : <any>undefined
      this.locationId = data['locationId']
      this.location = data['location']
        ? LocationDto.fromJS(data['location'])
        : <any>undefined
      this.isPrimaryLocation = data['isPrimaryLocation']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): ScheduleProviderLocationDto {
    data = typeof data === 'object' ? data : {}
    let result = new ScheduleProviderLocationDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['scheduleId'] = this.scheduleId
    data['schedule'] = this.schedule ? this.schedule.toJSON() : <any>undefined
    data['locationId'] = this.locationId
    data['location'] = this.location ? this.location.toJSON() : <any>undefined
    data['isPrimaryLocation'] = this.isPrimaryLocation
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isActive'] = this.isActive
    return data
  }
}

export interface IScheduleProviderLocationDto {
  scheduleId?: string | undefined
  schedule?: ScheduleDto | undefined
  locationId?: string | undefined
  location?: LocationDto | undefined
  isPrimaryLocation?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
}

export class ProfessionalComponentLineItemDto implements IProfessionalComponentLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  physicianId?: string | undefined
  physician?: IdentifierEntityDto | undefined
  typeId?: string | undefined
  typeText?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  contract?: number | undefined
  discount?: number | undefined
  suggested?: number | undefined
  contractId?: string | undefined
  medicareCostLookupId?: string | undefined
  markedDeleted?: boolean | undefined

  constructor(data?: IProfessionalComponentLineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.providerId = data['providerId']
      this.provider = data['provider']
        ? IdentifierEntityDto.fromJS(data['provider'])
        : <any>undefined
      this.physicianId = data['physicianId']
      this.physician = data['physician']
        ? IdentifierEntityDto.fromJS(data['physician'])
        : <any>undefined
      this.typeId = data['typeId']
      this.typeText = data['typeText']
      this.cptCode = data['cptCode']
      this.cost = data['cost']
      this.isCostOverridden = data['isCostOverridden']
      this.costOverriddenBy = data['costOverriddenBy']
      this.costOverriddenByName = data['costOverriddenByName']
      this.costOverriddenOn = data['costOverriddenOn']
        ? new Date(data['costOverriddenOn'].toString())
        : <any>undefined
      this.calculationExplanation = data['calculationExplanation']
        ? CalculationExplanationDto.fromJS(data['calculationExplanation'])
        : <any>undefined
      this.inclusions = data['inclusions']
      this.contract = data['contract']
      this.discount = data['discount']
      this.suggested = data['suggested']
      this.contractId = data['contractId']
      this.medicareCostLookupId = data['medicareCostLookupId']
      this.markedDeleted = data['markedDeleted'] ?? false
    }
  }

  static fromJS(data: any): ProfessionalComponentLineItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new ProfessionalComponentLineItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['providerId'] = this.providerId
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['physicianId'] = this.physicianId
    data['physician'] = this.physician ? this.physician.toJSON() : <any>undefined
    data['typeId'] = this.typeId
    data['typeText'] = this.typeText
    data['cptCode'] = this.cptCode
    data['cost'] = this.cost
    data['isCostOverridden'] = this.isCostOverridden
    data['costOverriddenBy'] = this.costOverriddenBy
    data['costOverriddenByName'] = this.costOverriddenByName
    data['costOverriddenOn'] = this.costOverriddenOn
      ? this.costOverriddenOn.toISOString()
      : <any>undefined
    data['calculationExplanation'] = this.calculationExplanation
      ? this.calculationExplanation.toJSON()
      : <any>undefined
    data['inclusions'] = this.inclusions
    data['contract'] = this.contract
    data['discount'] = this.discount
    data['suggested'] = this.suggested
    data['contractId'] = this.contractId
    data['medicareCostLookupId'] = this.medicareCostLookupId
    data['markedDeleted'] = this.markedDeleted ?? false
    return data
  }
}

export interface IProfessionalComponentLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  physicianId?: string | undefined
  physician?: IdentifierEntityDto | undefined
  typeId?: string | undefined
  typeText?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  contract?: number | undefined
  discount?: number | undefined
  suggested?: number | undefined
  contractId?: string | undefined
  medicareCostLookupId?: string | undefined
  markedDeleted?: boolean | undefined
}

export class TechnicalComponentLineItemDto implements ITechnicalComponentLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  typeId?: string | undefined
  typeText?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  contract?: number | undefined
  discount?: number | undefined
  suggested?: number | undefined
  contractId?: string | undefined
  medicareCostLookupId?: string | undefined
  markedDeleted?: boolean | undefined

  constructor(data?: ITechnicalComponentLineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.providerId = data['providerId']
      this.provider = data['provider']
        ? IdentifierEntityDto.fromJS(data['provider'])
        : <any>undefined
      this.typeId = data['typeId']
      this.typeText = data['typeText']
      this.cptCode = data['cptCode']
      this.cost = data['cost']
      this.isCostOverridden = data['isCostOverridden']
      this.costOverriddenBy = data['costOverriddenBy']
      this.costOverriddenByName = data['costOverriddenByName']
      this.costOverriddenOn = data['costOverriddenOn']
        ? new Date(data['costOverriddenOn'].toString())
        : <any>undefined
      this.calculationExplanation = data['calculationExplanation']
        ? CalculationExplanationDto.fromJS(data['calculationExplanation'])
        : <any>undefined
      this.inclusions = data['inclusions']
      this.contract = data['contract']
      this.discount = data['discount']
      this.suggested = data['suggested']
      this.contractId = data['contractId']
      this.medicareCostLookupId = data['medicareCostLookupId']
      this.markedDeleted = data['markedDeleted'] ?? false
    }
  }

  static fromJS(data: any): TechnicalComponentLineItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new TechnicalComponentLineItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['providerId'] = this.providerId
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['typeId'] = this.typeId
    data['typeText'] = this.typeText
    data['cptCode'] = this.cptCode
    data['cost'] = this.cost
    data['isCostOverridden'] = this.isCostOverridden
    data['costOverriddenBy'] = this.costOverriddenBy
    data['costOverriddenByName'] = this.costOverriddenByName
    data['costOverriddenOn'] = this.costOverriddenOn
      ? this.costOverriddenOn.toISOString()
      : <any>undefined
    data['calculationExplanation'] = this.calculationExplanation
      ? this.calculationExplanation.toJSON()
      : <any>undefined
    data['inclusions'] = this.inclusions
    data['contract'] = this.contract
    data['discount'] = this.discount
    data['suggested'] = this.suggested
    data['contractId'] = this.contractId
    data['medicareCostLookupId'] = this.medicareCostLookupId
    data['markedDeleted'] = this.markedDeleted ?? false
    return data
  }
}

export interface ITechnicalComponentLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  typeId?: string | undefined
  typeText?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  contract?: number | undefined
  discount?: number | undefined
  suggested?: number | undefined
  contractId?: string | undefined
  medicareCostLookupId?: string | undefined
  markedDeleted?: boolean | undefined
}

export class AnesthesiaLineItemDto implements IAnesthesiaLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  physicianId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  physician?: IdentifierEntityDto | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  markedDeleted?: boolean | undefined

  constructor(data?: IAnesthesiaLineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.providerId = data['providerId']
      this.physicianId = data['physicianId']
      this.provider = data['provider']
        ? IdentifierEntityDto.fromJS(data['provider'])
        : <any>undefined
      this.physician = data['physician']
        ? IdentifierEntityDto.fromJS(data['physician'])
        : <any>undefined
      this.cptCode = data['cptCode']
      this.cost = data['cost']
      this.isCostOverridden = data['isCostOverridden']
      this.costOverriddenBy = data['costOverriddenBy']
      this.costOverriddenByName = data['costOverriddenByName']
      this.costOverriddenOn = data['costOverriddenOn']
        ? new Date(data['costOverriddenOn'].toString())
        : <any>undefined
      this.calculationExplanation = data['calculationExplanation']
        ? CalculationExplanationDto.fromJS(data['calculationExplanation'])
        : <any>undefined
      this.inclusions = data['inclusions']
      this.markedDeleted = data['markedDeleted'] ?? false
    }
  }

  static fromJS(data: any): AnesthesiaLineItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new AnesthesiaLineItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['providerId'] = this.providerId
    data['physicianId'] = this.physicianId
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['physician'] = this.physician ? this.physician.toJSON() : <any>undefined
    data['cptCode'] = this.cptCode
    data['cost'] = this.cost
    data['isCostOverridden'] = this.isCostOverridden
    data['costOverriddenBy'] = this.costOverriddenBy
    data['costOverriddenByName'] = this.costOverriddenByName
    data['costOverriddenOn'] = this.costOverriddenOn
      ? this.costOverriddenOn.toISOString()
      : <any>undefined
    data['calculationExplanation'] = this.calculationExplanation
      ? this.calculationExplanation.toJSON()
      : <any>undefined
    data['inclusions'] = this.inclusions
    data['markedDeleted'] = this.markedDeleted ?? false
    return data
  }
}

export interface IAnesthesiaLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  physicianId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  physician?: IdentifierEntityDto | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  markedDeleted?: boolean | undefined
}

export class PhysicalTherapyLineItemDto implements IPhysicalTherapyLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  numberOfVisits?: number | undefined
  costPerVisit?: number | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  markedDeleted?: boolean | undefined

  constructor(data?: IPhysicalTherapyLineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.providerId = data['providerId']
      this.provider = data['provider']
        ? IdentifierEntityDto.fromJS(data['provider'])
        : <any>undefined
      this.numberOfVisits = data['numberOfVisits']
      this.costPerVisit = data['costPerVisit']
      this.cost = data['cost']
      this.isCostOverridden = data['isCostOverridden']
      this.costOverriddenBy = data['costOverriddenBy']
      this.costOverriddenByName = data['costOverriddenByName']
      this.costOverriddenOn = data['costOverriddenOn']
        ? new Date(data['costOverriddenOn'].toString())
        : <any>undefined
      this.calculationExplanation = data['calculationExplanation']
        ? CalculationExplanationDto.fromJS(data['calculationExplanation'])
        : <any>undefined
      this.inclusions = data['inclusions']
      this.markedDeleted = data['markedDeleted'] ?? false
    }
  }

  static fromJS(data: any): PhysicalTherapyLineItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new PhysicalTherapyLineItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['providerId'] = this.providerId
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['numberOfVisits'] = this.numberOfVisits
    data['costPerVisit'] = this.costPerVisit
    data['cost'] = this.cost
    data['isCostOverridden'] = this.isCostOverridden
    data['costOverriddenBy'] = this.costOverriddenBy
    data['costOverriddenByName'] = this.costOverriddenByName
    data['costOverriddenOn'] = this.costOverriddenOn
      ? this.costOverriddenOn.toISOString()
      : <any>undefined
    data['calculationExplanation'] = this.calculationExplanation
      ? this.calculationExplanation.toJSON()
      : <any>undefined
    data['inclusions'] = this.inclusions
    data['markedDeleted'] = this.markedDeleted
    return data
  }
}

export interface IPhysicalTherapyLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  numberOfVisits?: number | undefined
  costPerVisit?: number | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  markedDelete?: boolean | undefined
}

export class MiscellaneousLineItemDto implements IMiscellaneousLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  typeId?: string | undefined
  typeText?: string | undefined
  description?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  markedDeleted?: boolean | undefined

  constructor(data?: IMiscellaneousLineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.providerId = data['providerId']
      this.provider = data['provider']
        ? IdentifierEntityDto.fromJS(data['provider'])
        : <any>undefined
      this.typeId = data['typeId']
      this.typeText = data['typeText']
      this.description = data['description']
      this.cptCode = data['cptCode']
      this.cost = data['cost']
      this.isCostOverridden = data['isCostOverridden']
      this.costOverriddenBy = data['costOverriddenBy']
      this.costOverriddenByName = data['costOverriddenByName']
      this.costOverriddenOn = data['costOverriddenOn']
        ? new Date(data['costOverriddenOn'].toString())
        : <any>undefined
      this.calculationExplanation = data['calculationExplanation']
        ? CalculationExplanationDto.fromJS(data['calculationExplanation'])
        : <any>undefined
      this.inclusions = data['inclusions']
      this.markedDeleted = data['markedDeleted'] ?? false
    }
  }

  static fromJS(data: any): MiscellaneousLineItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new MiscellaneousLineItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['providerId'] = this.providerId
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['typeId'] = this.typeId
    data['typeText'] = this.typeText
    data['description'] = this.description
    data['cptCode'] = this.cptCode
    data['cost'] = this.cost
    data['isCostOverridden'] = this.isCostOverridden
    data['costOverriddenBy'] = this.costOverriddenBy
    data['costOverriddenByName'] = this.costOverriddenByName
    data['costOverriddenOn'] = this.costOverriddenOn
      ? this.costOverriddenOn.toISOString()
      : <any>undefined
    data['calculationExplanation'] = this.calculationExplanation
      ? this.calculationExplanation.toJSON()
      : <any>undefined
    data['inclusions'] = this.inclusions
    data['markedDeleted'] = this.markedDeleted ?? false
    return data
  }
}

export interface IMiscellaneousLineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  provider?: IdentifierEntityDto | undefined
  typeId?: string | undefined
  typeText?: string | undefined
  description?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenByName?: string | undefined
  costOverriddenOn?: Date | undefined
  calculationExplanation?: CalculationExplanationDto | undefined
  inclusions?: string | undefined
  markedDeleted?: boolean | undefined
}

export class ProcedureDto implements IProcedureDto {
  diagnostic?: string | undefined
  isActive?: boolean | undefined
  name?: string | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IProcedureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.diagnostic = data['diagnostic']
      this.isActive = data['isActive']
      this.name = data['name']
      this.legacyId = data['legacyId']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ProcedureDto {
    data = typeof data === 'object' ? data : {}
    let result = new ProcedureDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['diagnostic'] = this.diagnostic
    data['isActive'] = this.isActive
    data['name'] = this.name
    data['legacyId'] = this.legacyId
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IProcedureDto {
  diagnostic?: string | undefined
  isActive?: boolean | undefined
  name?: string | undefined
  legacyId?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class IdentifierEntityDto implements IIdentifierEntityDto {
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IIdentifierEntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.name = data['name']
    }
  }

  static fromJS(data: any): IdentifierEntityDto {
    data = typeof data === 'object' ? data : {}
    let result = new IdentifierEntityDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IIdentifierEntityDto {
  id?: string | undefined
  name?: string | undefined
}

export class ContractAttachmentFileDto implements IContractAttachmentFileDto {
  contract?: ContractDto | undefined
  contractId?: string | undefined
  attachmentFile?: AttachmentFileDto | undefined
  attachmentFileId?: string | undefined

  constructor(data?: IContractAttachmentFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.contract = data['contract']
        ? ContractDto.fromJS(data['contract'])
        : <any>undefined
      this.contractId = data['contractId']
      this.attachmentFile = data['attachmentFile']
        ? AttachmentFileDto.fromJS(data['attachmentFile'])
        : <any>undefined
      this.attachmentFileId = data['attachmentFileId']
    }
  }

  static fromJS(data: any): ContractAttachmentFileDto {
    data = typeof data === 'object' ? data : {}
    let result = new ContractAttachmentFileDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['contract'] = this.contract ? this.contract.toJSON() : <any>undefined
    data['contractId'] = this.contractId
    data['attachmentFile'] = this.attachmentFile
      ? this.attachmentFile.toJSON()
      : <any>undefined
    data['attachmentFileId'] = this.attachmentFileId
    return data
  }
}

export interface IContractAttachmentFileDto {
  contract?: ContractDto | undefined
  contractId?: string | undefined
  attachmentFile?: AttachmentFileDto | undefined
  attachmentFileId?: string | undefined
}

export class CodeDto implements ICodeDto {
  id?: string | undefined
  contractId?: string | undefined
  codeType?: string | undefined
  operationCode?: string | undefined
  rate?: number | undefined

  constructor(data?: ICodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.contractId = data['contractId']
      this.codeType = data['codeType']
      this.operationCode = data['operationCode']
      this.rate = data['rate']
    }
  }

  static fromJS(data: any): CodeDto {
    data = typeof data === 'object' ? data : {}
    let result = new CodeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['contractId'] = this.contractId
    data['codeType'] = this.codeType
    data['operationCode'] = this.operationCode
    data['rate'] = this.rate
    return data
  }
}

export interface ICodeDto {
  id?: string | undefined
  contractId?: string | undefined
  codeType?: string | undefined
  operationCode?: string | undefined
  rate?: number | undefined
}

export class MultipleProcedureDiscountDto implements IMultipleProcedureDiscountDto {
  id?: string | undefined
  contractId?: string | undefined
  procedureNumber?: number | undefined
  costPercentage?: number | undefined

  constructor(data?: IMultipleProcedureDiscountDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.contractId = data['contractId']
      this.procedureNumber = data['procedureNumber']
      this.costPercentage = data['costPercentage']
    }
  }

  static fromJS(data: any): MultipleProcedureDiscountDto {
    data = typeof data === 'object' ? data : {}
    let result = new MultipleProcedureDiscountDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['contractId'] = this.contractId
    data['procedureNumber'] = this.procedureNumber
    data['costPercentage'] = this.costPercentage
    return data
  }
}

export interface IMultipleProcedureDiscountDto {
  id?: string | undefined
  contractId?: string | undefined
  procedureNumber?: number | undefined
  costPercentage?: number | undefined
}

export class LocationProcedureDto implements ILocationProcedureDto {
  name?: string | undefined
  isActive?: boolean | undefined
  locationId?: string | undefined
  procedureId?: string | undefined
  procedure?: ProcedureDto | undefined
  contractPrice?: number | undefined
  tesla?: number | undefined
  weightLimit?: number | undefined
  otherBilling?: string | undefined
  usesSecondProvider?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: ILocationProcedureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.locationId = data['locationId']
      this.procedureId = data['procedureId']
      this.procedure = data['procedure']
        ? ProcedureDto.fromJS(data['procedure'])
        : <any>undefined
      this.contractPrice = data['contractPrice']
      this.tesla = data['tesla']
      this.weightLimit = data['weightLimit']
      this.otherBilling = data['otherBilling']
      this.usesSecondProvider = data['usesSecondProvider']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): LocationProcedureDto {
    data = typeof data === 'object' ? data : {}
    let result = new LocationProcedureDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['locationId'] = this.locationId
    data['procedureId'] = this.procedureId
    data['procedure'] = this.procedure ? this.procedure.toJSON() : <any>undefined
    data['contractPrice'] = this.contractPrice
    data['tesla'] = this.tesla
    data['weightLimit'] = this.weightLimit
    data['otherBilling'] = this.otherBilling
    data['usesSecondProvider'] = this.usesSecondProvider
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ILocationProcedureDto {
  name?: string | undefined
  isActive?: boolean | undefined
  locationId?: string | undefined
  procedureId?: string | undefined
  procedure?: ProcedureDto | undefined
  contractPrice?: number | undefined
  tesla?: number | undefined
  weightLimit?: number | undefined
  otherBilling?: string | undefined
  usesSecondProvider?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class LocationBillingDto implements ILocationBillingDto {
  name?: string | undefined
  isActive?: boolean | undefined
  locationId?: string | undefined
  addressId?: string | undefined
  address?: AddressDto | undefined
  addressLine?: string | undefined
  city?: string | undefined
  state?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: ILocationBillingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.locationId = data['locationId']
      this.addressId = data['addressId']
      this.address = data['address'] ? AddressDto.fromJS(data['address']) : <any>undefined
      this.addressLine = data['addressLine']
      this.city = data['city']
      this.state = data['state']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): LocationBillingDto {
    data = typeof data === 'object' ? data : {}
    let result = new LocationBillingDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['locationId'] = this.locationId
    data['addressId'] = this.addressId
    data['address'] = this.address ? this.address.toJSON() : <any>undefined
    data['addressLine'] = this.addressLine
    data['city'] = this.city
    data['state'] = this.state
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ILocationBillingDto {
  name?: string | undefined
  isActive?: boolean | undefined
  locationId?: string | undefined
  addressId?: string | undefined
  address?: AddressDto | undefined
  addressLine?: string | undefined
  city?: string | undefined
  state?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class PatientPreExistingConditionDto implements IPatientPreExistingConditionDto {
  patientId?: string | undefined
  preExistingConditionId?: string | undefined
  patient?: IdentifierEntityDto | undefined
  preExistingCondition?: IdentifierEntityDto | undefined

  constructor(data?: IPatientPreExistingConditionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.patientId = data['patientId']
      this.preExistingConditionId = data['preExistingConditionId']
      this.patient = data['patient']
        ? IdentifierEntityDto.fromJS(data['patient'])
        : <any>undefined
      this.preExistingCondition = data['preExistingCondition']
        ? IdentifierEntityDto.fromJS(data['preExistingCondition'])
        : <any>undefined
    }
  }

  static fromJS(data: any): PatientPreExistingConditionDto {
    data = typeof data === 'object' ? data : {}
    let result = new PatientPreExistingConditionDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['patientId'] = this.patientId
    data['preExistingConditionId'] = this.preExistingConditionId
    data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined
    data['preExistingCondition'] = this.preExistingCondition
      ? this.preExistingCondition.toJSON()
      : <any>undefined
    return data
  }
}

export interface IPatientPreExistingConditionDto {
  patientId?: string | undefined
  preExistingConditionId?: string | undefined
  patient?: IdentifierEntityDto | undefined
  preExistingCondition?: IdentifierEntityDto | undefined
}

export class CalculationExplanationDto implements ICalculationExplanationDto {
  rate?: number | undefined
  source?: string | undefined
  contractId?: string | undefined
  contractDate?: Date | undefined
  isSingleCaseAgreement?: boolean | undefined
  isMultiProcedureDiscounted?: boolean | undefined
  multiProcedureDiscountPercentage?: number | undefined
  medicarePercentage?: number | undefined
  isExcludedFromMultipleProcedureDiscount?: boolean | undefined

  constructor(data?: ICalculationExplanationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.rate = data['rate']
      this.source = data['source']
      this.contractId = data['contractId']
      this.contractDate = data['contractDate']
        ? new Date(data['contractDate'].toString())
        : <any>undefined
      this.isSingleCaseAgreement = data['isSingleCaseAgreement']
      this.isMultiProcedureDiscounted = data['isMultiProcedureDiscounted']
      this.multiProcedureDiscountPercentage = data['multiProcedureDiscountPercentage']
      this.medicarePercentage = data['medicarePercentage']
      this.isExcludedFromMultipleProcedureDiscount =
        data['isExcludedFromMultipleProcedureDiscount']
    }
  }

  static fromJS(data: any): CalculationExplanationDto {
    data = typeof data === 'object' ? data : {}
    let result = new CalculationExplanationDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['rate'] = this.rate
    data['source'] = this.source
    data['contractId'] = this.contractId
    data['contractDate'] = this.contractDate
      ? this.contractDate.toISOString()
      : <any>undefined
    data['isSingleCaseAgreement'] = this.isSingleCaseAgreement
    data['isMultiProcedureDiscounted'] = this.isMultiProcedureDiscounted
    data['multiProcedureDiscountPercentage'] = this.multiProcedureDiscountPercentage
    data['medicarePercentage'] = this.medicarePercentage
    data['isExcludedFromMultipleProcedureDiscount'] =
      this.isExcludedFromMultipleProcedureDiscount
    return data
  }
}

export interface ICalculationExplanationDto {
  rate?: number | undefined
  source?: string | undefined
  contractId?: string | undefined
  contractDate?: Date | undefined
  isSingleCaseAgreement?: boolean | undefined
  isMultiProcedureDiscounted?: boolean | undefined
  multiProcedureDiscountPercentage?: number | undefined
  medicarePercentage?: number | undefined
  isExcludedFromMultipleProcedureDiscount?: boolean | undefined
}

export class ColumnSettingsDto implements IColumnSettingsDto {
  id?: string | undefined
  isActive?: boolean | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isVisible?: boolean | undefined
  fieldName?: string | undefined
  groupOrder?: number | undefined
  columnName?: string | undefined
  sort?: string | undefined
  type?: string | undefined
  applicationUserId?: string | undefined

  constructor(data?: IColumnSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.isActive = data['isActive']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isVisible = data['isVisible']
      this.fieldName = data['fieldName']
      this.groupOrder = data['groupOrder']
      this.columnName = data['columnName']
      this.sort = data['sort']
      this.type = data['type']
      this.applicationUserId = data['applicationUserId']
    }
  }

  static fromJS(data: any): ColumnSettingsDto {
    data = typeof data === 'object' ? data : {}
    let result = new ColumnSettingsDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['isActive'] = this.isActive
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isVisible'] = this.isVisible
    data['fieldName'] = this.fieldName
    data['groupOrder'] = this.groupOrder
    data['columnName'] = this.columnName
    data['sort'] = this.sort
    data['type'] = this.type
    data['applicationUserId'] = this.applicationUserId
    return data
  }
}

export interface IColumnSettingsDto {
  id?: string | undefined
  isActive?: boolean | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isVisible?: boolean | undefined
  fieldName?: string | undefined
  groupOrder?: number | undefined
  columnName?: string | undefined
  sort?: string | undefined
  type?: string | undefined
  applicationUserId?: string | undefined
}

export class CommunicationDto implements ICommunicationDto {
  name?: string | undefined
  isActive?: boolean | undefined
  providerId?: string | undefined
  patientId?: string | undefined
  contact?: string | undefined
  location?: IdentifierEntityDto | undefined
  preCertNumber?: string | undefined
  message?: string | undefined
  displayMessage?: string | undefined
  creator?: IdentifierEntityDto | undefined
  creatorName: string | undefined
  type?: string | undefined
  createdOn?: Date | undefined
  communicationDate?: Date | undefined
  dateOfService?: Date | undefined
  communicationTags?: TagDto[] | undefined
  displayTags?: TagDto[] | undefined
  id?: string | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: ICommunicationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.isActive = data['isActive']
      this.providerId = data['providerId']
      this.patientId = data['patientId']
      this.contact = data['contact']
      this.location = data['location']
        ? IdentifierEntityDto.fromJS(data['location'])
        : <any>undefined
      this.preCertNumber = data['preCertNumber']
      this.message = data['message']
      this.displayMessage = data['displayMessage']
      this.creator = data['creator']
        ? IdentifierEntityDto.fromJS(data['creator'])
        : <any>undefined
      this.creatorName = data['creatorName']
      this.type = data['type']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.communicationDate = data['communicationDate']
        ? new Date(data['communicationDate'].toString())
        : <any>undefined
      this.dateOfService = data['dateOfService']
        ? new Date(data['dateOfService'].toString())
        : <any>undefined
      if (data['communicationTags'] && data['communicationTags'].constructor === Array) {
        this.communicationTags = []
        for (let item of data['communicationTags'])
          this.communicationTags.push(TagDto.fromJS(item))
      }
      if (data['displayTags'] && data['displayTags'].constructor === Array) {
        this.displayTags = []
        for (let item of data['displayTags']) this.displayTags.push(TagDto.fromJS(item))
      }
      this.id = data['id']
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): CommunicationDto {
    data = typeof data === 'object' ? data : {}
    let result = new CommunicationDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['providerId'] = this.providerId
    data['patientId'] = this.patientId
    data['contact'] = this.contact
    data['location'] = this.location ? this.location.toJSON() : <any>undefined
    data['preCertNumber'] = this.preCertNumber
    data['message'] = this.message
    data['displayMessage'] = this.displayMessage
    data['creator'] = this.creator ? this.creator.toJSON() : <any>undefined
    data['creatorName'] = this.creatorName
    data['type'] = this.type
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['communicationDate'] = this.communicationDate
      ? this.communicationDate.toISOString()
      : <any>undefined
    data['dateOfService'] = this.dateOfService
      ? this.dateOfService.toISOString()
      : <any>undefined
    if (this.communicationTags && this.communicationTags.constructor === Array) {
      data['communicationTags'] = []
      for (let item of this.communicationTags)
        data['communicationTags'].push(item.toJSON())
    }
    if (this.displayTags && this.displayTags.constructor === Array) {
      data['displayTags'] = []
      for (let item of this.displayTags) data['displayTags'].push(item.toJSON())
    }
    data['id'] = this.id
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ICommunicationDto {
  name?: string | undefined
  isActive?: boolean | undefined
  providerId?: string | undefined
  patientId?: string | undefined
  contact?: string | undefined
  location?: IdentifierEntityDto | undefined
  preCertNumber?: string | undefined
  message?: string | undefined
  displayMessage?: string | undefined
  creator?: IdentifierEntityDto | undefined
  creatorName?: string | undefined
  type?: string | undefined
  createdOn?: Date | undefined
  communicationDate?: Date | undefined
  dateOfService?: Date | undefined
  communicationTags?: TagDto[] | undefined
  displayTags?: TagDto[] | undefined
  id?: string | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class ComponentDto implements IComponentDto {
  appointmentTasks?: AppointmentTaskDto[] | undefined
  isLocked?: boolean | undefined
  isActive?: boolean | undefined
  organizationId?: string | undefined
  organization?: OrganizationDto | undefined
  organizationName?: string | undefined
  legacyId?: string | undefined
  isSimpleComponent?: boolean | undefined
  isDefaultComponent?: boolean | undefined
  excludeFromBundle?: boolean | undefined
  excludeFromPTCount?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IComponentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data['appointmentTasks'] && data['appointmentTasks'].constructor === Array) {
        this.appointmentTasks = []
        for (let item of data['appointmentTasks'])
          this.appointmentTasks.push(AppointmentTaskDto.fromJS(item))
      }
      this.isLocked = data['isLocked']
      this.isActive = data['isActive']
      this.organizationId = data['organizationId']
      this.organization = data['organization']
        ? OrganizationDto.fromJS(data['organization'])
        : <any>undefined
      this.organizationName = data['organizationName']
      this.legacyId = data['legacyId']
      this.isSimpleComponent = data['isSimpleComponent']
      this.isDefaultComponent = data['isDefaultComponent']
      this.excludeFromBundle = data['excludeFromBundle']
      this.excludeFromPTCount = data['excludeFromPTCount']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ComponentDto {
    data = typeof data === 'object' ? data : {}
    let result = new ComponentDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (this.appointmentTasks && this.appointmentTasks.constructor === Array) {
      data['appointmentTasks'] = []
      for (let item of this.appointmentTasks) data['appointmentTasks'].push(item.toJSON())
    }
    data['isLocked'] = this.isLocked
    data['isActive'] = this.isActive
    data['organizationId'] = this.organizationId
    data['organization'] = this.organization ? this.organization.toJSON() : <any>undefined
    data['organizationName'] = this.organizationName
    data['legacyId'] = this.legacyId
    data['isSimpleComponent'] = this.isSimpleComponent
    data['isDefaultComponent'] = this.isDefaultComponent
    data['excludeFromBundle'] = this.excludeFromBundle
    data['excludeFromPTCount'] = this.excludeFromPTCount
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IComponentDto {
  appointmentTasks?: AppointmentTaskDto[] | undefined
  isLocked?: boolean | undefined
  isActive?: boolean | undefined
  excludeFromBundle?: boolean | undefined
  excludeFromPTCount?: boolean | undefined
  organizationId?: string | undefined
  organization?: OrganizationDto | undefined
  organizationName?: string | undefined
  legacyId?: string | undefined
  isSimpleComponent?: boolean | undefined
  isDefaultComponent?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class OrganizationDto implements IOrganizationDto {
  isActive?: boolean | undefined
  description?: string | undefined
  generalInquiries?: AddressDto | undefined
  billingInquiries?: AddressDto | undefined
  patientDemographicsUserId?: string | undefined
  patientDemographicsUser?: SimpleUserDto | undefined
  globalInvoiceUserId?: string | undefined
  globalInvoiceUser?: SimpleUserDto | undefined
  distributeTestResultsCCId?: string | undefined
  distributeTestResultsCC?: SimpleUserDto | undefined
  distributeTestResultsAdditionalInfoId?: string | undefined
  distributeTestResultsAdditionalInfo?: SimpleUserDto | undefined
  navigationLabel?: string | undefined
  initials?: string | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IOrganizationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.description = data['description']
      this.generalInquiries = data['generalInquiries']
        ? AddressDto.fromJS(data['generalInquiries'])
        : <any>undefined
      this.billingInquiries = data['billingInquiries']
        ? AddressDto.fromJS(data['billingInquiries'])
        : <any>undefined
      this.patientDemographicsUserId = data['patientDemographicsUserId']
      this.patientDemographicsUser = data['patientDemographicsUser']
        ? SimpleUserDto.fromJS(data['patientDemographicsUser'])
        : <any>undefined
      this.globalInvoiceUserId = data['globalInvoiceUserId']
      this.globalInvoiceUser = data['globalInvoiceUser']
        ? SimpleUserDto.fromJS(data['globalInvoiceUser'])
        : <any>undefined
      this.distributeTestResultsCCId = data['distributeTestResultsCCId']
      this.distributeTestResultsCC = data['distributeTestResultsCC']
        ? SimpleUserDto.fromJS(data['distributeTestResultsCC'])
        : <any>undefined
      this.distributeTestResultsAdditionalInfoId =
        data['distributeTestResultsAdditionalInfoId']
      this.distributeTestResultsAdditionalInfo = data[
        'distributeTestResultsAdditionalInfo'
      ]
        ? SimpleUserDto.fromJS(data['distributeTestResultsAdditionalInfo'])
        : <any>undefined
      this.navigationLabel = data['navigationLabel']
      this.initials = data['initials']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): OrganizationDto {
    data = typeof data === 'object' ? data : {}
    let result = new OrganizationDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['description'] = this.description
    data['generalInquiries'] = this.generalInquiries
      ? this.generalInquiries.toJSON()
      : <any>undefined
    data['billingInquiries'] = this.billingInquiries
      ? this.billingInquiries.toJSON()
      : <any>undefined
    data['patientDemographicsUserId'] = this.patientDemographicsUserId
    data['patientDemographicsUser'] = this.patientDemographicsUser
      ? this.patientDemographicsUser.toJSON()
      : <any>undefined
    data['globalInvoiceUserId'] = this.globalInvoiceUserId
    data['globalInvoiceUser'] = this.globalInvoiceUser
      ? this.globalInvoiceUser.toJSON()
      : <any>undefined
    data['distributeTestResultsCCId'] = this.distributeTestResultsCCId
    data['distributeTestResultsCC'] = this.distributeTestResultsCC
      ? this.distributeTestResultsCC.toJSON()
      : <any>undefined
    data['distributeTestResultsAdditionalInfoId'] =
      this.distributeTestResultsAdditionalInfoId
    data['distributeTestResultsAdditionalInfo'] = this.distributeTestResultsAdditionalInfo
      ? this.distributeTestResultsAdditionalInfo.toJSON()
      : <any>undefined
    data['navigationLabel'] = this.navigationLabel
    data['initials'] = this.initials
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IOrganizationDto {
  isActive?: boolean | undefined
  excludeFromPTCount?: boolean | undefined
  organizationId?: string | undefined
  description?: string | undefined
  generalInquiries?: AddressDto | undefined
  billingInquiries?: AddressDto | undefined
  patientDemographicsUserId?: string | undefined
  patientDemographicsUser?: SimpleUserDto | undefined
  globalInvoiceUserId?: string | undefined
  globalInvoiceUser?: SimpleUserDto | undefined
  distributeTestResultsCCId?: string | undefined
  distributeTestResultsCC?: SimpleUserDto | undefined
  distributeTestResultsAdditionalInfoId?: string | undefined
  distributeTestResultsAdditionalInfo?: SimpleUserDto | undefined
  navigationLabel?: string | undefined
  initials?: string | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class SimpleUserDto implements ISimpleUserDto {
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  email?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  directNumber?: string | undefined
  isActive?: boolean | undefined

  constructor(data?: ISimpleUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.email = data['email']
      this.firstName = data['firstName']
      this.lastName = data['lastName']
      this.directNumber = data['directNumber']
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): SimpleUserDto {
    data = typeof data === 'object' ? data : {}
    let result = new SimpleUserDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['email'] = this.email
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    data['directNumber'] = this.directNumber
    data['isActive'] = this.isActive
    return data
  }
}

export interface ISimpleUserDto {
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  email?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  directNumber?: string | undefined
  isActive?: boolean | undefined
}

export class ContactTypeDto implements IContactTypeDto {
  isActive?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IContactTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): ContactTypeDto {
    data = typeof data === 'object' ? data : {}
    let result = new ContactTypeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IContactTypeDto {
  isActive?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class CptCodeDto implements ICptCodeDto {
  code?: string | undefined
  description?: string | undefined
  name?: string | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: ICptCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.code = data['code']
      this.description = data['description']
      this.name = data['name']
      this.isActive = data['isActive']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): CptCodeDto {
    data = typeof data === 'object' ? data : {}
    let result = new CptCodeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['code'] = this.code
    data['description'] = this.description
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface ICptCodeDto {
  code?: string | undefined
  description?: string | undefined
  name?: string | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class DxCodeDto implements IDxCodeDto {
  code?: string | undefined
  description?: string | undefined
  name?: string | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IDxCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.code = data['code']
      this.description = data['description']
      this.name = data['name']
      this.isActive = data['isActive']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): DxCodeDto {
    data = typeof data === 'object' ? data : {}
    let result = new DxCodeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['code'] = this.code
    data['description'] = this.description
    data['name'] = this.name
    data['isActive'] = this.isActive
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IDxCodeDto {
  code?: string | undefined
  description?: string | undefined
  name?: string | undefined
  isActive?: boolean | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class File implements IFile {
  name?: string | undefined
  fullName?: string | undefined
  folderName?: string | undefined
  directory?: IDirectory | undefined
  extension?: string | undefined
  exists?: boolean | undefined
  additionalAttributes?: FileInfo | undefined

  constructor(data?: IFile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.fullName = data['fullName']
      this.folderName = data['folderName']
      this.directory = data['directory']
        ? IDirectory.fromJS(data['directory'])
        : <any>undefined
      this.extension = data['extension']
      this.exists = data['exists']
      this.additionalAttributes = data['additionalAttributes']
        ? FileInfo.fromJS(data['additionalAttributes'])
        : <any>undefined
    }
  }

  static fromJS(data: any): File {
    data = typeof data === 'object' ? data : {}
    let result = new File()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['fullName'] = this.fullName
    data['folderName'] = this.folderName
    data['directory'] = this.directory ? this.directory.toJSON() : <any>undefined
    data['extension'] = this.extension
    data['exists'] = this.exists
    data['additionalAttributes'] = this.additionalAttributes
      ? this.additionalAttributes.toJSON()
      : <any>undefined
    return data
  }
}

export interface IFile {
  name?: string | undefined
  fullName?: string | undefined
  folderName?: string | undefined
  directory?: IDirectory | undefined
  extension?: string | undefined
  exists?: boolean | undefined
  additionalAttributes?: FileInfo | undefined
}

export class IDirectory implements IIDirectory {
  name?: string | undefined
  fullName?: string | undefined
  exists?: boolean | undefined
  subDirectories?: IDirectory[] | undefined
  subDirectoriesRecursive?: IDirectory[] | undefined
  files?: IFile[] | undefined
  filesRecursive?: IFile[] | undefined

  constructor(data?: IIDirectory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.fullName = data['fullName']
      this.exists = data['exists']
      if (data['subDirectories'] && data['subDirectories'].constructor === Array) {
        this.subDirectories = []
        for (let item of data['subDirectories'])
          this.subDirectories.push(IDirectory.fromJS(item))
      }
      if (
        data['subDirectoriesRecursive'] &&
        data['subDirectoriesRecursive'].constructor === Array
      ) {
        this.subDirectoriesRecursive = []
        for (let item of data['subDirectoriesRecursive'])
          this.subDirectoriesRecursive.push(IDirectory.fromJS(item))
      }
      if (data['files'] && data['files'].constructor === Array) {
        this.files = []
        for (let item of data['files']) this.files.push(IFile.fromJS(item))
      }
      if (data['filesRecursive'] && data['filesRecursive'].constructor === Array) {
        this.filesRecursive = []
        for (let item of data['filesRecursive'])
          this.filesRecursive.push(IFile.fromJS(item))
      }
    }
  }

  static fromJS(data: any): IDirectory {
    data = typeof data === 'object' ? data : {}
    let result = new IDirectory()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['fullName'] = this.fullName
    data['exists'] = this.exists
    if (this.subDirectories && this.subDirectories.constructor === Array) {
      data['subDirectories'] = []
      for (let item of this.subDirectories) data['subDirectories'].push(item.toJSON())
    }
    if (
      this.subDirectoriesRecursive &&
      this.subDirectoriesRecursive.constructor === Array
    ) {
      data['subDirectoriesRecursive'] = []
      for (let item of this.subDirectoriesRecursive)
        data['subDirectoriesRecursive'].push(item.toJSON())
    }
    if (this.files && this.files.constructor === Array) {
      data['files'] = []
      for (let item of this.files) data['files'].push(item.toJSON())
    }
    if (this.filesRecursive && this.filesRecursive.constructor === Array) {
      data['filesRecursive'] = []
      for (let item of this.filesRecursive) data['filesRecursive'].push(item.toJSON())
    }
    return data
  }
}

export interface IIDirectory {
  name?: string | undefined
  fullName?: string | undefined
  exists?: boolean | undefined
  subDirectories?: IDirectory[] | undefined
  subDirectoriesRecursive?: IDirectory[] | undefined
  files?: IFile[] | undefined
  filesRecursive?: IFile[] | undefined
}

export class FileInfo implements IFileInfo {
  length?: number | undefined
  directoryName?: string | undefined
  directory?: DirectoryInfo | undefined
  isReadOnly?: boolean | undefined
  fullName?: string | undefined
  extension?: string | undefined
  name?: string | undefined
  exists?: boolean | undefined
  creationTime?: Date | undefined
  creationTimeUtc?: Date | undefined
  lastAccessTime?: Date | undefined
  lastAccessTimeUtc?: Date | undefined
  lastWriteTime?: Date | undefined
  lastWriteTimeUtc?: Date | undefined
  attributes?: FileInfoAttributes | undefined

  constructor(data?: IFileInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.length = data['length']
      this.directoryName = data['directoryName']
      this.directory = data['directory']
        ? DirectoryInfo.fromJS(data['directory'])
        : <any>undefined
      this.isReadOnly = data['isReadOnly']
      this.fullName = data['fullName']
      this.extension = data['extension']
      this.name = data['name']
      this.exists = data['exists']
      this.creationTime = data['creationTime']
        ? new Date(data['creationTime'].toString())
        : <any>undefined
      this.creationTimeUtc = data['creationTimeUtc']
        ? new Date(data['creationTimeUtc'].toString())
        : <any>undefined
      this.lastAccessTime = data['lastAccessTime']
        ? new Date(data['lastAccessTime'].toString())
        : <any>undefined
      this.lastAccessTimeUtc = data['lastAccessTimeUtc']
        ? new Date(data['lastAccessTimeUtc'].toString())
        : <any>undefined
      this.lastWriteTime = data['lastWriteTime']
        ? new Date(data['lastWriteTime'].toString())
        : <any>undefined
      this.lastWriteTimeUtc = data['lastWriteTimeUtc']
        ? new Date(data['lastWriteTimeUtc'].toString())
        : <any>undefined
      this.attributes = data['attributes']
    }
  }

  static fromJS(data: any): FileInfo {
    data = typeof data === 'object' ? data : {}
    let result = new FileInfo()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['length'] = this.length
    data['directoryName'] = this.directoryName
    data['directory'] = this.directory ? this.directory.toJSON() : <any>undefined
    data['isReadOnly'] = this.isReadOnly
    data['fullName'] = this.fullName
    data['extension'] = this.extension
    data['name'] = this.name
    data['exists'] = this.exists
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined
    data['creationTimeUtc'] = this.creationTimeUtc
      ? this.creationTimeUtc.toISOString()
      : <any>undefined
    data['lastAccessTime'] = this.lastAccessTime
      ? this.lastAccessTime.toISOString()
      : <any>undefined
    data['lastAccessTimeUtc'] = this.lastAccessTimeUtc
      ? this.lastAccessTimeUtc.toISOString()
      : <any>undefined
    data['lastWriteTime'] = this.lastWriteTime
      ? this.lastWriteTime.toISOString()
      : <any>undefined
    data['lastWriteTimeUtc'] = this.lastWriteTimeUtc
      ? this.lastWriteTimeUtc.toISOString()
      : <any>undefined
    data['attributes'] = this.attributes
    return data
  }
}

export interface IFileInfo {
  length?: number | undefined
  directoryName?: string | undefined
  directory?: DirectoryInfo | undefined
  isReadOnly?: boolean | undefined
  fullName?: string | undefined
  extension?: string | undefined
  name?: string | undefined
  exists?: boolean | undefined
  creationTime?: Date | undefined
  creationTimeUtc?: Date | undefined
  lastAccessTime?: Date | undefined
  lastAccessTimeUtc?: Date | undefined
  lastWriteTime?: Date | undefined
  lastWriteTimeUtc?: Date | undefined
  attributes?: FileInfoAttributes | undefined
}

export class IFile implements IIFile {
  name?: string | undefined
  fullName?: string | undefined
  folderName?: string | undefined
  directory?: IDirectory | undefined
  extension?: string | undefined
  exists?: boolean | undefined
  additionalAttributes?: FileInfo | undefined

  constructor(data?: IIFile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name']
      this.fullName = data['fullName']
      this.folderName = data['folderName']
      this.directory = data['directory']
        ? IDirectory.fromJS(data['directory'])
        : <any>undefined
      this.extension = data['extension']
      this.exists = data['exists']
      this.additionalAttributes = data['additionalAttributes']
        ? FileInfo.fromJS(data['additionalAttributes'])
        : <any>undefined
    }
  }

  static fromJS(data: any): IFile {
    data = typeof data === 'object' ? data : {}
    let result = new IFile()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['fullName'] = this.fullName
    data['folderName'] = this.folderName
    data['directory'] = this.directory ? this.directory.toJSON() : <any>undefined
    data['extension'] = this.extension
    data['exists'] = this.exists
    data['additionalAttributes'] = this.additionalAttributes
      ? this.additionalAttributes.toJSON()
      : <any>undefined
    return data
  }
}

export interface IIFile {
  name?: string | undefined
  fullName?: string | undefined
  folderName?: string | undefined
  directory?: IDirectory | undefined
  extension?: string | undefined
  exists?: boolean | undefined
  additionalAttributes?: FileInfo | undefined
}

export class DirectoryInfo implements IDirectoryInfo {
  parent?: DirectoryInfo | undefined
  root?: DirectoryInfo | undefined
  fullName?: string | undefined
  extension?: string | undefined
  name?: string | undefined
  exists?: boolean | undefined
  creationTime?: Date | undefined
  creationTimeUtc?: Date | undefined
  lastAccessTime?: Date | undefined
  lastAccessTimeUtc?: Date | undefined
  lastWriteTime?: Date | undefined
  lastWriteTimeUtc?: Date | undefined
  attributes?: DirectoryInfoAttributes | undefined

  constructor(data?: IDirectoryInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.parent = data['parent'] ? DirectoryInfo.fromJS(data['parent']) : <any>undefined
      this.root = data['root'] ? DirectoryInfo.fromJS(data['root']) : <any>undefined
      this.fullName = data['fullName']
      this.extension = data['extension']
      this.name = data['name']
      this.exists = data['exists']
      this.creationTime = data['creationTime']
        ? new Date(data['creationTime'].toString())
        : <any>undefined
      this.creationTimeUtc = data['creationTimeUtc']
        ? new Date(data['creationTimeUtc'].toString())
        : <any>undefined
      this.lastAccessTime = data['lastAccessTime']
        ? new Date(data['lastAccessTime'].toString())
        : <any>undefined
      this.lastAccessTimeUtc = data['lastAccessTimeUtc']
        ? new Date(data['lastAccessTimeUtc'].toString())
        : <any>undefined
      this.lastWriteTime = data['lastWriteTime']
        ? new Date(data['lastWriteTime'].toString())
        : <any>undefined
      this.lastWriteTimeUtc = data['lastWriteTimeUtc']
        ? new Date(data['lastWriteTimeUtc'].toString())
        : <any>undefined
      this.attributes = data['attributes']
    }
  }

  static fromJS(data: any): DirectoryInfo {
    data = typeof data === 'object' ? data : {}
    let result = new DirectoryInfo()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['parent'] = this.parent ? this.parent.toJSON() : <any>undefined
    data['root'] = this.root ? this.root.toJSON() : <any>undefined
    data['fullName'] = this.fullName
    data['extension'] = this.extension
    data['name'] = this.name
    data['exists'] = this.exists
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined
    data['creationTimeUtc'] = this.creationTimeUtc
      ? this.creationTimeUtc.toISOString()
      : <any>undefined
    data['lastAccessTime'] = this.lastAccessTime
      ? this.lastAccessTime.toISOString()
      : <any>undefined
    data['lastAccessTimeUtc'] = this.lastAccessTimeUtc
      ? this.lastAccessTimeUtc.toISOString()
      : <any>undefined
    data['lastWriteTime'] = this.lastWriteTime
      ? this.lastWriteTime.toISOString()
      : <any>undefined
    data['lastWriteTimeUtc'] = this.lastWriteTimeUtc
      ? this.lastWriteTimeUtc.toISOString()
      : <any>undefined
    data['attributes'] = this.attributes
    return data
  }
}

export interface IDirectoryInfo {
  parent?: DirectoryInfo | undefined
  root?: DirectoryInfo | undefined
  fullName?: string | undefined
  extension?: string | undefined
  name?: string | undefined
  exists?: boolean | undefined
  creationTime?: Date | undefined
  creationTimeUtc?: Date | undefined
  lastAccessTime?: Date | undefined
  lastAccessTimeUtc?: Date | undefined
  lastWriteTime?: Date | undefined
  lastWriteTimeUtc?: Date | undefined
  attributes?: DirectoryInfoAttributes | undefined
}

export class LoginDto implements ILoginDto {
  userName?: string | undefined
  email?: string | undefined
  password?: string | undefined
  resetPasswordToken?: string | undefined

  constructor(data?: ILoginDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userName = data['userName']
      this.email = data['email']
      this.password = data['password']
      this.resetPasswordToken = data['resetPasswordToken']
    }
  }

  static fromJS(data: any): LoginDto {
    data = typeof data === 'object' ? data : {}
    let result = new LoginDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['userName'] = this.userName
    data['email'] = this.email
    data['password'] = this.password
    data['resetPasswordToken'] = this.resetPasswordToken
    return data
  }
}

export interface ILoginDto {
  userName?: string | undefined
  email?: string | undefined
  password?: string | undefined
  resetPasswordToken?: string | undefined
}

export class MedicareCostLookupDto implements IMedicareCostLookupDto {
  isActive?: boolean | undefined
  name?: string | undefined
  state?: string | undefined
  locality?: string | undefined
  note?: string | undefined
  procedure?: string | undefined
  mod?: string | undefined
  parAmount?: number | undefined
  parAmountFormatted?: string | undefined
  nonParAmount?: number | undefined
  nonParAmountFormatted?: string | undefined
  limitingCharge?: number | undefined
  limitingChargeFormatted?: string | undefined
  effectiveDate?: Date | undefined
  percentageOfMedicareAmount?: number | undefined
  percentageOfMedicareAmountFormatted?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IMedicareCostLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.name = data['name']
      this.state = data['state']
      this.locality = data['locality']
      this.note = data['note']
      this.procedure = data['procedure']
      this.mod = data['mod']
      this.parAmount = data['parAmount']
      this.parAmountFormatted = data['parAmountFormatted']
      this.nonParAmount = data['nonParAmount']
      this.nonParAmountFormatted = data['nonParAmountFormatted']
      this.limitingCharge = data['limitingCharge']
      this.limitingChargeFormatted = data['limitingChargeFormatted']
      this.effectiveDate = data['effectiveDate']
        ? new Date(data['effectiveDate'].toString())
        : <any>undefined
      this.percentageOfMedicareAmount = data['percentageOfMedicareAmount']
      this.percentageOfMedicareAmountFormatted =
        data['percentageOfMedicareAmountFormatted']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): MedicareCostLookupDto {
    data = typeof data === 'object' ? data : {}
    let result = new MedicareCostLookupDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['name'] = this.name
    data['state'] = this.state
    data['locality'] = this.locality
    data['note'] = this.note
    data['procedure'] = this.procedure
    data['mod'] = this.mod
    data['parAmount'] = this.parAmount
    data['parAmountFormatted'] = this.parAmountFormatted
    data['nonParAmount'] = this.nonParAmount
    data['nonParAmountFormatted'] = this.nonParAmountFormatted
    data['limitingCharge'] = this.limitingCharge
    data['limitingChargeFormatted'] = this.limitingChargeFormatted
    data['effectiveDate'] = this.effectiveDate
      ? this.effectiveDate.toISOString()
      : <any>undefined
    data['percentageOfMedicareAmount'] = this.percentageOfMedicareAmount
    data['percentageOfMedicareAmountFormatted'] = this.percentageOfMedicareAmountFormatted
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IMedicareCostLookupDto {
  isActive?: boolean | undefined
  name?: string | undefined
  state?: string | undefined
  locality?: string | undefined
  note?: string | undefined
  procedure?: string | undefined
  mod?: string | undefined
  parAmount?: number | undefined
  parAmountFormatted?: string | undefined
  nonParAmount?: number | undefined
  nonParAmountFormatted?: string | undefined
  limitingCharge?: number | undefined
  limitingChargeFormatted?: string | undefined
  effectiveDate?: Date | undefined
  percentageOfMedicareAmount?: number | undefined
  percentageOfMedicareAmountFormatted?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class CptCostLookupDto implements ICptCostLookupDto {
  cost?: number | undefined
  cptCode?: string | undefined
  contractId?: string | undefined
  contract?: ContractDto | undefined
  medicareCostLookupId?: string | undefined
  medicareCostLookup?: MedicareCostLookupDto | undefined
  lineItemId?: string | undefined

  constructor(data?: ICptCostLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.cost = data['cost']
      this.cptCode = data['cptCode']
      this.contractId = data['contractId']
      this.contract = data['contract']
        ? ContractDto.fromJS(data['contract'])
        : <any>undefined
      this.medicareCostLookupId = data['medicareCostLookupId']
      this.medicareCostLookup = data['medicareCostLookup']
        ? MedicareCostLookupDto.fromJS(data['medicareCostLookup'])
        : <any>undefined
      this.lineItemId = data['lineItemId']
    }
  }

  static fromJS(data: any): CptCostLookupDto {
    data = typeof data === 'object' ? data : {}
    let result = new CptCostLookupDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['cost'] = this.cost
    data['cptCode'] = this.cptCode
    data['contractId'] = this.contractId
    data['contract'] = this.contract ? this.contract.toJSON() : <any>undefined
    data['medicareCostLookupId'] = this.medicareCostLookupId
    data['medicareCostLookup'] = this.medicareCostLookup
      ? this.medicareCostLookup.toJSON()
      : <any>undefined
    data['lineItemId'] = this.lineItemId
    return data
  }
}

export interface ICptCostLookupDto {
  cost?: number | undefined
  cptCode?: string | undefined
  contractId?: string | undefined
  contract?: ContractDto | undefined
  medicareCostLookupId?: string | undefined
  medicareCostLookup?: MedicareCostLookupDto | undefined
  lineItemId?: string | undefined
}

export class LineItemDto implements ILineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenOn?: Date | undefined
  costOverriddenByName?: string | undefined
  calcExplanation?: CalculationExplanationDto | undefined
  originalCost?: number | undefined
  medicareCostLookupId?: string | undefined
  contractId?: string | undefined
  contract?: number | undefined
  discount?: number | undefined
  discountPercent?: number | undefined
  suggested?: number | undefined

  constructor(data?: ILineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.providerId = data['providerId']
      this.cptCode = data['cptCode']
      this.cost = data['cost']
      this.isCostOverridden = data['isCostOverridden']
      this.costOverriddenBy = data['costOverriddenBy']
      this.costOverriddenOn = data['costOverriddenOn']
        ? new Date(data['costOverriddenOn'].toString())
        : <any>undefined
      this.costOverriddenByName = data['costOverriddenByName']
      this.calcExplanation = data['calcExplanation']
        ? CalculationExplanationDto.fromJS(data['calcExplanation'])
        : <any>undefined
      this.originalCost = data['originalCost']
      this.medicareCostLookupId = data['medicareCostLookupId']
      this.contractId = data['contractId']
      this.contract = data['contract']
      this.discount = data['discount']
      this.discountPercent = data['discountPercent']
      this.suggested = data['suggested']
    }
  }

  static fromJS(data: any): LineItemDto {
    data = typeof data === 'object' ? data : {}
    let result = new LineItemDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['providerId'] = this.providerId
    data['cptCode'] = this.cptCode
    data['cost'] = this.cost
    data['isCostOverridden'] = this.isCostOverridden
    data['costOverriddenBy'] = this.costOverriddenBy
    data['costOverriddenOn'] = this.costOverriddenOn
      ? this.costOverriddenOn.toISOString()
      : <any>undefined
    data['costOverriddenByName'] = this.costOverriddenByName
    data['calcExplanation'] = this.calcExplanation
      ? this.calcExplanation.toJSON()
      : <any>undefined
    data['originalCost'] = this.originalCost
    data['medicareCostLookupId'] = this.medicareCostLookupId
    data['contractId'] = this.contractId
    data['contract'] = this.contract
    data['discount'] = this.discount
    data['discountPercent'] = this.discountPercent
    data['suggested'] = this.suggested
    return data
  }
}

export interface ILineItemDto {
  id?: string | undefined
  providerId?: string | undefined
  cptCode?: string | undefined
  cost?: number | undefined
  isCostOverridden?: boolean | undefined
  costOverriddenBy?: string | undefined
  costOverriddenOn?: Date | undefined
  costOverriddenByName?: string | undefined
  calcExplanation?: CalculationExplanationDto | undefined
  originalCost?: number | undefined
  medicareCostLookupId?: string | undefined
  contractId?: string | undefined
  contract?: number | undefined
  discount?: number | undefined
  discountPercent?: number | undefined
  suggested?: number | undefined
}

export class DiscountsDto implements IDiscountsDto {
  provider?: ProviderDto | undefined
  contract?: ContractDto | undefined
  discounts?: MultipleProcedureDiscountDto[] | undefined
  discountedLineItems?: LineItemDto[] | undefined

  constructor(data?: IDiscountsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.provider = data['provider']
        ? ProviderDto.fromJS(data['provider'])
        : <any>undefined
      this.contract = data['contract']
        ? ContractDto.fromJS(data['contract'])
        : <any>undefined
      if (data['discounts'] && data['discounts'].constructor === Array) {
        this.discounts = []
        for (let item of data['discounts'])
          this.discounts.push(MultipleProcedureDiscountDto.fromJS(item))
      }
      if (
        data['discountedLineItems'] &&
        data['discountedLineItems'].constructor === Array
      ) {
        this.discountedLineItems = []
        for (let item of data['discountedLineItems'])
          this.discountedLineItems.push(LineItemDto.fromJS(item))
      }
    }
  }

  static fromJS(data: any): DiscountsDto {
    data = typeof data === 'object' ? data : {}
    let result = new DiscountsDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined
    data['contract'] = this.contract ? this.contract.toJSON() : <any>undefined
    if (this.discounts && this.discounts.constructor === Array) {
      data['discounts'] = []
      for (let item of this.discounts) data['discounts'].push(item.toJSON())
    }
    if (this.discountedLineItems && this.discountedLineItems.constructor === Array) {
      data['discountedLineItems'] = []
      for (let item of this.discountedLineItems)
        data['discountedLineItems'].push(item.toJSON())
    }
    return data
  }
}

export interface IDiscountsDto {
  provider?: ProviderDto | undefined
  contract?: ContractDto | undefined
  discounts?: MultipleProcedureDiscountDto[] | undefined
  discountedLineItems?: LineItemDto[] | undefined
}

export class MultipleProcedureDiscountExclusionCodeDto implements IMultipleProcedureDiscountExclusionCodeDto {
  code?: string | undefined
  isActive?: boolean | undefined
  name?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IMultipleProcedureDiscountExclusionCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.code = data['code']
      this.isActive = data['isActive']
      this.name = data['name']
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): MultipleProcedureDiscountExclusionCodeDto {
    data = typeof data === 'object' ? data : {}
    let result = new MultipleProcedureDiscountExclusionCodeDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['code'] = this.code
    data['isActive'] = this.isActive
    data['name'] = this.name
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IMultipleProcedureDiscountExclusionCodeDto {
  code?: string | undefined
  isActive?: boolean | undefined
  name?: string | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class PasswordRuleSettings implements IPasswordRuleSettings {
  requiredLength?: number | undefined
  requireDigit?: boolean | undefined
  requireLowercase?: boolean | undefined
  requireUppercase?: boolean | undefined
  requireNonAlphanumeric?: boolean | undefined
  passwordLifespanInDays?: string | undefined

  constructor(data?: IPasswordRuleSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.requiredLength = data['requiredLength']
      this.requireDigit = data['requireDigit']
      this.requireLowercase = data['requireLowercase']
      this.requireUppercase = data['requireUppercase']
      this.requireNonAlphanumeric = data['requireNonAlphanumeric']
      this.passwordLifespanInDays = data['passwordLifespanInDays']
    }
  }

  static fromJS(data: any): PasswordRuleSettings {
    data = typeof data === 'object' ? data : {}
    let result = new PasswordRuleSettings()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['requiredLength'] = this.requiredLength
    data['requireDigit'] = this.requireDigit
    data['requireLowercase'] = this.requireLowercase
    data['requireUppercase'] = this.requireUppercase
    data['requireNonAlphanumeric'] = this.requireNonAlphanumeric
    data['passwordLifespanInDays'] = this.passwordLifespanInDays
    return data
  }
}

export interface IPasswordRuleSettings {
  requiredLength?: number | undefined
  requireDigit?: boolean | undefined
  requireLowercase?: boolean | undefined
  requireUppercase?: boolean | undefined
  requireNonAlphanumeric?: boolean | undefined
  passwordLifespanInDays?: string | undefined
}

export class PhysicianDto implements IPhysicianDto {
  npi?: string | undefined
  isActive?: boolean | undefined
  name?: string | undefined
  locationNames?: string | undefined
  providerId?: string | undefined
  locations?: PhysicianLocationDto[] | undefined
  specialtyName?: string | undefined
  specialty?: SpecialtyDto | undefined
  subSpecialtyName?: string | undefined
  subSpecialty?: SubSpecialtyDto | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  firstName?: string | undefined
  lastName?: string | undefined

  constructor(data?: IPhysicianDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.npi = data['npi']
      this.isActive = data['isActive']
      this.name = data['name']
      this.locationNames = data['locationNames']
      this.providerId = data['providerId']
      if (data['locations'] && data['locations'].constructor === Array) {
        this.locations = []
        for (let item of data['locations'])
          this.locations.push(PhysicianLocationDto.fromJS(item))
      }
      this.specialtyName = data['specialtyName']
      this.specialty = data['specialty']
        ? SpecialtyDto.fromJS(data['specialty'])
        : <any>undefined
      this.subSpecialtyName = data['subSpecialtyName']
      this.subSpecialty = data['subSpecialty']
        ? SubSpecialtyDto.fromJS(data['subSpecialty'])
        : <any>undefined
      this.id = data['id']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.firstName = data['firstName']
      this.lastName = data['lastName']
    }
  }

  static fromJS(data: any): PhysicianDto {
    data = typeof data === 'object' ? data : {}
    let result = new PhysicianDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['npi'] = this.npi
    data['isActive'] = this.isActive
    data['name'] = this.name
    data['locationNames'] = this.locationNames
    data['providerId'] = this.providerId
    if (this.locations && this.locations.constructor === Array) {
      data['locations'] = []
      for (let item of this.locations) data['locations'].push(item.toJSON())
    }
    data['specialtyName'] = this.specialtyName
    data['specialty'] = this.specialty ? this.specialty.toJSON() : <any>undefined
    data['subSpecialtyName'] = this.subSpecialtyName
    data['subSpecialty'] = this.subSpecialty ? this.subSpecialty.toJSON() : <any>undefined
    data['id'] = this.id
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['firstName'] = this.firstName
    data['lastName'] = this.lastName
    return data
  }
}

export interface IPhysicianDto {
  npi?: string | undefined
  isActive?: boolean | undefined
  name?: string | undefined
  locationNames?: string | undefined
  providerId?: string | undefined
  locations?: PhysicianLocationDto[] | undefined
  specialtyName?: string | undefined
  specialty?: SpecialtyDto | undefined
  subSpecialtyName?: string | undefined
  subSpecialty?: SubSpecialtyDto | undefined
  id?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  firstName?: string | undefined
  lastName?: string | undefined
}

export class PhysicianLocationDto implements IPhysicianLocationDto {
  physician?: PhysicianDto | undefined
  physicianId?: string | undefined
  location?: LocationDto | undefined
  locationId?: string | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined

  constructor(data?: IPhysicianLocationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.physician = data['physician']
        ? PhysicianDto.fromJS(data['physician'])
        : <any>undefined
      this.physicianId = data['physicianId']
      this.location = data['location']
        ? LocationDto.fromJS(data['location'])
        : <any>undefined
      this.locationId = data['locationId']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
      this.isActive = data['isActive']
    }
  }

  static fromJS(data: any): PhysicianLocationDto {
    data = typeof data === 'object' ? data : {}
    let result = new PhysicianLocationDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['physician'] = this.physician ? this.physician.toJSON() : <any>undefined
    data['physicianId'] = this.physicianId
    data['location'] = this.location ? this.location.toJSON() : <any>undefined
    data['locationId'] = this.locationId
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    data['isActive'] = this.isActive
    return data
  }
}

export interface IPhysicianLocationDto {
  physician?: PhysicianDto | undefined
  physicianId?: string | undefined
  location?: LocationDto | undefined
  locationId?: string | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
  isActive?: boolean | undefined
}

export class SpecialtyDto implements ISpecialtyDto {
  id?: string | undefined
  name?: string | undefined
  category?: string | undefined

  constructor(data?: ISpecialtyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.name = data['name']
      this.category = data['category']
    }
  }

  static fromJS(data: any): SpecialtyDto {
    data = typeof data === 'object' ? data : {}
    let result = new SpecialtyDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['category'] = this.category
    return data
  }
}

export interface ISpecialtyDto {
  id?: string | undefined
  name?: string | undefined
  category?: string | undefined
}

export class SubSpecialtyDto implements ISubSpecialtyDto {
  id?: string | undefined
  name?: string | undefined
  category?: string | undefined

  constructor(data?: ISubSpecialtyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.name = data['name']
      this.category = data['category']
    }
  }

  static fromJS(data: any): SubSpecialtyDto {
    data = typeof data === 'object' ? data : {}
    let result = new SubSpecialtyDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['category'] = this.category
    return data
  }
}

export interface ISubSpecialtyDto {
  id?: string | undefined
  name?: string | undefined
  category?: string | undefined
}

export class PreExistingConditionDto implements IPreExistingConditionDto {
  isActive?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined

  constructor(data?: IPreExistingConditionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isActive = data['isActive']
      this.id = data['id']
      this.name = data['name']
      this.createdOn = data['createdOn']
        ? new Date(data['createdOn'].toString())
        : <any>undefined
      this.modifiedOn = data['modifiedOn']
        ? new Date(data['modifiedOn'].toString())
        : <any>undefined
      this.deletedOn = data['deletedOn']
        ? new Date(data['deletedOn'].toString())
        : <any>undefined
    }
  }

  static fromJS(data: any): PreExistingConditionDto {
    data = typeof data === 'object' ? data : {}
    let result = new PreExistingConditionDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isActive'] = this.isActive
    data['id'] = this.id
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['modifiedOn'] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined
    return data
  }
}

export interface IPreExistingConditionDto {
  isActive?: boolean | undefined
  id?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  modifiedOn?: Date | undefined
  deletedOn?: Date | undefined
}

export class RoleDto implements IRoleDto {
  id?: string | undefined
  name?: string | undefined
  usersInRole?: number | undefined

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id']
      this.name = data['name']
      this.usersInRole = data['usersInRole']
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === 'object' ? data : {}
    let result = new RoleDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['usersInRole'] = this.usersInRole
    return data
  }
}

export interface IRoleDto {
  id?: string | undefined
  name?: string | undefined
  usersInRole?: number | undefined
}

export class SingleCaseAgreementTextDto implements ISingleCaseAgreementTextDto {
  additionalText?: string | undefined
  reimbursementAmount?: string | undefined

  constructor(data?: ISingleCaseAgreementTextDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.additionalText = data['additionalText']
      this.reimbursementAmount = data['reimbursementAmount']
    }
  }

  static fromJS(data: any): SingleCaseAgreementTextDto {
    data = typeof data === 'object' ? data : {}
    let result = new SingleCaseAgreementTextDto()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['additionalText'] = this.additionalText
    data['reimbursementAmount'] = this.reimbursementAmount
    return data
  }
}

export interface ISingleCaseAgreementTextDto {
  additionalText?: string | undefined
  reimbursementAmount?: string | undefined
}

export enum FileInfoAttributes {
  _1 = 1,
  _2 = 2,
  _4 = 4,
  _16 = 16,
  _32 = 32,
  _64 = 64,
  _128 = 128,
  _256 = 256,
  _512 = 512,
  _1024 = 1024,
  _2048 = 2048,
  _4096 = 4096,
  _8192 = 8192,
  _16384 = 16384,
  _32768 = 32768,
  _131072 = 131072,
}

export enum DirectoryInfoAttributes {
  _1 = 1,
  _2 = 2,
  _4 = 4,
  _16 = 16,
  _32 = 32,
  _64 = 64,
  _128 = 128,
  _256 = 256,
  _512 = 512,
  _1024 = 1024,
  _2048 = 2048,
  _4096 = 4096,
  _8192 = 8192,
  _16384 = 16384,
  _32768 = 32768,
  _131072 = 131072,
}

export class SwaggerResponse<TResult> {
  status: number
  headers: { [key: string]: any }
  result: TResult

  constructor(status: number, headers: { [key: string]: any }, result: TResult) {
    this.status = status
    this.headers = headers
    this.result = result
  }
}

export class SwaggerException extends Error {
  message: string
  status: number
  response: string
  headers: { [key: string]: any }
  result: any

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super()

    this.message = message
    this.status = status
    this.response = response
    this.headers = headers
    this.result = result
  }

  protected isSwaggerException = true

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result
  else throw new SwaggerException(message, status, response, headers, null)
}
